var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmuNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DMU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134,
    height: 109.539,
    viewBox: "0 0 134 109.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #b5979b;\n      }\n\n      .cls-4 {\n        fill: #c17a2d;\n      }\n\n      .cls-5 {\n        fill: #ffb133;\n      }\n\n      .cls-6 {\n        fill: #af6822;\n      }\n\n      .cls-7 {\n        fill: #fa0;\n      }\n\n      .cls-8 {\n        fill: #91541c;\n      }\n\n      .cls-9 {\n        fill: #ffe36c;\n      }\n\n      .cls-10 {\n        fill: #ffce43;\n      }\n\n      .cls-11 {\n        fill: #8e596e;\n      }\n\n      .cls-12 {\n        fill: #f7c22b;\n      }\n\n      .cls-13 {\n        fill: #fcba27;\n      }\n\n      .cls-14 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-16 {\n        fill: #4e2132;\n      }\n\n      .cls-17 {\n        fill: #d89535;\n      }\n\n      .cls-18 {\n        fill: #7a4955;\n      }\n\n      .cls-19 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-21 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-23 {\n        fill: #411928;\n      }\n\n      .cls-24 {\n        fill: #ce99ac;\n      }\n\n      .cls-25 {\n        fill: #683449;\n      }\n\n      .cls-26 {\n        fill: #381020;\n      }\n\n      .cls-27 {\n        fill: #512535;\n      }\n\n      .cls-28 {\n        fill: #603743;\n      }\n\n      .cls-29 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-31 {\n        fill: #331421;\n      }\n\n      .cls-32 {\n        fill: #260a15;\n      }\n\n      .cls-33 {\n        fill: #603542;\n      }\n\n      .cls-34 {\n        fill: #9b6e67;\n      }\n\n      .cls-35 {\n        clip-path: url(#clip-path-10);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-37 {\n        fill: #5e304a;\n      }\n\n      .cls-38 {\n        fill: #7c5050;\n      }\n\n      .cls-39 {\n        clip-path: url(#clip-path-12);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-41 {\n        fill: #5b313f;\n      }\n\n      .cls-42 {\n        clip-path: url(#clip-path-14);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-44 {\n        fill: #a28489;\n      }\n\n      .cls-45 {\n        clip-path: url(#clip-path-16);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-47 {\n        fill: #f4f1e4;\n      }\n\n      .cls-48 {\n        fill: #ddc3ba;\n      }\n\n      .cls-49 {\n        fill: #a97f7f;\n      }\n\n      .cls-50 {\n        clip-path: url(#clip-path-18);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-52 {\n        clip-path: url(#clip-path-20);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-54 {\n        clip-path: url(#clip-path-22);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-56 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-58 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-60 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-62 {\n        clip-path: url(#clip-path-29);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-64 {\n        clip-path: url(#clip-path-31);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-66 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-68 {\n        clip-path: url(#clip-path-35);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-70 {\n        clip-path: url(#clip-path-37);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-39);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-74 {\n        clip-path: url(#clip-path-41);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-76 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-78 {\n        fill: #875761;\n      }\n\n      .cls-79 {\n        fill: #8d5c68;\n      }\n\n      .cls-80 {\n        fill: #9b5f24;\n      }\n\n      .cls-81 {\n        fill: #8d89be;\n      }\n\n      .cls-82 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-84 {\n        fill: #874c0b;\n      }\n\n      .cls-85 {\n        fill: #a36419;\n      }\n\n      .cls-86 {\n        fill: #603642;\n      }\n\n      .cls-87 {\n        fill: #725760;\n      }\n\n      .cls-88 {\n        fill: #efe2cb;\n      }\n\n      .cls-89 {\n        fill: #c1a097;\n      }\n\n      .cls-90 {\n        fill: #a37282;\n      }\n\n      .cls-91 {\n        fill: #dd9f33;\n      }\n\n      .cls-92 {\n        fill: #a0729e;\n      }\n\n      .cls-93 {\n        fill: #cc9acc;\n      }\n\n      .cls-94 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-96 {\n        clip-path: url(#clip-path-48);\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-98 {\n        clip-path: url(#clip-path-50);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-100 {\n        clip-path: url(#clip-path-52);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-102 {\n        clip-path: url(#clip-path-54);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-104 {\n        clip-path: url(#clip-path-56);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-106 {\n        clip-path: url(#clip-path-58);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-108 {\n        clip-path: url(#clip-path-60);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-110 {\n        clip-path: url(#clip-path-62);\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-112 {\n        clip-path: url(#clip-path-64);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-114 {\n        clip-path: url(#clip-path-66);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-116 {\n        clip-path: url(#clip-path-68);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-118 {\n        clip-path: url(#clip-path-69);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-120 {\n        clip-path: url(#clip-path-71);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-122 {\n        clip-path: url(#clip-path-73);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-124 {\n        clip-path: url(#clip-path-75);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-126 {\n        clip-path: url(#clip-path-77);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-128 {\n        clip-path: url(#clip-path-79);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-130 {\n        clip-path: url(#clip-path-81);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-132 {\n        clip-path: url(#clip-path-82);\n      }\n\n      .cls-133 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-134 {\n        fill: #77465a;\n      }\n\n      .cls-135 {\n        fill: #895b68;\n      }\n\n      .cls-136 {\n        fill: #51273b;\n      }\n\n      .cls-137 {\n        fill: #54293d;\n      }\n\n      .cls-138 {\n        fill: #724159;\n      }\n\n      .cls-139 {\n        fill: #a8767e;\n      }\n\n      .cls-140 {\n        fill: #af6b27;\n      }\n\n      .cls-141 {\n        fill: #593054;\n      }\n\n      .cls-142 {\n        fill: #82505e;\n      }\n\n      .cls-143 {\n        fill: #4f2533;\n      }\n\n      .cls-144 {\n        fill: #703a4a;\n      }\n\n      .cls-145 {\n        fill: #ffa543;\n      }\n\n      .cls-146 {\n        fill: #d35a00;\n      }\n\n      .cls-147 {\n        fill: #ff8e00;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27167",
    "data-name": "Rectangle 27167",
    className: "cls-1",
    width: 134,
    height: 109.539
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80649",
    "data-name": "Path 80649",
    className: "cls-1",
    d: "M25.738,20.451a.618.618,0,0,0-.367.29.777.777,0,0,0-.1.346V21.2c0,.055.006.109.012.163a2.282,2.282,0,0,0,.227.749,2.537,2.537,0,0,0,.462.64,1.728,1.728,0,0,0,.372.29l.012.006.059.032.073.033a.758.758,0,0,0,.466.06.62.62,0,0,0,.367-.29.845.845,0,0,0,.1-.456,1.552,1.552,0,0,0-.012-.16,2.236,2.236,0,0,0-.228-.749,2.493,2.493,0,0,0-.462-.642,1.613,1.613,0,0,0-.514-.361.906.906,0,0,0-.337-.076.515.515,0,0,0-.13.016",
    transform: "translate(-25.274 -20.435)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.746,
    y1: 32.761,
    x2: -10.321,
    y2: 32.761,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#582a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80657",
    "data-name": "Path 80657",
    className: "cls-1",
    d: "M9.93,29.644a.632.632,0,0,0-.367.29.784.784,0,0,0-.1.347v.11a1.57,1.57,0,0,0,.013.161A2.246,2.246,0,0,0,9.7,31.3a2.572,2.572,0,0,0,.462.641,1.757,1.757,0,0,0,.372.29l.012.006c.019.011.039.022.059.031a.66.66,0,0,0,.073.033.754.754,0,0,0,.467.061.617.617,0,0,0,.366-.29.846.846,0,0,0,.1-.456,1.59,1.59,0,0,0-.013-.161,2.248,2.248,0,0,0-.227-.749,2.555,2.555,0,0,0-.462-.641A1.6,1.6,0,0,0,10.4,29.7a.888.888,0,0,0-.337-.076.56.56,0,0,0-.13.015",
    transform: "translate(-9.466 -29.629)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.025,
    y1: 29.727,
    x2: -3.6,
    y2: 29.727,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80667",
    "data-name": "Path 80667",
    className: "cls-1",
    d: "M1.14,38.683a.648.648,0,0,0-.156.061.842.842,0,0,0-.31.306,1.263,1.263,0,0,0-.109.785,2.881,2.881,0,0,0,.289.951,3.258,3.258,0,0,0,.586.815,2.056,2.056,0,0,0,.654.458.969.969,0,0,0,.594.078.716.716,0,0,0,.293-.16.817.817,0,0,0,.173-.208,1.1,1.1,0,0,0,.124-.58c0-.068-.008-.136-.016-.2a2.84,2.84,0,0,0-.289-.951,3.2,3.2,0,0,0-.585-.815,2.053,2.053,0,0,0-.655-.459,1.13,1.13,0,0,0-.426-.1.674.674,0,0,0-.166.02",
    transform: "translate(-0.55 -38.663)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.177,
    y1: 21.052,
    x2: 0.155,
    y2: 21.052,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80681",
    "data-name": "Path 80681",
    className: "cls-1",
    d: "M104.665,75.154l.566.539,5.827-3.333-.566-.539q-2.912,1.667-5.827,3.333",
    transform: "translate(-104.665 -71.821)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -14.976,
    y1: 11.323,
    x2: -14.833,
    y2: 11.323,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80691",
    "data-name": "Path 80691",
    className: "cls-1",
    d: "M102.8,77.739a4.185,4.185,0,0,1-2.752.64,4.316,4.316,0,0,0,1.689-.125l.36.75,1.122-.641c-.134-.213-.268-.424-.4-.636l-.016.012",
    transform: "translate(-100.044 -77.727)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -28.864,
    y1: 30.094,
    x2: -28.576,
    y2: 30.094,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80697",
    "data-name": "Path 80697",
    className: "cls-1",
    d: "M97.436,78.281c.216-.125.435-.25.651-.373q-.346-.147-.678-.323c.01.231.018.463.027.7",
    transform: "translate(-97.409 -77.585)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -131.456,
    y1: 55.391,
    x2: -130.106,
    y2: 55.391,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80707",
    "data-name": "Path 80707",
    className: "cls-1",
    d: "M92.575,75.51l.6-.34-.6-.341Z",
    transform: "translate(-92.575 -74.828)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -141.986,
    y1: 60.282,
    x2: -140.453,
    y2: 60.282,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80719",
    "data-name": "Path 80719",
    className: "cls-1",
    d: "M87.74,72.745l.6-.34-.6-.341Z",
    transform: "translate(-87.74 -72.063)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -134.365,
    y1: 63.994,
    x2: -132.833,
    y2: 63.994,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80731",
    "data-name": "Path 80731",
    className: "cls-1",
    d: "M82.9,69.979l.6-.341-.6-.341Z",
    transform: "translate(-82.905 -69.297)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -126.96,
    y1: 67.615,
    x2: -125.428,
    y2: 67.615,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80738",
    "data-name": "Path 80738",
    className: "cls-1",
    d: "M78.071,67.215c.2-.113.4-.227.6-.341l-.6-.339Z",
    transform: "translate(-78.071 -66.534)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -119.925,
    y1: 71.51,
    x2: -118.39,
    y2: 71.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80743",
    "data-name": "Path 80743",
    className: "cls-1",
    d: "M73.236,64.449l.6-.341-.6-.341Z",
    transform: "translate(-73.236 -63.767)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -112.499,
    y1: 75.028,
    x2: -110.964,
    y2: 75.028,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80751",
    "data-name": "Path 80751",
    className: "cls-1",
    d: "M68.4,61.684l.6-.341L68.4,61Z",
    transform: "translate(-68.401 -61.002)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -104.91,
    y1: 78.735,
    x2: -103.374,
    y2: 78.735,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80755",
    "data-name": "Path 80755",
    className: "cls-1",
    d: "M66.806,32.371a6.128,6.128,0,0,0-1.412-.338,4.712,4.712,0,0,1,.5.088,8.53,8.53,0,0,1,2.383.937c0-.221.006-.442.011-.662L73.5,29.411c-.1-.048-.193-.094-.292-.139-.188-.085-.381-.164-.575-.234l-5.828,3.333",
    transform: "translate(-65.394 -29.038)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -7.378,
    y1: 20.642,
    x2: -7.265,
    y2: 20.642,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80760",
    "data-name": "Path 80760",
    className: "cls-1",
    d: "M63.566,58.919l.6-.341-.6-.341Z",
    transform: "translate(-63.566 -58.237)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -97.345,
    y1: 82.442,
    x2: -95.812,
    y2: 82.442,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80761",
    "data-name": "Path 80761",
    className: "cls-1",
    d: "M62.611,32.512l1.242-.2c-.059-.138-.116-.277-.175-.414l-1.068.611",
    transform: "translate(-62.611 -31.901)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -46.105,
    y1: 131.492,
    x2: -45.369,
    y2: 131.492,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80771",
    "data-name": "Path 80771",
    className: "cls-1",
    d: "M58.537,33.157l1.241-.2-.175-.414-1.067.611",
    transform: "translate(-58.537 -32.546)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -43.137,
    y1: 130.527,
    x2: -42.401,
    y2: 130.527,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80773",
    "data-name": "Path 80773",
    className: "cls-1",
    d: "M58.732,56.155l.6-.341-.6-.34Z",
    transform: "translate(-58.732 -55.473)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -90.219,
    y1: 86.261,
    x2: -88.683,
    y2: 86.261,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80777",
    "data-name": "Path 80777",
    className: "cls-1",
    d: "M54.461,33.8l1.242-.2c-.059-.137-.116-.275-.175-.414l-1.068.61",
    transform: "translate(-54.461 -33.191)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -40.104,
    y1: 129.757,
    x2: -39.367,
    y2: 129.757,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80779",
    "data-name": "Path 80779",
    className: "cls-1",
    d: "M53.769,53.087c.168-.1.338-.194.5-.288q-.191-.145-.377-.3c-.042.2-.085.391-.128.588",
    transform: "translate(-53.769 -52.499)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -97.408,
    y1: 104.57,
    x2: -95.597,
    y2: 104.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80784",
    "data-name": "Path 80784",
    className: "cls-1",
    d: "M50.3,34.55a3.231,3.231,0,0,0-.4.195l0,0a3.615,3.615,0,0,0-1.072.944A3.851,3.851,0,0,1,51.1,34.321l.16-.026.231-.038c-.046-.106-.09-.213-.135-.318l-1.064.61",
    transform: "translate(-48.82 -33.94)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -16.696,
    y1: 44.827,
    x2: -16.354,
    y2: 44.827,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80786",
    "data-name": "Path 80786",
    className: "cls-1",
    d: "M47.974,42.948l-.47.27c.187.03.373.059.561.091-.031-.12-.062-.24-.09-.36Z",
    transform: "translate(-47.504 -42.948)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -77.494,
    y1: 194.903,
    x2: -75.863,
    y2: 194.903,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80787",
    "data-name": "Path 80787",
    className: "cls-1",
    d: "M47.276,37.178l.569.5a5.011,5.011,0,0,1,.382-1.041c-.359.206-.592.34-.951.545",
    transform: "translate(-47.276 -36.633)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -45.458,
    y1: 73.027,
    x2: -44.497,
    y2: 73.027,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80804",
    "data-name": "Path 80804",
    className: "cls-1",
    d: "M77.16,46.712a1.514,1.514,0,0,0-.44.5,1.477,1.477,0,0,0-.219.628.64.64,0,0,0,.219.618l4.148,2.373a.64.64,0,0,1-.218-.618,1.733,1.733,0,0,1,.659-1.132.656.656,0,0,1,.65-.122q-2.073-1.186-4.149-2.372a.378.378,0,0,0-.189-.048.872.872,0,0,0-.46.168",
    transform: "translate(-76.498 -46.544)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -12.777,
    y1: 15.606,
    x2: -12.61,
    y2: 15.606,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80853",
    "data-name": "Path 80853",
    className: "cls-1",
    d: "M57.905,57.364a1.755,1.755,0,0,0-.659,1.13.642.642,0,0,0,.22.618l4.148,2.372a.638.638,0,0,1-.219-.617,1.744,1.744,0,0,1,.659-1.131.655.655,0,0,1,.65-.123q-2.073-1.186-4.149-2.372a.376.376,0,0,0-.189-.048.876.876,0,0,0-.46.169",
    transform: "translate(-57.243 -57.195)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -9.562,
    y1: 13.338,
    x2: -9.395,
    y2: 13.338,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80858",
    "data-name": "Path 80858",
    className: "cls-1",
    d: "M75.984,91.507l.566.54,5.827-3.334-.567-.539-5.827,3.333",
    transform: "translate(-75.984 -88.174)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -10.872,
    y1: 7.457,
    x2: -10.729,
    y2: 7.457,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80868",
    "data-name": "Path 80868",
    className: "cls-1",
    d: "M74.114,94.092a4.182,4.182,0,0,1-2.751.64,4.318,4.318,0,0,0,1.689-.125c.119.25.24.5.36.75l1.122-.641-.4-.636c-.006,0-.012.009-.017.012",
    transform: "translate(-71.363 -94.08)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -20.595,
    y1: 18.38,
    x2: -20.307,
    y2: 18.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80874",
    "data-name": "Path 80874",
    className: "cls-1",
    d: "M68.754,94.634l.65-.372q-.346-.148-.676-.324c.009.232.017.463.026.7",
    transform: "translate(-68.728 -93.938)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -93.001,
    y1: 33.903,
    x2: -91.648,
    y2: 33.903,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80884",
    "data-name": "Path 80884",
    className: "cls-1",
    d: "M63.894,91.863l.595-.341-.595-.341Z",
    transform: "translate(-63.894 -91.181)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -98.298,
    y1: 38.281,
    x2: -96.76,
    y2: 38.281,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80896",
    "data-name": "Path 80896",
    className: "cls-1",
    d: "M59.059,89.1l.6-.341-.6-.341Z",
    transform: "translate(-59.059 -88.416)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -90.719,
    y1: 41.987,
    x2: -89.183,
    y2: 41.987,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80908",
    "data-name": "Path 80908",
    className: "cls-1",
    d: "M54.223,86.333c.2-.113.4-.228.6-.34l-.6-.341Z",
    transform: "translate(-54.223 -85.651)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -83.039,
    y1: 45.754,
    x2: -81.506,
    y2: 45.754,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80915",
    "data-name": "Path 80915",
    className: "cls-1",
    d: "M49.389,83.568l.6-.34-.6-.34Z",
    transform: "translate(-49.389 -82.887)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -75.751,
    y1: 49.53,
    x2: -74.217,
    y2: 49.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80920",
    "data-name": "Path 80920",
    className: "cls-1",
    d: "M44.555,80.8l.6-.341-.6-.34Z",
    transform: "translate(-44.555 -80.121)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -68.439,
    y1: 53.177,
    x2: -66.904,
    y2: 53.177,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80928",
    "data-name": "Path 80928",
    className: "cls-1",
    d: "M39.72,78.038l.595-.341-.595-.34Z",
    transform: "translate(-39.72 -77.356)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -61.107,
    y1: 56.888,
    x2: -59.568,
    y2: 56.888,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80932",
    "data-name": "Path 80932",
    className: "cls-1",
    d: "M38.125,48.724a6.179,6.179,0,0,0-1.412-.338c.165.02.33.05.5.088a8.551,8.551,0,0,1,2.383.937q0-.332.01-.662,2.609-1.493,5.217-2.984c-.1-.048-.193-.094-.291-.138-.19-.086-.382-.164-.577-.235l-5.827,3.333",
    transform: "translate(-36.713 -45.391)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -4.143,
    y1: 16.92,
    x2: -4.03,
    y2: 16.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80937",
    "data-name": "Path 80937",
    className: "cls-1",
    d: "M34.884,75.272l.6-.341-.6-.341Z",
    transform: "translate(-34.884 -74.59)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -53.504,
    y1: 60.521,
    x2: -51.971,
    y2: 60.521,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80938",
    "data-name": "Path 80938",
    className: "cls-1",
    d: "M33.93,48.865l1.242-.2c-.059-.138-.116-.276-.176-.414l-1.067.61",
    transform: "translate(-33.93 -48.255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -24.985,
    y1: 107.171,
    x2: -24.249,
    y2: 107.171,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80948",
    "data-name": "Path 80948",
    className: "cls-1",
    d: "M29.856,49.51l1.241-.2-.175-.413c-.357.2-.711.406-1.067.61",
    transform: "translate(-29.856 -48.9)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -22.001,
    y1: 106.203,
    x2: -21.264,
    y2: 106.203,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80950",
    "data-name": "Path 80950",
    className: "cls-1",
    d: "M30.05,72.508l.6-.341-.6-.34Z",
    transform: "translate(-30.05 -71.826)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -46.09,
    y1: 64.311,
    x2: -44.556,
    y2: 64.311,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80954",
    "data-name": "Path 80954",
    className: "cls-1",
    d: "M25.779,50.154l1.243-.2c-.059-.137-.116-.276-.176-.414q-.534.306-1.068.61",
    transform: "translate(-25.779 -49.544)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -18.969,
    y1: 105.238,
    x2: -18.233,
    y2: 105.238,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80956",
    "data-name": "Path 80956",
    className: "cls-1",
    d: "M25.087,69.44l.5-.288c-.126-.1-.252-.2-.376-.3-.043.2-.085.392-.129.588",
    transform: "translate(-25.087 -68.852)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -45.449,
    y1: 79.138,
    x2: -43.638,
    y2: 79.138,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80961",
    "data-name": "Path 80961",
    className: "cls-1",
    d: "M21.614,50.9a3.422,3.422,0,0,0-.4.195l0,0a3.626,3.626,0,0,0-1.073.943,3.854,3.854,0,0,1,2.286-1.369l.16-.027.23-.037c-.045-.107-.09-.214-.134-.319l-1.065.61",
    transform: "translate(-20.137 -50.293)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -6.885,
    y1: 36.283,
    x2: -6.543,
    y2: 36.283,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80963",
    "data-name": "Path 80963",
    className: "cls-1",
    d: "M19.292,59.3l-.47.269c.187.03.373.059.561.09-.032-.118-.061-.239-.09-.359Z",
    transform: "translate(-18.822 -59.302)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -30.704,
    y1: 154.176,
    x2: -29.073,
    y2: 154.176,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80964",
    "data-name": "Path 80964",
    className: "cls-1",
    d: "M18.595,53.531l.568.5a4.986,4.986,0,0,1,.383-1.04l-.951.544",
    transform: "translate(-18.595 -52.987)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -17.879,
    y1: 58.708,
    x2: -16.918,
    y2: 58.708,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73810",
    "data-name": "Group 73810",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73809",
    "data-name": "Group 73809",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80629",
    "data-name": "Path 80629",
    className: "cls-3",
    d: "M36.084,22.654a7.223,7.223,0,0,0-.8-1.659,6.5,6.5,0,0,0-.619-.836,2.049,2.049,0,0,1,.551.413,3.315,3.315,0,0,1,.757,1.248,2.208,2.208,0,0,1,.111.835",
    transform: "translate(-2.953 -1.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80630",
    "data-name": "Path 80630",
    className: "cls-4",
    d: "M20.91,28.787a5.367,5.367,0,0,1,1.017,2.98c-.006.141-.029.423-.049.562-.039.277-.2,1.1-.2,1.1-.149.8-.33,1.627-.542,2.464q-.262,1.033-.585,2.1l-1.1,3.615c-.028.093-.054.192-.074.293s-.04.2-.053.307-.024.212-.03.321-.009.22-.007.332.008.226.016.34.023.23.039.345c.014.093.029.186.048.278l.6,3.041-1.2-2.694c-.037-.082-.07-.164-.1-.245-.041-.1-.078-.2-.112-.3s-.063-.2-.09-.3-.05-.194-.069-.289-.036-.187-.047-.278-.019-.178-.023-.264,0-.169,0-.25l.146-3.071a31.288,31.288,0,0,1,.506-4.2l.2-1.1c.009-.047.016-.092.023-.139.013-.093.02-.188.024-.282,0-.047,0-.094,0-.141a5.24,5.24,0,0,0-.708-2.5,6.49,6.49,0,0,0-1.364-1.7,2.978,2.978,0,0,0-1.528-.82,1.815,1.815,0,0,0-1.056.154l0-.008,2.682-1.534a2.059,2.059,0,0,1,1.86.15,4.548,4.548,0,0,1,1.783,1.745",
    transform: "translate(-1.242 -2.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80631",
    "data-name": "Path 80631",
    className: "cls-5",
    d: "M18.709,44.311l1.2,2.694-1.368-1.316c-.057-.053-.113-.111-.169-.166l-.165-.175-.161-.18c-.079-.092-.158-.188-.234-.283s-.149-.194-.22-.293-.141-.2-.207-.3-.132-.2-.193-.307-.119-.206-.175-.308-.107-.207-.156-.311-.1-.206-.138-.309-.079-.194-.113-.291l-1.424-3.983a4.992,4.992,0,0,1-.158-.521l-.251-1.029c-.177-.725-.334-1.469-.468-2.226-.161-.9-.292-1.822-.392-2.76a18.893,18.893,0,0,1-.175-2.375,1.831,1.831,0,0,1,.567-1.158,1.184,1.184,0,0,1,.208-.134,1.807,1.807,0,0,1,1.056-.155,2.978,2.978,0,0,1,1.528.82,6.513,6.513,0,0,1,1.364,1.7,5.234,5.234,0,0,1,.708,2.5c0,.047,0,.094,0,.142,0,.094-.012.188-.024.281-.006.047-.015.093-.023.14l-.2,1.1a31.284,31.284,0,0,0-.506,4.205l-.146,3.07c0,.081,0,.165,0,.25s.011.176.023.265.027.184.046.278.042.191.07.289.057.2.09.3.07.2.111.3c.034.081.068.163.1.245",
    transform: "translate(-1.169 -2.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80632",
    "data-name": "Path 80632",
    className: "cls-6",
    d: "M22.275,31.888l-2.69,1.528a3.973,3.973,0,0,0-.146-1.034,5.373,5.373,0,0,0-.457-1.208,1.937,1.937,0,0,0-.1-.192,6.182,6.182,0,0,0-.421-.659L21.131,28.8a1.96,1.96,0,0,1,.119.174c.137.21.265.439.393.668a5.876,5.876,0,0,1,.485,1.2,3.44,3.44,0,0,1,.146,1.052",
    transform: "translate(-1.572 -2.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80633",
    "data-name": "Path 80633",
    className: "cls-4",
    d: "M34.766,20.881a5.367,5.367,0,0,1,1.017,2.98c-.006.141-.029.423-.049.562-.039.277-.2,1.1-.2,1.1-.149.8-.33,1.627-.542,2.464q-.262,1.033-.585,2.1L33.3,33.7c-.028.093-.054.192-.074.293s-.04.2-.053.307-.024.212-.03.321-.009.22-.006.332.007.225.016.34.023.23.039.345c.014.093.029.186.048.278l.6,3.04-1.2-2.694c-.037-.081-.07-.163-.1-.244-.041-.1-.078-.2-.112-.3s-.063-.2-.09-.3-.05-.194-.069-.289-.036-.187-.047-.278-.019-.178-.023-.264,0-.169,0-.25l.146-3.071a31.148,31.148,0,0,1,.507-4.2l.2-1.1c.008-.047.016-.092.022-.139.013-.093.02-.188.024-.282,0-.047,0-.094,0-.141a5.23,5.23,0,0,0-.708-2.5,6.51,6.51,0,0,0-1.364-1.7,2.983,2.983,0,0,0-1.528-.819,1.815,1.815,0,0,0-1.056.154l0-.008,2.682-1.534a2.059,2.059,0,0,1,1.86.15,4.542,4.542,0,0,1,1.783,1.745",
    transform: "translate(-2.422 -1.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80634",
    "data-name": "Path 80634",
    className: "cls-6",
    d: "M36.115,23.959,33.425,25.5a5.237,5.237,0,0,0-.7-2.433A6.18,6.18,0,0,0,32.3,22.4l2.68-1.528c.037.055.073.119.11.174.128.2.256.412.375.631a5.548,5.548,0,0,1,.494,1.189,3.686,3.686,0,0,1,.156,1.089",
    transform: "translate(-2.751 -1.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80635",
    "data-name": "Path 80635",
    className: "cls-7",
    d: "M32.565,36.4l1.2,2.694L32.4,37.782c-.057-.053-.113-.11-.168-.167s-.111-.116-.166-.175-.108-.12-.161-.18c-.079-.092-.158-.188-.234-.283s-.149-.194-.22-.293-.141-.2-.207-.3-.132-.2-.193-.307-.119-.206-.175-.308-.107-.207-.156-.311-.1-.206-.138-.309-.078-.194-.113-.291l-1.424-3.983a4.991,4.991,0,0,1-.158-.521l-.251-1.029c-.177-.725-.334-1.469-.468-2.226-.161-.9-.292-1.822-.392-2.76a18.893,18.893,0,0,1-.175-2.375,1.833,1.833,0,0,1,.567-1.158,1.184,1.184,0,0,1,.208-.134,1.807,1.807,0,0,1,1.056-.155,2.985,2.985,0,0,1,1.528.82,6.529,6.529,0,0,1,1.364,1.7,5.234,5.234,0,0,1,.708,2.5c0,.047,0,.094,0,.142,0,.094-.012.188-.024.281-.006.047-.015.093-.023.14l-.2,1.1a31.3,31.3,0,0,0-.506,4.205l-.146,3.071c0,.08,0,.164,0,.25s.011.175.023.264.027.184.046.278.042.191.07.289.057.2.09.3.07.2.111.3c.034.081.068.163.1.245",
    transform: "translate(-2.35 -1.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80636",
    "data-name": "Path 80636",
    className: "cls-8",
    d: "M22.177,30.914l-2.69,1.546a5.373,5.373,0,0,0-.457-1.208l2.662-1.537a5.876,5.876,0,0,1,.485,1.2",
    transform: "translate(-1.621 -2.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80637",
    "data-name": "Path 80637",
    className: "cls-8",
    d: "M36.039,22.945,33.687,24.3a5.372,5.372,0,0,0-.457-1.208l2.315-1.336a5.549,5.549,0,0,1,.494,1.189",
    transform: "translate(-2.83 -1.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80638",
    "data-name": "Path 80638",
    className: "cls-9",
    d: "M58.443,36.513l-1.652.946L28.305,21.167q.827-.472,1.652-.946l.483.276,0,0,5.29,3.026Z",
    transform: "translate(-2.411 -1.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80639",
    "data-name": "Path 80639",
    className: "cls-6",
    d: "M57.367,42.677l-1.673.957L27.587,27.561,29.26,26.6l.241.137.36.206,2.762,1.58,2.008,1.148Z",
    transform: "translate(-2.35 -2.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80640",
    "data-name": "Path 80640",
    className: "cls-10",
    d: "M27.319,29.407l-.163-.092q.025-.048.047-.1c.015-.033.028-.068.04-.1s.024-.073.035-.112.016-.067.023-.1l.25-1.249L55.656,43.723v1.89l-22.034-12.6-1.41-.807L28.64,30.163Z",
    transform: "translate(-2.313 -2.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80641",
    "data-name": "Path 80641",
    className: "cls-9",
    d: "M42.58,45.585l-1.652.946L12.442,30.239l1.652-.944.486.277L18.8,31.986l2.724,1.559Z",
    transform: "translate(-1.06 -2.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80642",
    "data-name": "Path 80642",
    className: "cls-4",
    d: "M42.391,52.257l-1.673.957L22.142,42.589l1.661-.951.006-.009Z",
    transform: "translate(-1.886 -3.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80643",
    "data-name": "Path 80643",
    className: "cls-10",
    d: "M21.217,42.172,39.793,52.8v1.89l-20.7-11.839-.978-.559h0l-2.663-1.522h0l-4-2.284-.164-.093c.017-.032.032-.064.048-.1s.028-.069.04-.105.023-.072.033-.111a.928.928,0,0,0,.024-.1l.251-1.25Z",
    transform: "translate(-0.962 -3.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80644",
    "data-name": "Path 80644",
    className: "cls-11",
    d: "M32.155,25.569l-.207.119-.124.07-.065.038-.138.079c-.07.041-.144.083-.22.125l-.285.164-.192.11c-.349.2-.682.391-.885.507h0l-.358-.2.156-.78.112-.553.816-.467.424.243Z",
    transform: "translate(-2.528 -2.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80645",
    "data-name": "Path 80645",
    className: "cls-12",
    d: "M30.754,24.756l-.816.467-.362.207.635-.983Z",
    transform: "translate(-2.519 -2.082)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27166",
    "data-name": "Rectangle 27166",
    className: "cls-10",
    width: 0.003,
    height: 1.92,
    transform: "matrix(0.554, -0.832, 0.832, 0.554, 26.059, 21.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80646",
    "data-name": "Path 80646",
    className: "cls-10",
    d: "M28.42,23.4l1.666.953-.635.984-1.333-.423Z",
    transform: "translate(-2.395 -1.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80647",
    "data-name": "Path 80647",
    className: "cls-10",
    d: "M28.437,23.218v0h0l.113-.559c.007-.037.013-.073.017-.113s.008-.077.009-.118c0-.025,0-.049,0-.076a1.739,1.739,0,0,0-.01-.193c0-.044-.01-.09-.016-.134s-.016-.091-.026-.136-.022-.091-.034-.137-.018-.063-.027-.092-.02-.063-.031-.094-.022-.061-.033-.092-.025-.062-.038-.092-.027-.062-.039-.092a.231.231,0,0,0-.016-.034L56.79,37.547v1.891L35.225,27.1l-2.156-1.233h0l-1.031-.589-1.392-.8-.543-.311,0,0Z",
    transform: "translate(-2.411 -1.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80648",
    "data-name": "Path 80648",
    className: "cls-13",
    d: "M27.79,22.411c0,.026,0,.051,0,.077,0,.051-.007.1-.014.153,0,.026-.009.051-.014.075L26.625,28.4a1.339,1.339,0,0,1-.237.561,1.036,1.036,0,0,1-.3.257,1.014,1.014,0,0,1-.4.134,1.687,1.687,0,0,1-.986-.274l-.023-.037c.694-.42,1.249-.76,1.249-.76a1.179,1.179,0,0,0,.154-.639,2.871,2.871,0,0,0-.509-1.489,2.264,2.264,0,0,0-.89-.871,1.029,1.029,0,0,0-.93-.074l-.98.561h0c0-.068,0-.134.006-.2a1.84,1.84,0,0,1,.072-.4,1.515,1.515,0,0,1,.07-.189L25.078,20.3a.806.806,0,0,1,.36-.409.946.946,0,0,1,.735-.019,1.95,1.95,0,0,1,.975.842,2.975,2.975,0,0,1,.643,1.7",
    transform: "translate(-1.94 -1.687)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73812",
    "data-name": "Group 73812",
    transform: "translate(23.121 18.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73811",
    "data-name": "Group 73811",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27168",
    "data-name": "Rectangle 27168",
    className: "cls-15",
    width: 2.152,
    height: 2.773,
    transform: "translate(0 0)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73814",
    "data-name": "Group 73814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73813",
    "data-name": "Group 73813",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80650",
    "data-name": "Path 80650",
    className: "cls-16",
    d: "M26.491,23.084a.761.761,0,0,0,.467.06.614.614,0,0,0,.366-.29.846.846,0,0,0,.1-.456,1.552,1.552,0,0,0-.013-.16,2.214,2.214,0,0,0-.227-.749,2.537,2.537,0,0,0-.462-.642,1.617,1.617,0,0,0-.515-.361.76.76,0,0,0-.467-.06.62.62,0,0,0-.366.29.778.778,0,0,0-.1.346c0-.013,0-.026,0-.04V21a1.051,1.051,0,0,1,.079-.448.751.751,0,0,1,.293-.338.594.594,0,0,1,.091-.043.809.809,0,0,1,.543.032,1.676,1.676,0,0,1,.606.4,2.918,2.918,0,0,1,.544.736,2.307,2.307,0,0,1,.283,1.053,1.115,1.115,0,0,1-.083.459.741.741,0,0,1-.274.32.573.573,0,0,1-.177.075,1.065,1.065,0,0,1-.725-.18l0,0-.03-.019c.023.011.048.023.072.033",
    transform: "translate(-2.153 -1.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80651",
    "data-name": "Path 80651",
    className: "cls-17",
    d: "M29.734,20.067l-1.652.946c.005.011.011.022.016.034.014.03.027.062.039.092s.026.061.038.092.022.063.033.092.022.063.031.094.018.061.027.092.024.092.034.137.018.091.026.136.012.091.017.134c.006.065.009.131.009.193,0,.027,0,.052,0,.076,0,.041,0,.08-.009.118s-.01.076-.017.113l-.113.559h0l-.3,1.516,1.333.422.363-.207-.268,1.334-.241-.137-1.673.957-.249,1.249c-.008.036-.016.069-.024.1s-.022.075-.034.112-.026.07-.041.1-.03.067-.046.1l.162.092-.851.488,0,0a1.025,1.025,0,0,0,.3-.258,1.331,1.331,0,0,0,.237-.56L28.01,22.6c0-.025.009-.049.014-.076.006-.05.011-.1.014-.153,0-.025,0-.051,0-.076a2.626,2.626,0,0,0-.36-1.254,4.084,4.084,0,0,0-.284-.443,3.415,3.415,0,0,0-.265-.325,1.786,1.786,0,0,0-.713-.492.953.953,0,0,0-.732-.005h0l2.242-1.283a.969.969,0,0,1,.8,0,1.843,1.843,0,0,1,.667.465c.061.064.12.13.175.2a3.809,3.809,0,0,1,.385.564,3,3,0,0,1,.251.585c0,.012.005.025.008.038Z",
    transform: "translate(-2.188 -1.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80652",
    "data-name": "Path 80652",
    className: "cls-11",
    d: "M25.885,28.131a1.173,1.173,0,0,1-.154.638s-.554.341-1.249.761c-.489.3-1.049.633-1.532.918h0c-.22.13-.424.249-.6.349h0v-.005a5.4,5.4,0,0,0-.287-.907,7.744,7.744,0,0,0-.632-1.2l-.019-.029c-.1-.15-.195-.3-.3-.436a4.739,4.739,0,0,0-.667-.739l2.135-1.219c.311-.177.632-.361.98-.562a1.032,1.032,0,0,1,.93.075,1.827,1.827,0,0,1,.408.279,2.389,2.389,0,0,1,.356.405c.044.06.086.124.127.187a3.292,3.292,0,0,1,.461,1.07,1.967,1.967,0,0,1,.047.419",
    transform: "translate(-1.741 -2.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80653",
    "data-name": "Path 80653",
    className: "cls-18",
    d: "M25.776,20.154a.915.915,0,0,1,.831.067,2.026,2.026,0,0,1,.8.779,2.57,2.57,0,0,1,.454,1.33,1.691,1.691,0,0,1-.016.225.875.875,0,0,1-.174.411.579.579,0,0,1-.167.146l-.111.064v0a.744.744,0,0,0,.274-.321,1.093,1.093,0,0,0,.083-.458,2.3,2.3,0,0,0-.282-1.053,2.886,2.886,0,0,0-.544-.736,1.682,1.682,0,0,0-.607-.4.818.818,0,0,0-.542-.032.693.693,0,0,0-.091.043l0,0,.1-.056",
    transform: "translate(-2.187 -1.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80654",
    "data-name": "Path 80654",
    className: "cls-9",
    d: "M14.946,33.95l-.816.467-.362.207.634-.984Z",
    transform: "translate(-1.173 -2.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80655",
    "data-name": "Path 80655",
    className: "cls-10",
    d: "M12.564,32.478l1.713,1.063-.634.984L12.31,34.1Z",
    transform: "translate(-1.048 -2.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80656",
    "data-name": "Path 80656",
    className: "cls-13",
    d: "M11.982,31.606c0,.026,0,.051,0,.077,0,.051-.007.1-.014.153,0,.026-.009.051-.014.075L10.817,37.6a1.339,1.339,0,0,1-.237.561,1.036,1.036,0,0,1-.3.257,1.015,1.015,0,0,1-.4.134,1.687,1.687,0,0,1-.986-.274l-.023-.037c.694-.42,1.249-.761,1.249-.761a1.173,1.173,0,0,0,.154-.638,2.871,2.871,0,0,0-.509-1.489,2.264,2.264,0,0,0-.89-.871,1.029,1.029,0,0,0-.93-.074l-.98.561h0c0-.068,0-.134.006-.2a1.9,1.9,0,0,1,.071-.4,1.615,1.615,0,0,1,.071-.189L9.27,29.5a.806.806,0,0,1,.36-.409.979.979,0,0,1,.732.005,2.026,2.026,0,0,1,.978.817,2.972,2.972,0,0,1,.643,1.7",
    transform: "translate(-0.593 -2.472)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73816",
    "data-name": "Group 73816",
    transform: "translate(8.66 27.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73815",
    "data-name": "Group 73815",
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27170",
    "data-name": "Rectangle 27170",
    className: "cls-20",
    width: 2.152,
    height: 2.773,
    transform: "translate(0 0)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73818",
    "data-name": "Group 73818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73817",
    "data-name": "Group 73817",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80658",
    "data-name": "Path 80658",
    className: "cls-16",
    d: "M10.683,32.278a.754.754,0,0,0,.467.06.618.618,0,0,0,.367-.29.853.853,0,0,0,.1-.456,1.333,1.333,0,0,0-.013-.16,2.214,2.214,0,0,0-.227-.749,2.537,2.537,0,0,0-.462-.642,1.632,1.632,0,0,0-.515-.361.76.76,0,0,0-.467-.06.623.623,0,0,0-.366.29.765.765,0,0,0-.1.346c0-.013,0-.026,0-.04V30.2a1.037,1.037,0,0,1,.078-.448.751.751,0,0,1,.293-.338.594.594,0,0,1,.091-.043.809.809,0,0,1,.543.032,1.687,1.687,0,0,1,.607.4,2.92,2.92,0,0,1,.543.736,2.307,2.307,0,0,1,.283,1.053,1.115,1.115,0,0,1-.083.459.741.741,0,0,1-.274.32.578.578,0,0,1-.177.075,1.067,1.067,0,0,1-.726-.18l0,0-.03-.019c.023.012.048.023.072.033",
    transform: "translate(-0.806 -2.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80659",
    "data-name": "Path 80659",
    className: "cls-4",
    d: "M13.926,29.26l-1.652.946c.005.011.011.022.016.034.014.03.027.062.039.092s.026.061.038.092.022.063.033.092.022.063.031.094.018.061.027.092.024.092.034.137.018.091.026.136.012.09.017.134c.006.065.009.131.009.193,0,.027,0,.052,0,.076,0,.041,0,.08-.009.118s-.01.076-.017.113l-.113.557-.3,1.519,1.333.422L13.8,33.9l-.268,1.334L13.29,35.1l-1.673.957L11.368,37.3c-.008.036-.016.069-.024.1s-.022.075-.034.112-.026.07-.041.1-.03.066-.046.1l.162.092-.851.488,0,0a1.036,1.036,0,0,0,.3-.257,1.339,1.339,0,0,0,.237-.561L12.2,31.79c0-.025.009-.049.014-.076.006-.05.011-.1.014-.152,0-.026,0-.052,0-.077a2.628,2.628,0,0,0-.359-1.252,4.207,4.207,0,0,0-.285-.445,3.659,3.659,0,0,0-.263-.324,1.809,1.809,0,0,0-.714-.493.953.953,0,0,0-.732-.005h0l2.242-1.283a.969.969,0,0,1,.8,0,1.863,1.863,0,0,1,.67.466c.059.064.117.13.172.2a3.832,3.832,0,0,1,.386.565,3.031,3.031,0,0,1,.25.584c0,.012.005.025.008.038Z",
    transform: "translate(-0.841 -2.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80660",
    "data-name": "Path 80660",
    className: "cls-18",
    d: "M9.968,29.348a.915.915,0,0,1,.831.067,2.032,2.032,0,0,1,.8.779,2.57,2.57,0,0,1,.454,1.33,1.691,1.691,0,0,1-.016.225.875.875,0,0,1-.174.411.579.579,0,0,1-.167.146l-.111.064v0a.744.744,0,0,0,.274-.321,1.1,1.1,0,0,0,.083-.458,2.306,2.306,0,0,0-.282-1.054,2.9,2.9,0,0,0-.544-.736,1.689,1.689,0,0,0-.607-.4.818.818,0,0,0-.542-.032.694.694,0,0,0-.091.043l0,0,.1-.056",
    transform: "translate(-0.841 -2.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80661",
    "data-name": "Path 80661",
    className: "cls-6",
    d: "M20.092,39.5l2.83,1.618-.006.009-1.661.95-9.53-5.45,1.673-.957.242.137.36.206.257.147h0l4.06,2.321Z",
    transform: "translate(-0.999 -3.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80662",
    "data-name": "Path 80662",
    className: "cls-11",
    d: "M16.292,34.641h0l-1.908,1.09-.207.119-.013-.006-.348-.2.145-.723.123-.61.816-.467.468.267.915.523Z",
    transform: "translate(-1.177 -2.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80663",
    "data-name": "Path 80663",
    className: "cls-10",
    d: "M12.576,32.295h0l.108-.563c.007-.036.013-.072.017-.111s.007-.078.01-.118,0-.05,0-.076c0-.063,0-.128-.011-.195,0-.044-.009-.089-.016-.134s-.016-.091-.026-.135-.021-.092-.034-.138-.017-.062-.027-.093l-.03-.092c-.011-.03-.022-.062-.034-.093s-.025-.062-.038-.092-.027-.062-.039-.092c-.005-.011-.012-.023-.016-.034L40.928,46.619V48.51L20.762,36.977l-2.032-1.162-2.555-1.462-1.392-.8-.539-.306-.27.048Z",
    transform: "translate(-1.06 -2.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80664",
    "data-name": "Path 80664",
    className: "cls-11",
    d: "M10.2,37.2a1.2,1.2,0,0,1-.144.622A.712.712,0,0,1,9.9,38h0a.431.431,0,0,1-.047.037l-.029.02-1,.577-.226.13h0l0-.016a5.224,5.224,0,0,0-.271-.862,7.715,7.715,0,0,0-.647-1.241c-.007-.009-.013-.02-.019-.029-.1-.15-.2-.3-.3-.437a4.819,4.819,0,0,0-.667-.737l.206-.118c.366-.207.67-.375,1.066-.6a.956.956,0,0,1,.7.044,1.76,1.76,0,0,1,.547.354,2.793,2.793,0,0,1,.356.4c.01.012.018.025.027.038a3.184,3.184,0,0,1,.575,1.262,1.986,1.986,0,0,1,.036.374",
    transform: "translate(-0.569 -2.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80665",
    "data-name": "Path 80665",
    className: "cls-4",
    d: "M8.2,39.565c0,.022,0,.046,0,.069-.005.141-.029.423-.049.562-.039.277-.2,1.1-.2,1.1-.149.8-.33,1.627-.542,2.464q-.262,1.033-.585,2.1l-1.1,3.615c-.028.093-.053.192-.074.293s-.04.2-.053.307-.024.212-.03.321-.008.22-.006.332.007.225.016.34.023.23.04.345c.013.093.029.186.047.278l.6,3.04-1.2-2.694c-.038-.082-.071-.164-.1-.244-.04-.1-.078-.2-.112-.3s-.063-.2-.09-.3-.05-.194-.069-.289-.035-.187-.047-.278-.019-.178-.023-.264,0-.169,0-.25l.146-3.071a31.3,31.3,0,0,1,.507-4.2l.2-1.1c.008-.047.016-.092.023-.139.012-.094.019-.188.023-.282,0-.047,0-.094,0-.141,0-.023,0-.046,0-.068a5.272,5.272,0,0,0-.707-2.437,6.2,6.2,0,0,0-.42-.657,6.571,6.571,0,0,0-.943-1.039,2.983,2.983,0,0,0-1.528-.819A1.809,1.809,0,0,0,.859,36.3l0-.008L3.536,34.76a2.059,2.059,0,0,1,1.86.15,4.35,4.35,0,0,1,1.667,1.567c.04.059.079.117.116.177A5.446,5.446,0,0,1,8.2,39.565",
    transform: "translate(-0.073 -2.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80666",
    "data-name": "Path 80666",
    className: "cls-10",
    d: "M4.978,52.177l1.2,2.694L4.811,53.555c-.057-.053-.113-.111-.169-.167l-.165-.175-.161-.18c-.079-.092-.158-.188-.234-.283s-.149-.194-.22-.293-.141-.2-.207-.3-.132-.2-.193-.307-.119-.206-.175-.308-.107-.207-.156-.311-.1-.206-.138-.309-.078-.194-.113-.291L1.455,46.648a5.15,5.15,0,0,1-.158-.521L1.046,45.1c-.177-.725-.334-1.469-.468-2.226-.161-.9-.292-1.822-.392-2.76a18.893,18.893,0,0,1-.175-2.375,1.833,1.833,0,0,1,.567-1.158,1.185,1.185,0,0,1,.208-.134,1.808,1.808,0,0,1,1.056-.155,2.985,2.985,0,0,1,1.528.82,6.5,6.5,0,0,1,1.364,1.7,5.234,5.234,0,0,1,.708,2.5c0,.047,0,.094,0,.141,0,.1-.012.188-.024.282-.006.048-.015.093-.023.14l-.2,1.1a31.3,31.3,0,0,0-.506,4.205l-.146,3.07c0,.081,0,.166,0,.251s.011.175.023.264.027.184.046.278.042.191.07.289.057.2.09.3.07.2.111.3c.034.081.068.163.1.245",
    transform: "translate(0 -3.089)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73820",
    "data-name": "Group 73820",
    transform: "translate(0.503 35.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73819",
    "data-name": "Group 73819",
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27172",
    "data-name": "Rectangle 27172",
    className: "cls-22",
    width: 2.749,
    height: 3.523,
    transform: "translate(-0.015 0)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73822",
    "data-name": "Group 73822",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73821",
    "data-name": "Group 73821",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80668",
    "data-name": "Path 80668",
    className: "cls-11",
    d: "M4.162,40.678a1.13,1.13,0,0,1-.206.714s-.415.261-.844.509l-.086.05-.011-.013a.817.817,0,0,0,.173-.208,1.1,1.1,0,0,0,.124-.58,1.952,1.952,0,0,0-.016-.2c-.005-.046-.012-.091-.019-.135a2.848,2.848,0,0,0-.27-.815,3.108,3.108,0,0,0-.322-.512,2.861,2.861,0,0,0-.264-.3c-.033-.033-.066-.066-.1-.1a1.915,1.915,0,0,0-.553-.363.952.952,0,0,0-.593-.066.65.65,0,0,0-.156.062L1.01,38.7c.456-.261.333-.18.788-.44l0,0a.779.779,0,0,1,.113-.064.956.956,0,0,1,.7.041,1.735,1.735,0,0,1,.55.354A2.808,2.808,0,0,1,3.522,39c.008.012.018.024.027.037a3.153,3.153,0,0,1,.579,1.278,1.9,1.9,0,0,1,.034.36",
    transform: "translate(-0.086 -3.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80669",
    "data-name": "Path 80669",
    className: "cls-23",
    d: "M17.34,37.631s.134-.275.2-.4.267-.457.272-.457l.458-.1a2.391,2.391,0,0,1,.476-.1c.11.009-.257.475-.257.475l-.374.346-.727.311Z",
    transform: "translate(-1.477 -3.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80670",
    "data-name": "Path 80670",
    className: "cls-9",
    d: "M21.648,39.14,23.7,41.525l-1.666.954-2.054-2.386,1.23-.7Z",
    transform: "translate(-1.702 -3.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80671",
    "data-name": "Path 80671",
    className: "cls-10",
    d: "M19.93,40.183l2.054,2.385-2.617-1.5.317-.5Z",
    transform: "translate(-1.65 -3.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80672",
    "data-name": "Path 80672",
    className: "cls-11",
    d: "M20.986,39.172l-.277.159-.187.106-.546.313-.22.125-.246.385-2.159-2.554c-.049-.06.023-.148.083-.219a2.4,2.4,0,0,1,.21-.226c.04-.038.084-.077.131-.117s.122-.1.186-.146a3.362,3.362,0,0,1,.317-.216l.024-.015c.054-.032.106-.059.166-.088.034-.017.07-.034.113-.052.083-.038.184-.084.235-.025l2.17,2.569",
    transform: "translate(-1.477 -3.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80673",
    "data-name": "Path 80673",
    className: "cls-24",
    d: "M20.8,39.341l-.186.107-2.244-2.655a.261.261,0,0,1,.024-.016c.054-.032.105-.059.166-.088l2.24,2.651",
    transform: "translate(-1.564 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80674",
    "data-name": "Path 80674",
    className: "cls-25",
    d: "M19.977,39.8l-.22.125-.247.385L17.351,37.76c-.049-.06.023-.148.083-.219a2.655,2.655,0,0,1,.21-.226c.041-.038.084-.077.132-.117q1.1,1.3,2.2,2.605",
    transform: "translate(-1.477 -3.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80675",
    "data-name": "Path 80675",
    className: "cls-9",
    d: "M37.532,30.043l2.054,2.385-1.666.953L35.866,31l1.23-.7Z",
    transform: "translate(-3.055 -2.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80676",
    "data-name": "Path 80676",
    className: "cls-10",
    d: "M35.813,31.085l2.054,2.385-2.617-1.5.317-.5Z",
    transform: "translate(-3.002 -2.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80677",
    "data-name": "Path 80677",
    className: "cls-18",
    d: "M110.409,71.763l.178-.618-6.257,2.019-.639,2.194h1.072Z",
    transform: "translate(-8.832 -6.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80678",
    "data-name": "Path 80678",
    className: "cls-26",
    d: "M110.456,66.275a14.117,14.117,0,0,0-.466-1.638l-5.752,2.153-.974,1.219.693,1.949,1.115.545,1.566-.436,1.844-1.37a3.461,3.461,0,0,0,1.123-.687l.48-.465Z",
    transform: "translate(-8.796 -5.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80679",
    "data-name": "Path 80679",
    className: "cls-27",
    d: "M111.209,66.577a11.627,11.627,0,0,1,.259,3.758l-.736.421q-2.546,1.456-5.092,2.912a11.657,11.657,0,0,0-.258-3.759l5.827-3.332",
    transform: "translate(-8.976 -5.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80680",
    "data-name": "Path 80680",
    className: "cls-28",
    d: "M110.583,66.427l.573.137L105.329,69.9l-.573-.137,5.827-3.333",
    transform: "translate(-8.923 -5.658)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73824",
    "data-name": "Group 73824",
    transform: "translate(95.75 65.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73823",
    "data-name": "Group 73823",
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27174",
    "data-name": "Rectangle 27174",
    className: "cls-30",
    width: 6.394,
    height: 3.872,
    transform: "translate(0 0)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73826",
    "data-name": "Group 73826",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73825",
    "data-name": "Group 73825",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80682",
    "data-name": "Path 80682",
    className: "cls-31",
    d: "M105.137,75.743l5.827-3.333a4.545,4.545,0,0,1-1.579,2.239l-5.827,3.332a4.544,4.544,0,0,0,1.578-2.238",
    transform: "translate(-8.821 -6.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80683",
    "data-name": "Path 80683",
    className: "cls-27",
    d: "M110.372,63.991l-.443.253-5.384,3.079a18.961,18.961,0,0,0-2-3.952l5.4-3.089.424-.242a18.885,18.885,0,0,1,2,3.951",
    transform: "translate(-8.734 -5.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80684",
    "data-name": "Path 80684",
    className: "cls-26",
    d: "M107.694,60.052l-5.4,3.089-.373.311a16.266,16.266,0,0,0-2.32-2.781l5.827-3.333c.214.2.421.414.623.63a16.467,16.467,0,0,1,1.134,1.361q.263.354.511.722",
    transform: "translate(-8.483 -4.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80685",
    "data-name": "Path 80685",
    className: "cls-32",
    d: "M105.588,56.723l-.164.564L99.6,60.619c.055-.188.109-.376.164-.564l5.827-3.333",
    transform: "translate(-8.483 -4.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80686",
    "data-name": "Path 80686",
    className: "cls-33",
    d: "M105.339,56.486l-5.827,3.333-2.837-2.543q2.672-1.529,5.344-3.057l.483-.275,2.837,2.543",
    transform: "translate(-8.234 -4.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80687",
    "data-name": "Path 80687",
    className: "cls-23",
    d: "M105.3,70.2a11.655,11.655,0,0,1,.258,3.759c-.195-.139-.539-.373-.734-.512a7.547,7.547,0,0,0-.05-1.585c0-.023-.274-.091-.276-.114A11.979,11.979,0,0,0,104.389,70c.191.046.718.159.908.2",
    transform: "translate(-8.891 -5.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80688",
    "data-name": "Path 80688",
    className: "cls-23",
    d: "M104.474,75.4c.189.179.433.415.621.6a4.548,4.548,0,0,1-1.578,2.238l-.045-.071-.4-.635.009-.007c.119-.085-.029-.495.076-.6.059-.057.262-.01.317-.07a4,4,0,0,0,1-1.454",
    transform: "translate(-8.779 -6.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80689",
    "data-name": "Path 80689",
    className: "cls-23",
    d: "M104.5,67.635l-.647.015a14.9,14.9,0,0,0-.7-1.4c-.028-.06-.105-.2-.135-.256-.015-.03-.027-.068-.043-.1s-.229-.144-.24-.164a12.827,12.827,0,0,0-.759-1.616c.125-.1.392-.328.517-.431a18.939,18.939,0,0,1,2,3.952",
    transform: "translate(-8.686 -5.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80690",
    "data-name": "Path 80690",
    className: "cls-34",
    d: "M94.338,71.843c-.257-.269-.5-.553-.729-.846a12.362,12.362,0,0,1-1.855-3.346l-.093-.263c-.045-.134-.087-.27-.128-.405-.006-.025-.014-.048-.021-.071-.077-.266-.145-.536-.2-.81a7.3,7.3,0,0,1-.07-2.658,3.764,3.764,0,0,1,.423-1.251l.023-.039c.016-.027.03-.054.047-.079s.016-.027.024-.039a2.8,2.8,0,0,1,1.584-1.17,3.874,3.874,0,0,1,2.621.4,8.4,8.4,0,0,1,2.63,2.027,12.53,12.53,0,0,1,2.167,3.343,9.651,9.651,0,0,1,.9,3.876,4.294,4.294,0,0,1-1.023,3,2.985,2.985,0,0,1-2.36.681,5.231,5.231,0,0,1-2.35-.986,10.2,10.2,0,0,1-1.584-1.359m5.772.7a3.688,3.688,0,0,0,.782-2.476,8.221,8.221,0,0,0-.733-3.231,10.575,10.575,0,0,0-1.77-2.807,7.82,7.82,0,0,0-2.147-1.75,3.583,3.583,0,0,0-2.151-.509,2.45,2.45,0,0,0-.338.071h0a2.3,2.3,0,0,0-1.113.7c-.01.011-.02.024-.029.036s-.038.048-.058.072-.018.025-.027.038a2.883,2.883,0,0,0-.509,1.224,6.3,6.3,0,0,0,.093,2.689,10.828,10.828,0,0,0,.415,1.284l.114.274a10.607,10.607,0,0,0,1.644,2.664,8.45,8.45,0,0,0,1.966,1.721,4.123,4.123,0,0,0,1.966.7,2.523,2.523,0,0,0,1.853-.652c.016-.013.028-.028.043-.042",
    transform: "translate(-7.763 -5.176)"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73828",
    "data-name": "Group 73828",
    transform: "translate(91.523 71.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73827",
    "data-name": "Group 73827",
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27176",
    "data-name": "Rectangle 27176",
    className: "cls-36",
    width: 3.171,
    height: 1.277,
    transform: "translate(0 0)"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73830",
    "data-name": "Group 73830",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73829",
    "data-name": "Group 73829",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80692",
    "data-name": "Path 80692",
    className: "cls-37",
    d: "M101.057,70.16a3.69,3.69,0,0,1-.782,2.476l-.042.042,0,0c-.065.018-.133.032-.2.044s-.137.02-.206.026-.142.009-.213.009-.145,0-.22-.006-.148-.013-.223-.023-.153-.025-.229-.041-.156-.035-.233-.057-.158-.047-.236-.073-.16-.058-.239-.09-.162-.068-.242-.105-.162-.079-.242-.121-.16-.088-.241-.135-.16-.1-.24-.15c-.123-.079-.239-.16-.359-.25s-.235-.181-.353-.281-.231-.2-.348-.308-.226-.219-.338-.336-.22-.236-.328-.36-.213-.252-.316-.382-.2-.266-.3-.4-.192-.276-.284-.419-.179-.288-.263-.435c-.038-.068-.078-.135-.114-.2s-.088-.162-.129-.243-.091-.181-.136-.274c-.029-.06-.058-.122-.085-.182-.07-.153-.135-.307-.2-.461s-.119-.311-.171-.465-.1-.311-.146-.465-.084-.309-.118-.461-.066-.306-.091-.456-.046-.3-.061-.446-.027-.294-.032-.435-.006-.279,0-.415.013-.264.027-.394a4.492,4.492,0,0,1,.092-.554,3.462,3.462,0,0,1,.156-.5,2.9,2.9,0,0,1,.217-.441,3.443,3.443,0,0,1,.329-.444h0a2.437,2.437,0,0,1,.339-.072,3.593,3.593,0,0,1,2.15.509,7.813,7.813,0,0,1,2.148,1.751,10.552,10.552,0,0,1,1.769,2.806,8.225,8.225,0,0,1,.733,3.232",
    transform: "translate(-7.929 -5.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80693",
    "data-name": "Path 80693",
    className: "cls-32",
    d: "M100.937,52.553c-.055.187-.109.375-.164.564l-5.827,3.332c.054-.188.109-.375.163-.564l5.827-3.332",
    transform: "translate(-8.087 -4.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80694",
    "data-name": "Path 80694",
    className: "cls-33",
    d: "M100.688,52.316l-5.827,3.332L92.025,53.1l5.344-3.056.482-.275,2.837,2.543",
    transform: "translate(-7.838 -4.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80695",
    "data-name": "Path 80695",
    className: "cls-38",
    d: "M100.134,72.683l0,0a2.523,2.523,0,0,1-1.853.652,4.12,4.12,0,0,1-1.966-.7,8.41,8.41,0,0,1-1.966-1.721,10.567,10.567,0,0,1-1.645-2.664l-.113-.274a10.831,10.831,0,0,1-.416-1.283,6.326,6.326,0,0,1-.093-2.689,2.9,2.9,0,0,1,.51-1.224c.009-.013.018-.025.027-.038s.038-.048.059-.072.018-.025.028-.036a2.3,2.3,0,0,1,1.113-.7,3.508,3.508,0,0,0-.329.444,2.914,2.914,0,0,0-.217.442,3.543,3.543,0,0,0-.156.5,4.447,4.447,0,0,0-.092.553c-.014.13-.022.258-.027.4s0,.273,0,.415.017.289.033.434.037.3.061.446.056.3.091.456.074.307.118.461.093.31.146.464.111.312.172.465.127.309.2.461c.027.061.055.122.084.183.045.091.09.182.136.273s.085.163.129.243.076.135.114.2c.084.147.172.292.263.435s.186.281.284.419.2.271.3.4.207.258.316.383.215.243.328.36.223.228.338.336.229.21.348.309.233.19.353.281.236.171.358.25c.08.053.158.1.24.149s.16.093.241.135.163.084.243.121.161.073.241.106.16.063.239.089.158.052.236.074.156.04.233.056.153.03.229.041.151.018.223.024.147.007.22.006.144,0,.213-.009.139-.016.206-.027a1.84,1.84,0,0,0,.2-.043",
    transform: "translate(-7.835 -5.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80696",
    "data-name": "Path 80696",
    className: "cls-23",
    d: "M99.5,60.129c-.055.187-.109.375-.164.564L96.5,58.149c.053-.188.108-.376.162-.563L99.5,60.129",
    transform: "translate(-8.219 -4.905)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73832",
    "data-name": "Group 73832",
    transform: "translate(89.112 70.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73831",
    "data-name": "Group 73831",
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27178",
    "data-name": "Rectangle 27178",
    className: "cls-40",
    width: 0.678,
    height: 0.696,
    transform: "translate(0 0)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73834",
    "data-name": "Group 73834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73833",
    "data-name": "Group 73833",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80698",
    "data-name": "Path 80698",
    className: "cls-26",
    d: "M97.222,49.983q-2.674,1.527-5.345,3.056c-.054.188-.109.375-.163.563L90.3,52.332,96.123,49Z",
    transform: "translate(-7.691 -4.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80699",
    "data-name": "Path 80699",
    className: "cls-23",
    d: "M97.134,77.309c.009.232.018.583.027.816l-.2-.107-.2-.11-2.58-1.477V75.75c.738.422,1.631.489,2.368.911.138.08.172.308.311.387.106.059.161.2.269.261",
    transform: "translate(-8.022 -6.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80700",
    "data-name": "Path 80700",
    className: "cls-32",
    d: "M96.285,48.382c-.054.188-.109.375-.163.564L90.3,52.278c.055-.188.109-.376.164-.564l5.827-3.333",
    transform: "translate(-7.691 -4.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80701",
    "data-name": "Path 80701",
    className: "cls-33",
    d: "M96.036,48.145,90.21,51.478l-2.837-2.543q2.672-1.529,5.344-3.057L93.2,45.6q1.419,1.271,2.836,2.543",
    transform: "translate(-7.442 -3.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80702",
    "data-name": "Path 80702",
    className: "cls-23",
    d: "M94.846,55.959c-.054.188-.109.376-.163.564l-2.836-2.544q.081-.281.163-.563l2.836,2.543",
    transform: "translate(-7.823 -4.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80703",
    "data-name": "Path 80703",
    className: "cls-26",
    d: "M96.1,57.773l-4.255-3.816L94.684,56.5l5.827-3.332,1.1.984-5.343,3.057c-.054.187-.109.375-.163.563",
    transform: "translate(-7.823 -4.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80704",
    "data-name": "Path 80704",
    className: "cls-41",
    d: "M94.15,58.44l-1.4.8L85.864,55.3l1.521-.87a1.037,1.037,0,0,0,.316-.278,1.622,1.622,0,0,0,.328-.774,2.99,2.99,0,0,0,.03-.4Z",
    transform: "translate(-7.313 -4.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80705",
    "data-name": "Path 80705",
    className: "cls-23",
    d: "M59.812,50.394,88.787,66.965a12.226,12.226,0,0,0,1.272,2q.344.44.729.846c.077.085.155.169.234.252l.008.009a10.652,10.652,0,0,0,2.039,1.672,5.325,5.325,0,0,0,2.652.922,3.58,3.58,0,0,0,1.073-.134l0,.006a3.448,3.448,0,0,1-1.709.242,5.3,5.3,0,0,1-2.083-.737L55.13,50.384a10.529,10.529,0,0,1-3.109-2.84,13.375,13.375,0,0,1-1.981-3.7,9.643,9.643,0,0,1-.57-3.435,4.393,4.393,0,0,1,.809-2.65,3.1,3.1,0,0,1,1.017-.821,3.193,3.193,0,0,0-.926,1.137,5.152,5.152,0,0,0-.469,2.306,9.22,9.22,0,0,0,.264,2.143,9.775,9.775,0,0,0,.825,2.438,12.826,12.826,0,0,0,2.119,3.151q.273.3.568.568l.005.005a8.984,8.984,0,0,0,2.269,1.645,4.329,4.329,0,0,0,2.708.519,2.964,2.964,0,0,0,1.752-1.065l.036-.048c.024-.031.046-.063.069-.1l.033-.049.328.188c-.323.186-.7.4-1.066.61",
    transform: "translate(-4.213 -3.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80706",
    "data-name": "Path 80706",
    className: "cls-23",
    d: "M94.371,59.641a3.1,3.1,0,0,0-1.494.377l.471-.269,1.4-.8,1.052.944a4.406,4.406,0,0,0-1.429-.251",
    transform: "translate(-7.911 -5.021)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73836",
    "data-name": "Group 73836",
    transform: "translate(84.69 68.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73835",
    "data-name": "Group 73835",
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27180",
    "data-name": "Rectangle 27180",
    className: "cls-43",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73838",
    "data-name": "Group 73838",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73837",
    "data-name": "Group 73837",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80708",
    "data-name": "Path 80708",
    className: "cls-26",
    d: "M92.57,45.812,87.227,48.87c-.055.187-.109.375-.164.563l-1.418-1.272,5.827-3.333Z",
    transform: "translate(-7.295 -3.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80709",
    "data-name": "Path 80709",
    className: "cls-23",
    d: "M92.3,74.671v.682l-2.949-1.686v-.682L92.3,74.671",
    transform: "translate(-7.61 -6.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80710",
    "data-name": "Path 80710",
    className: "cls-41",
    d: "M89.75,68.161,60.775,51.59l1.066-.61L89.073,66.555l.092.263a12.266,12.266,0,0,0,.585,1.343",
    transform: "translate(-5.176 -4.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80711",
    "data-name": "Path 80711",
    className: "cls-32",
    d: "M91.635,44.212c-.055.188-.109.375-.164.564l-5.827,3.332c.055-.188.109-.375.164-.564l5.827-3.332",
    transform: "translate(-7.295 -3.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80712",
    "data-name": "Path 80712",
    className: "cls-27",
    d: "M91.386,43.975l-5.827,3.332-2.837-2.543,5.345-3.056.482-.275,2.837,2.543",
    transform: "translate(-7.046 -3.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80713",
    "data-name": "Path 80713",
    className: "cls-44",
    d: "M91.8,61.945l-.024.039c-.016.026-.031.051-.046.079s-.016.027-.023.039c0-.223.006-.445.01-.668,0-.108,0-.216.006-.323.014-.023.028-.044.043-.067.029-.045.059-.088.09-.131.016-.021.032-.043.048-.063a2.9,2.9,0,0,1,.858-.76l.013-.007a3.1,3.1,0,0,1,1.494-.377,4.406,4.406,0,0,1,1.429.251h0L97.867,61.9l.566.507a12.914,12.914,0,0,1,2.6,3.582,12.211,12.211,0,0,1,1.133,3.51,6.441,6.441,0,0,1-.118,2.919,3.428,3.428,0,0,1-1.218,1.821,2.409,2.409,0,0,1-.439.242l0-.006a3.6,3.6,0,0,1-1.072.133,5.332,5.332,0,0,1-2.653-.922,10.682,10.682,0,0,1-2.039-1.671L94.619,72c-.079-.083-.156-.167-.234-.252a10.287,10.287,0,0,0,1.584,1.359,5.23,5.23,0,0,0,2.351.986,2.983,2.983,0,0,0,2.359-.681,4.29,4.29,0,0,0,1.023-3,9.651,9.651,0,0,0-.9-3.876A12.531,12.531,0,0,0,98.635,63.2a8.4,8.4,0,0,0-2.629-2.027,3.877,3.877,0,0,0-2.622-.4,2.8,2.8,0,0,0-1.584,1.17",
    transform: "translate(-7.811 -5.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80714",
    "data-name": "Path 80714",
    className: "cls-44",
    d: "M89.081,59.774c0,.108,0,.215-.006.323,0,.223-.008.445-.011.668l-28.4-16.242c.278-.172.559-.347.837-.521Z",
    transform: "translate(-5.167 -3.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80715",
    "data-name": "Path 80715",
    className: "cls-23",
    d: "M90.2,51.789c-.056.187-.11.375-.164.564l-2.837-2.544c.055-.188.108-.376.163-.563L90.2,51.789",
    transform: "translate(-7.427 -4.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80716",
    "data-name": "Path 80716",
    className: "cls-23",
    d: "M87.772,64.424l-8.108-4.638-9.519-5.443-8.1-4.63,1.019-.584L87.65,63.188h0c0,.081.005.162.01.244s.013.177.02.267.017.183.028.275c.016.147.038.3.062.449",
    transform: "translate(-5.285 -4.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80717",
    "data-name": "Path 80717",
    className: "cls-41",
    d: "M87.745,63.038,63.165,48.979c.017-.091.035-.184.048-.278s.027-.192.039-.29.018-.2.026-.3.011-.2.013-.306c0-.061,0-.122,0-.184v-.265l6.947,3.974,9.519,5.444,8.108,4.637c-.025.124-.045.251-.062.378-.01.081-.02.161-.028.242s-.014.163-.02.245-.008.164-.011.246,0,.166,0,.249,0,.166,0,.252v.016Z",
    transform: "translate(-5.38 -4.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80718",
    "data-name": "Path 80718",
    className: "cls-26",
    d: "M87.92,41.642,82.576,44.7c-.054.188-.109.376-.163.563L81,43.99l5.827-3.333Z",
    transform: "translate(-6.899 -3.463)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73840",
    "data-name": "Group 73840",
    transform: "translate(80.267 65.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73839",
    "data-name": "Group 73839",
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27182",
    "data-name": "Rectangle 27182",
    className: "cls-46",
    width: 0.597,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73842",
    "data-name": "Group 73842",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73841",
    "data-name": "Group 73841",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80720",
    "data-name": "Path 80720",
    className: "cls-23",
    d: "M83.38,48.723l4.342,3.893a2.987,2.987,0,0,1-.03.4,1.618,1.618,0,0,1-.328.774,1.04,1.04,0,0,1-.316.279l-1.521.87-.069-.04a1.369,1.369,0,0,0,.1-.135,1.987,1.987,0,0,0,.264-1.086,4.892,4.892,0,0,0-1.1-2.83A3.278,3.278,0,0,0,83.052,49.5a1.576,1.576,0,0,0-1.154.07h0q.742-.423,1.483-.848",
    transform: "translate(-6.976 -4.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80721",
    "data-name": "Path 80721",
    className: "cls-23",
    d: "M87.465,71.906v.682L84.517,70.9v-.682l2.948,1.686Z",
    transform: "translate(-7.199 -5.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80722",
    "data-name": "Path 80722",
    className: "cls-32",
    d: "M86.984,40.042l-.164.564-5.827,3.333c.054-.188.109-.376.163-.564l5.827-3.333",
    transform: "translate(-6.899 -3.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80723",
    "data-name": "Path 80723",
    className: "cls-27",
    d: "M86.735,39.805l-5.827,3.333-2.836-2.543,5.344-3.057.482-.275,2.837,2.543",
    transform: "translate(-6.65 -3.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80724",
    "data-name": "Path 80724",
    className: "cls-23",
    d: "M85.544,47.618c-.055.188-.109.376-.164.564l-2.835-2.544c.053-.187.108-.375.162-.563l2.837,2.543",
    transform: "translate(-7.031 -3.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80725",
    "data-name": "Path 80725",
    className: "cls-23",
    d: "M68.03,45.866a4.7,4.7,0,0,0,2.09.749l9.334,5.339h0a4.466,4.466,0,0,0,.29.729,4.918,4.918,0,0,0,.892,1.239,3.109,3.109,0,0,0,1,.7,1.717,1.717,0,0,0,.663.147c.136.011.272.02.408.029h.009a1.341,1.341,0,0,0,.4-.026,1.224,1.224,0,0,0,.617-.375l.069.039,6.886,3.937-.471.27-.013.007a2.907,2.907,0,0,0-.858.759c-.016.021-.033.042-.048.064-.03.043-.06.086-.09.131-.015.023-.029.044-.043.067L61.581,43.9l1.019-.583.876-.5,2.617,1.5c.108.119.217.236.33.349a6.335,6.335,0,0,0,1.466,1.129c.046.027.091.049.138.073Z",
    transform: "translate(-5.245 -3.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80726",
    "data-name": "Path 80726",
    className: "cls-47",
    d: "M81.817,50.551l-.015.008a1.084,1.084,0,0,0-.41.4,1.632,1.632,0,0,0-.141,1.02,3.737,3.737,0,0,0,.375,1.239,4.2,4.2,0,0,0,.763,1.058,2.664,2.664,0,0,0,.852.6,1.25,1.25,0,0,0,.77.1,1.036,1.036,0,0,0,.607-.479.8.8,0,0,0,.045-.089,1.5,1.5,0,0,0,.116-.665,2.566,2.566,0,0,0-.021-.265,3.656,3.656,0,0,0-.376-1.239,4.134,4.134,0,0,0-.762-1.058,2.623,2.623,0,0,0-.851-.6,1.66,1.66,0,0,0-.4-.116.967.967,0,0,0-.367.016.823.823,0,0,0-.181.07m-.7.109,0,0a1.208,1.208,0,0,1,.707-.558,1.3,1.3,0,0,1,.7.046c.069.021.135.046.2.072a3.1,3.1,0,0,1,1,.7,4.851,4.851,0,0,1,.892,1.239,4.359,4.359,0,0,1,.441,1.449c.012.1.02.207.023.311a1.641,1.641,0,0,1-.188.882,1.2,1.2,0,0,1-.708.559c-.03.007-.06.014-.091.019a1.128,1.128,0,0,1-.147.012,1.715,1.715,0,0,1-.663-.148,3.121,3.121,0,0,1-1-.7,4.922,4.922,0,0,1-.893-1.239,4.421,4.421,0,0,1-.289-.73,4.3,4.3,0,0,1-.15-.719,1.918,1.918,0,0,1,.165-1.193",
    transform: "translate(-6.893 -4.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80727",
    "data-name": "Path 80727",
    className: "cls-48",
    d: "M84.9,53.779a1.5,1.5,0,0,1-.116.665l-.013-.005-.091-.016c-.03-.006-.061-.014-.091-.023s-.062-.018-.093-.028-.063-.023-.094-.036-.063-.027-.1-.042-.064-.03-.1-.048-.063-.035-.1-.053l-.094-.059c-.048-.03-.093-.063-.142-.1s-.092-.071-.139-.111-.091-.078-.137-.122-.089-.087-.134-.133-.087-.093-.129-.142-.084-.1-.125-.152-.08-.1-.118-.159-.075-.109-.112-.166-.071-.113-.1-.171-.065-.117-.1-.177-.059-.12-.087-.179-.054-.122-.079-.183-.048-.123-.068-.183-.04-.123-.058-.184-.033-.123-.047-.182-.027-.121-.036-.179-.018-.119-.025-.177-.01-.115-.012-.172,0-.109,0-.164,0-.1.01-.156a1.785,1.785,0,0,1,.036-.219,1.386,1.386,0,0,1,.062-.2l0-.026a1.579,1.579,0,0,1,.405.116,2.62,2.62,0,0,1,.851.6,4.138,4.138,0,0,1,.762,1.059,3.677,3.677,0,0,1,.376,1.239,2.566,2.566,0,0,1,.021.265",
    transform: "translate(-7.016 -4.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80728",
    "data-name": "Path 80728",
    className: "cls-49",
    d: "M81.831,50.594l.014-.007a.773.773,0,0,1,.182-.07.945.945,0,0,1,.366-.015l0,.025a1.438,1.438,0,0,0-.062.2,1.637,1.637,0,0,0-.036.218,1.5,1.5,0,0,0-.011.156c0,.054,0,.109,0,.164s.007.115.013.172.015.117.025.176.021.12.036.18.029.122.046.182.038.123.058.184.045.123.069.183.05.123.078.182.057.121.087.18.063.119.1.177.068.115.1.171.074.112.113.166.078.108.118.159.082.1.124.152.085.1.13.142.088.09.133.133.091.082.138.122.091.076.139.111.093.068.141.1l.1.059.1.053c.032.016.064.034.1.048s.064.029.1.042l.1.036.093.028c.03.009.061.016.091.023l.091.016.014.005a.9.9,0,0,1-.046.089,1.029,1.029,0,0,1-.607.478,1.245,1.245,0,0,1-.77-.1,2.644,2.644,0,0,1-.851-.6,4.2,4.2,0,0,1-.763-1.059,3.725,3.725,0,0,1-.376-1.239A1.636,1.636,0,0,1,81.421,51a1.073,1.073,0,0,1,.41-.4",
    transform: "translate(-6.921 -4.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80729",
    "data-name": "Path 80729",
    className: "cls-18",
    d: "M84.633,55.909l-.408-.029a1.1,1.1,0,0,0,.147-.012,1.647,1.647,0,0,0,.261.041",
    transform: "translate(-7.174 -4.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80730",
    "data-name": "Path 80730",
    className: "cls-26",
    d: "M83.269,37.471Q80.6,39,77.926,40.529c-.055.187-.109.375-.164.563L76.344,39.82l5.827-3.333Z",
    transform: "translate(-6.503 -3.108)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73844",
    "data-name": "Group 73844",
    transform: "translate(75.844 63.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73843",
    "data-name": "Group 73843",
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27184",
    "data-name": "Rectangle 27184",
    className: "cls-51",
    width: 0.597,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73846",
    "data-name": "Group 73846",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73845",
    "data-name": "Group 73845",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80732",
    "data-name": "Path 80732",
    className: "cls-41",
    d: "M80.459,49.557l-.193.4,0,0a1.908,1.908,0,0,0-.164,1.192,4.627,4.627,0,0,0,.149.72h0l-9.334-5.339a2.283,2.283,0,0,0,.669-.052,2.049,2.049,0,0,0,.609-.26l0,.005,1.9-1.085A2.03,2.03,0,0,0,74.7,44.6a3.12,3.12,0,0,0,.636-1.5,5.887,5.887,0,0,0,.059-.819c0-.041,0-.081,0-.123,0-.081,0-.163-.01-.244,0-.041,0-.081-.009-.122l7.071,6.339-1.484.848h0c-.023.013-.044.027-.066.04a1.274,1.274,0,0,0-.435.536Z",
    transform: "translate(-6.04 -3.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80733",
    "data-name": "Path 80733",
    className: "cls-23",
    d: "M82.63,69.14v.682q-1.475-.841-2.948-1.685v-.682Z",
    transform: "translate(-6.787 -5.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80734",
    "data-name": "Path 80734",
    className: "cls-32",
    d: "M82.333,35.872c-.054.188-.109.375-.163.564l-5.827,3.332.164-.564,5.827-3.332",
    transform: "translate(-6.502 -3.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80735",
    "data-name": "Path 80735",
    className: "cls-27",
    d: "M78.764,33.367l.484-.276,2.835,2.544-5.827,3.332L73.42,36.424l5.344-3.056",
    transform: "translate(-6.253 -2.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80736",
    "data-name": "Path 80736",
    className: "cls-23",
    d: "M80.893,43.448c-.054.187-.109.375-.162.563l-2.837-2.543c.055-.188.108-.376.163-.563q1.419,1.271,2.836,2.543",
    transform: "translate(-6.635 -3.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80737",
    "data-name": "Path 80737",
    className: "cls-26",
    d: "M78.617,33.3l-5.344,3.056c-.054.188-.108.376-.163.563L71.692,35.65l5.827-3.334Z",
    transform: "translate(-6.106 -2.753)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73848",
    "data-name": "Group 73848",
    transform: "translate(71.421 60.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73847",
    "data-name": "Group 73847",
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27186",
    "data-name": "Rectangle 27186",
    className: "cls-53",
    width: 0.596,
    height: 0.681,
    transform: "translate(0 0)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73850",
    "data-name": "Group 73850",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73849",
    "data-name": "Group 73849",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80739",
    "data-name": "Path 80739",
    className: "cls-32",
    d: "M77.682,31.7c-.055.188-.109.375-.163.564L71.692,35.6h0c.055-.188.11-.375.164-.563L77.682,31.7",
    transform: "translate(-6.106 -2.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80740",
    "data-name": "Path 80740",
    className: "cls-27",
    d: "M77.415,31.476l-5.827,3.333L70.8,34.1l-.038-.035q-.309-.287-.625-.548a12.533,12.533,0,0,0-1.582-1.12l5.218-2.984.609-.349a12.388,12.388,0,0,1,1.58,1.12c.212.175.42.357.627.548l.025.024.006.005.8.714",
    transform: "translate(-5.839 -2.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80741",
    "data-name": "Path 80741",
    className: "cls-23",
    d: "M77.8,66.376v.681q-1.475-.843-2.949-1.685v-.682L77.8,66.375Z",
    transform: "translate(-6.375 -5.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80742",
    "data-name": "Path 80742",
    className: "cls-23",
    d: "M76.243,39.277l-.164.564L73.242,37.3c.055-.187.109-.375.164-.563l2.837,2.543",
    transform: "translate(-6.238 -3.129)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73852",
    "data-name": "Group 73852",
    transform: "translate(66.998 58.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73851",
    "data-name": "Group 73851",
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27188",
    "data-name": "Rectangle 27188",
    className: "cls-55",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73854",
    "data-name": "Group 73854",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73853",
    "data-name": "Group 73853",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80744",
    "data-name": "Path 80744",
    className: "cls-44",
    d: "M70.328,45.917a4.7,4.7,0,0,1-2.09-.749c.1.052.21.1.32.148a2.829,2.829,0,0,0,1.744.228,2.33,2.33,0,0,0,1.371-1.083,3.187,3.187,0,0,0,.364-1.705c-.005-.2-.022-.4-.046-.6a8.393,8.393,0,0,0-.85-2.8,9.437,9.437,0,0,0-1.726-2.4A5.98,5.98,0,0,0,67.489,35.6a2.817,2.817,0,0,0-1.744-.229,2.325,2.325,0,0,0-1.371,1.083,2.934,2.934,0,0,0-.362,1.371c0-.055,0-.11,0-.167a4.507,4.507,0,0,1,.2-1.4,2.721,2.721,0,0,1,.689-1.144,2.17,2.17,0,0,1,.873-.5v0a3.6,3.6,0,0,1,.523.084,6.574,6.574,0,0,1,2.43,1.114,11.33,11.33,0,0,1,1.029.857l1.751,1.571c.12.2.234.4.342.6a9.766,9.766,0,0,1,.921,2.562,6.57,6.57,0,0,1,.141,1.352,4.068,4.068,0,0,1-.3,1.66A2.712,2.712,0,0,1,71.6,45.6a2.041,2.041,0,0,1-.609.261,2.277,2.277,0,0,1-.668.052",
    transform: "translate(-5.452 -2.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80745",
    "data-name": "Path 80745",
    className: "cls-32",
    d: "M72.755,28.97,66.928,32.3c-.036-.244-.071-.488-.109-.733l5.827-3.333q.055.366.109.733",
    transform: "translate(-5.691 -2.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80746",
    "data-name": "Path 80746",
    className: "cls-23",
    d: "M72.961,63.61v.682l-2.949-1.686v-.682Z",
    transform: "translate(-5.963 -5.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80747",
    "data-name": "Path 80747",
    className: "cls-47",
    d: "M70.874,44.308a2.044,2.044,0,0,0,.268-.363,2.724,2.724,0,0,0,.312-1.457c0-.172-.019-.344-.039-.514a7.168,7.168,0,0,0-.727-2.4,8.031,8.031,0,0,0-1.476-2.048,5.109,5.109,0,0,0-1.646-1.155,2.487,2.487,0,0,0-1.407-.213c-.028.005-.057.011-.084.018a1.99,1.99,0,0,0-1.172.926,3.164,3.164,0,0,0-.273,1.972,7.149,7.149,0,0,0,.727,2.4,8.037,8.037,0,0,0,1.476,2.048,5.121,5.121,0,0,0,1.646,1.155,2.409,2.409,0,0,0,1.49.195,1.887,1.887,0,0,0,.9-.564M66.3,43.68a9.429,9.429,0,0,1-1.4-2.046,8.365,8.365,0,0,1-.851-2.8c-.024-.2-.039-.4-.045-.6v-.267c0-.022,0-.045,0-.066a2.93,2.93,0,0,1,.361-1.371,2.326,2.326,0,0,1,1.371-1.084,2.816,2.816,0,0,1,1.744.229,5.979,5.979,0,0,1,1.926,1.349,9.437,9.437,0,0,1,1.726,2.4,8.4,8.4,0,0,1,.85,2.8c.024.2.041.4.047.6a3.2,3.2,0,0,1-.365,1.705A2.324,2.324,0,0,1,70.3,45.609a2.816,2.816,0,0,1-1.744-.228c-.11-.046-.216-.1-.32-.148h0c-.047-.023-.092-.047-.138-.072a6.364,6.364,0,0,1-1.466-1.13c-.113-.113-.222-.23-.33-.349",
    transform: "translate(-5.452 -3.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80748",
    "data-name": "Path 80748",
    className: "cls-23",
    d: "M74.2,44.863l-1.9,1.085,0-.005a2.723,2.723,0,0,0,1.01-1.189,4.078,4.078,0,0,0,.3-1.66,6.625,6.625,0,0,0-.141-1.351,9.805,9.805,0,0,0-.921-2.562c-.108-.2-.222-.405-.342-.6l3.281,2.941h0l.008.122c0,.081.007.163.009.244,0,.041,0,.081,0,.123a5.762,5.762,0,0,1-.058.82,3.128,3.128,0,0,1-.635,1.5,2.042,2.042,0,0,1-.61.538",
    transform: "translate(-6.15 -3.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80749",
    "data-name": "Path 80749",
    className: "cls-48",
    d: "M71.6,42.557a2.717,2.717,0,0,1-.312,1.457,2.044,2.044,0,0,1-.268.363c-.04.006-.081.011-.122.015s-.109.006-.163.007-.111,0-.167-.005-.113-.01-.171-.018-.116-.018-.175-.031-.119-.027-.177-.043-.121-.036-.181-.056-.122-.043-.182-.069-.124-.051-.185-.081-.124-.059-.185-.092-.123-.067-.184-.1-.121-.073-.184-.113c-.092-.061-.181-.123-.273-.191s-.179-.138-.27-.214-.177-.154-.265-.237-.173-.166-.258-.256-.168-.179-.252-.275-.161-.191-.24-.293-.155-.2-.23-.306-.146-.211-.216-.321-.137-.22-.2-.332-.126-.226-.186-.34-.115-.231-.169-.348-.1-.235-.15-.353-.091-.237-.132-.354-.078-.238-.111-.355-.065-.237-.091-.352-.049-.234-.069-.349-.036-.23-.047-.34-.02-.224-.025-.332,0-.212,0-.317.009-.2.019-.3a3.478,3.478,0,0,1,.071-.423,2.679,2.679,0,0,1,.119-.383,2.274,2.274,0,0,1,.165-.338,1.9,1.9,0,0,1,.172-.242v0a2.479,2.479,0,0,1,1.407.213A5.109,5.109,0,0,1,69.361,37.6a8.031,8.031,0,0,1,1.476,2.048,7.169,7.169,0,0,1,.727,2.4c.02.17.035.342.039.514",
    transform: "translate(-5.601 -3.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80750",
    "data-name": "Path 80750",
    className: "cls-23",
    d: "M70.8,34.41l.789.709c-.054.188-.109.374-.164.563l-.589.29c-.038-.035-2.04-2.192-2.292-2.337,0-.221.006-.706.01-.927a12.46,12.46,0,0,1,1.581,1.12q.317.261.626.548c.013.013.027.025.038.035",
    transform: "translate(-5.838 -2.786)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73856",
    "data-name": "Group 73856",
    transform: "translate(62.575 55.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73855",
    "data-name": "Group 73855",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27190",
    "data-name": "Rectangle 27190",
    className: "cls-57",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73858",
    "data-name": "Group 73858",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73857",
    "data-name": "Group 73857",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80752",
    "data-name": "Path 80752",
    className: "cls-32",
    d: "M68.087,28.1c.107.253.068.162.175.414L63.5,31.232c.049.115.1.23.145.345l-1.067.611c-.107-.252-.213-.507-.321-.759L68.087,28.1",
    transform: "translate(-5.303 -2.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80753",
    "data-name": "Path 80753",
    className: "cls-18",
    d: "M67.856,28.1l-5.827,3.333-2.486.393L64.3,29.1l1.068-.611,2.486-.393",
    transform: "translate(-5.072 -2.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80754",
    "data-name": "Path 80754",
    className: "cls-23",
    d: "M68.126,60.846v.682l-2.948-1.686v-.682Z",
    transform: "translate(-5.551 -5.039)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73860",
    "data-name": "Group 73860",
    transform: "translate(59.824 26.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73859",
    "data-name": "Group 73859",
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27192",
    "data-name": "Rectangle 27192",
    className: "cls-59",
    width: 8.108,
    height: 4.02,
    transform: "translate(0 0)"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73862",
    "data-name": "Group 73862",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73861",
    "data-name": "Group 73861",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80756",
    "data-name": "Path 80756",
    className: "cls-49",
    d: "M66.214,36.237a1.984,1.984,0,0,0-.172.242,2.222,2.222,0,0,0-.165.338,2.68,2.68,0,0,0-.12.383,3.337,3.337,0,0,0-.07.423c-.01.1-.017.2-.02.3s0,.209,0,.316.013.222.025.332.027.228.048.341.042.232.069.348.057.236.091.352.071.237.112.355.084.238.132.354.1.237.15.353.11.233.168.348.123.229.187.34.132.223.2.333.142.215.216.32.15.207.23.307.157.2.24.293.166.186.252.274.17.174.257.257.176.16.265.236.179.146.271.214.18.131.273.191c.062.04.122.078.183.114s.124.07.185.1.124.065.185.092.124.057.184.081.123.048.182.069.123.039.182.056.119.031.177.043a1.71,1.71,0,0,0,.175.031c.058.008.115.016.171.019s.112.005.166.005.11,0,.164-.007.081-.009.122-.016a1.892,1.892,0,0,1-.9.564,2.408,2.408,0,0,1-1.49-.195,5.1,5.1,0,0,1-1.646-1.155,8.015,8.015,0,0,1-1.476-2.048,7.149,7.149,0,0,1-.727-2.4,3.158,3.158,0,0,1,.273-1.972,1.99,1.99,0,0,1,1.172-.926c.027-.007.056-.013.084-.018Z",
    transform: "translate(-5.506 -3.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80757",
    "data-name": "Path 80757",
    className: "cls-41",
    d: "M64.445,34.642a3.355,3.355,0,0,1,.8-.03v0a2.186,2.186,0,0,0-.874.5,2.719,2.719,0,0,0-.688,1.144,4.5,4.5,0,0,0-.2,1.4V37.9c0,.085,0,.167,0,.252v.015c.005.2.022.4.046.6a8.366,8.366,0,0,0,.851,2.8,9.371,9.371,0,0,0,1.4,2.046l-2.616-1.5a13.364,13.364,0,0,0-.9-1.925,12.9,12.9,0,0,0-2.675-3.306,8.172,8.172,0,0,0-1.759-1.2Z",
    transform: "translate(-4.925 -2.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80758",
    "data-name": "Path 80758",
    className: "cls-32",
    d: "M64.012,28.741c.107.252.068.161.175.414l-4.76,2.722c.049.114.1.23.146.345l-1.067.611h0c-.107-.254-.213-.507-.321-.759l5.827-3.333",
    transform: "translate(-4.956 -2.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80759",
    "data-name": "Path 80759",
    className: "cls-18",
    d: "M63.781,28.741l-5.827,3.333-2.486.393,4.76-2.723,1.068-.61,2.486-.393",
    transform: "translate(-4.724 -2.448)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73864",
    "data-name": "Group 73864",
    transform: "translate(58.152 53.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73863",
    "data-name": "Group 73863",
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27194",
    "data-name": "Rectangle 27194",
    className: "cls-61",
    width: 0.597,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73866",
    "data-name": "Group 73866",
    transform: "translate(57.278 29.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73865",
    "data-name": "Group 73865",
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27195",
    "data-name": "Rectangle 27195",
    className: "cls-63",
    width: 1.242,
    height: 0.611,
    transform: "translate(0 0)"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73868",
    "data-name": "Group 73868",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73867",
    "data-name": "Group 73867",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80762",
    "data-name": "Path 80762",
    className: "cls-18",
    d: "M63.619,31.208l4.759-2.722,1.069-.611.159-.026a4.574,4.574,0,0,1,.519-.044,5.1,5.1,0,0,1,.723.03,6.6,6.6,0,0,1,1.528.365l-5.827,3.332a6.651,6.651,0,0,0-1.528-.365,5.231,5.231,0,0,0-.722-.03,5.055,5.055,0,0,0-.52.045l-.159.026",
    transform: "translate(-5.419 -2.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80763",
    "data-name": "Path 80763",
    className: "cls-23",
    d: "M62.835,42.218l-.877.5q-.508.292-1.019.583l-.136-.349a14.357,14.357,0,0,0-1.176-2.274,11.561,11.561,0,0,0-3.672-3.614,4.462,4.462,0,0,0-1.917-.72v-.005l3.464-.548a8.1,8.1,0,0,1,1.759,1.2,12.9,12.9,0,0,1,2.675,3.306,13.364,13.364,0,0,1,.9,1.925",
    transform: "translate(-4.603 -3.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80764",
    "data-name": "Path 80764",
    className: "cls-23",
    d: "M63.291,58.081v.682l-2.948-1.686v-.682l2.948,1.687",
    transform: "translate(-5.14 -4.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80765",
    "data-name": "Path 80765",
    className: "cls-23",
    d: "M63.2,47.294v.265c0,.062,0,.123,0,.184,0,.1-.006.206-.013.306s-.016.2-.026.3-.024.195-.039.29-.031.188-.048.279l-1.02.583c.025-.122.045-.246.063-.371a7.181,7.181,0,0,0,.065-.986c0-.166,0-.338-.015-.515s-.027-.36-.05-.546c-.018-.145-.038-.293-.063-.445l1.148.657",
    transform: "translate(-5.285 -3.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80766",
    "data-name": "Path 80766",
    className: "cls-23",
    d: "M62.029,31.739c.108.252.214.506.321.758l-2.486.393-.175-.414c-.048-.115-.1-.231-.146-.346l2.486-.392",
    transform: "translate(-5.072 -2.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80767",
    "data-name": "Path 80767",
    className: "cls-44",
    d: "M60.452,43l.137.349c-.279.176-.559.35-.838.521l-.06-.169a12.014,12.014,0,0,0-1.854-3.319,10.086,10.086,0,0,0-2.323-2.161,4.769,4.769,0,0,0-2.368-.9,2.96,2.96,0,0,0-2.284.865,4.381,4.381,0,0,0-.8,3.109,8.47,8.47,0,0,0,.14,1.187,9.22,9.22,0,0,1-.264-2.143,5.152,5.152,0,0,1,.469-2.306,3.186,3.186,0,0,1,.927-1.137,2.645,2.645,0,0,1,.763-.252l.156-.027,1.431-.226V36.4a4.452,4.452,0,0,1,1.917.719,11.561,11.561,0,0,1,3.672,3.614A14.392,14.392,0,0,1,60.452,43",
    transform: "translate(-4.254 -3.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80768",
    "data-name": "Path 80768",
    className: "cls-32",
    d: "M59.937,29.387c.059.137.117.276.175.414q-2.379,1.361-4.76,2.723c.049.114.1.23.146.345l-1.068.61c-.107-.253-.213-.506-.321-.759l5.827-3.332",
    transform: "translate(-4.609 -2.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80769",
    "data-name": "Path 80769",
    className: "cls-18",
    d: "M59.706,29.387l-5.827,3.332-2.486.394q2.364-1.353,4.728-2.7l1.1-.629,2.486-.393",
    transform: "translate(-4.377 -2.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80770",
    "data-name": "Path 80770",
    className: "cls-48",
    d: "M59.716,46.526a5.527,5.527,0,0,1-.031.589,3.73,3.73,0,0,1-.306,1.138,2.491,2.491,0,0,1-.3.507c-.005.008-.012.016-.017.023l-.038.048-.018.022a1.54,1.54,0,0,1-.106.113c-.06.016-.092.021-.156.032s-.134.02-.2.026-.137.009-.207.009-.142,0-.212-.006-.145-.013-.219-.023-.148-.024-.223-.039-.151-.035-.226-.056-.154-.045-.231-.07-.155-.057-.232-.087-.156-.067-.234-.1-.157-.077-.236-.118-.156-.085-.235-.132-.155-.093-.233-.145c-.118-.077-.231-.156-.348-.243s-.23-.176-.344-.274-.225-.194-.338-.3-.22-.213-.329-.328-.215-.229-.319-.35-.206-.244-.306-.372-.2-.258-.292-.392-.186-.27-.275-.409-.174-.279-.257-.423-.161-.288-.236-.435-.147-.295-.215-.443-.133-.3-.192-.449-.117-.3-.168-.452-.1-.3-.142-.452-.081-.3-.114-.448-.065-.3-.088-.444-.046-.293-.06-.435S52,41.32,52,41.183s-.006-.271,0-.4.013-.259.026-.386a4.266,4.266,0,0,1,.091-.539,3.528,3.528,0,0,1,.151-.488,2.9,2.9,0,0,1,.212-.431,3.162,3.162,0,0,1,.306-.406,2.464,2.464,0,0,1,.561-.1,3.7,3.7,0,0,1,2.005.6,7.867,7.867,0,0,1,2,1.689,10.369,10.369,0,0,1,1.662,2.663l.073.178q.145.351.261.716a8.162,8.162,0,0,1,.328,1.486,6.221,6.221,0,0,1,.048.759",
    transform: "translate(-4.428 -3.273)"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73870",
    "data-name": "Group 73870",
    transform: "translate(53.551 29.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73869",
    "data-name": "Group 73869",
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27197",
    "data-name": "Rectangle 27197",
    className: "cls-65",
    width: 1.241,
    height: 0.611,
    transform: "translate(0 0)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73872",
    "data-name": "Group 73872",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73871",
    "data-name": "Group 73871",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80772",
    "data-name": "Path 80772",
    className: "cls-49",
    d: "M58.648,49.008a1.391,1.391,0,0,0,.156-.033,2.307,2.307,0,0,1-1.261.628,3.414,3.414,0,0,1-2.041-.435,7.229,7.229,0,0,1-2.062-1.615,10.58,10.58,0,0,1-1.734-2.614,8.34,8.34,0,0,1-.815-3,3.817,3.817,0,0,1,.542-2.582,2.422,2.422,0,0,1,1.25-.821,3.184,3.184,0,0,0-.306.406,2.8,2.8,0,0,0-.211.43,3.458,3.458,0,0,0-.151.489,4.083,4.083,0,0,0-.091.539c-.013.127-.021.252-.025.385s0,.265,0,.4.016.282.031.423.036.289.06.434.054.3.088.444.072.3.115.449.091.3.142.452.107.3.167.452.124.3.192.448.14.3.215.443.154.292.236.435.168.284.257.423.18.274.275.409.192.263.292.391.2.252.306.372.21.238.319.351.217.221.329.327.223.2.338.3.226.186.343.273.23.166.348.243c.079.051.155.1.233.145s.156.091.235.132.159.081.236.118.157.07.234.1.156.061.232.087.155.05.231.071.152.039.227.055.149.029.222.039.146.018.219.024.143.006.212.006.14,0,.207-.009.136-.015.2-.026",
    transform: "translate(-4.333 -3.283)"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73874",
    "data-name": "Group 73874",
    transform: "translate(53.73 50.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73873",
    "data-name": "Group 73873",
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27199",
    "data-name": "Rectangle 27199",
    className: "cls-67",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73876",
    "data-name": "Group 73876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73875",
    "data-name": "Group 73875",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80774",
    "data-name": "Path 80774",
    className: "cls-23",
    d: "M58.456,55.237v.682l-2.765-1.581c-.062-.035-.129-.074-.2-.113l.011-.676c.046.027.282-.869.327-.843.016.009.214.2.23.211.123.071.2.138.32.208.062.035.238.194.3.228Z",
    transform: "translate(-4.727 -4.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80775",
    "data-name": "Path 80775",
    className: "cls-23",
    d: "M57.954,32.385c.108.252.214.5.321.758l-2.486.393c-.059-.138-.116-.276-.175-.414-.048-.115-.1-.231-.146-.345l2.486-.393",
    transform: "translate(-4.724 -2.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80776",
    "data-name": "Path 80776",
    className: "cls-32",
    d: "M55.834,30.155l.167.32-4.728,2.7c.062.145.125.293.187.439l-1.065.61-.014-.027c-.124-.238-.251-.475-.375-.714l5.827-3.333",
    transform: "translate(-4.259 -2.568)"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73878",
    "data-name": "Group 73878",
    transform: "translate(49.822 30.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73877",
    "data-name": "Group 73877",
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27201",
    "data-name": "Rectangle 27201",
    className: "cls-69",
    width: 1.242,
    height: 0.61,
    transform: "translate(0 0)"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73880",
    "data-name": "Group 73880",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73879",
    "data-name": "Group 73879",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80778",
    "data-name": "Path 80778",
    className: "cls-23",
    d: "M51.579,33.862q-.092-.221-.186-.44l2.485-.393q.162.38.321.758l-2.485.394-.135-.319",
    transform: "translate(-4.377 -2.813)"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73882",
    "data-name": "Group 73882",
    transform: "translate(49.189 48.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73881",
    "data-name": "Group 73881",
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27203",
    "data-name": "Rectangle 27203",
    className: "cls-71",
    width: 0.505,
    height: 0.588,
    transform: "translate(0 0)"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73884",
    "data-name": "Group 73884",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73883",
    "data-name": "Group 73883",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80780",
    "data-name": "Path 80780",
    className: "cls-23",
    d: "M53.651,52.113c-.042.2-.108.491-.151.687a16.776,16.776,0,0,1-2.891-3.132l.347-.356c.016.022.3-.195.32-.173.066.092.07.139.14.231.12.16.238.056.363.21,0,.005.033.215.038.22.041.051.156.027.2.077.014.016.091.171.1.188a13.626,13.626,0,0,0,1.532,2.048",
    transform: "translate(-4.311 -4.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80781",
    "data-name": "Path 80781",
    className: "cls-10",
    d: "M50.381,34.578c0,.008.009.018.015.027a3.366,3.366,0,0,0-.4.195l.385-.221",
    transform: "translate(-4.258 -2.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80782",
    "data-name": "Path 80782",
    className: "cls-47",
    d: "M62.178,46.508l-1.148-.657c.025.152.046.3.063.445.023.187.038.37.05.546s.015.349.015.516a7.018,7.018,0,0,1-.065.985c-.017.125-.038.25-.063.371l8.1,4.631,9.519,5.443q4.055,2.319,8.108,4.638c-.025-.153-.045-.3-.062-.449-.01-.092-.02-.185-.028-.275s-.014-.179-.02-.267-.008-.164-.01-.244v-.016c0-.085,0-.17,0-.252s0-.167,0-.25.006-.164.011-.245.013-.164.02-.245.018-.162.028-.242c.017-.127.038-.253.062-.378l-8.108-4.637-9.519-5.444-6.947-3.974m-9.561-8.063a2.421,2.421,0,0,0-1.251.821,3.812,3.812,0,0,0-.542,2.582,8.321,8.321,0,0,0,.814,3,10.558,10.558,0,0,0,1.735,2.614,7.238,7.238,0,0,0,2.061,1.615,3.417,3.417,0,0,0,2.042.435,2.31,2.31,0,0,0,1.261-.628,1.527,1.527,0,0,0,.105-.113l.019-.022L58.9,48.7c.005-.007.013-.016.018-.024a2.509,2.509,0,0,0,.3-.507,3.7,3.7,0,0,0,.3-1.137,5.545,5.545,0,0,0,.032-.59,6.221,6.221,0,0,0-.048-.759,8.161,8.161,0,0,0-.328-1.486c-.078-.243-.165-.481-.261-.716l-.074-.177a10.365,10.365,0,0,0-1.661-2.663,7.877,7.877,0,0,0-2-1.69,3.7,3.7,0,0,0-2-.6,2.456,2.456,0,0,0-.561.1m-1.574,6.562a9.788,9.788,0,0,1-.825-2.438,8.337,8.337,0,0,1-.14-1.187,4.381,4.381,0,0,1,.8-3.109,2.963,2.963,0,0,1,2.284-.865,4.772,4.772,0,0,1,2.368.9,10.064,10.064,0,0,1,2.322,2.161A12.017,12.017,0,0,1,59.7,43.791l.06.169L88.161,60.2a3.764,3.764,0,0,0-.423,1.251,7.3,7.3,0,0,0,.07,2.658c.059.274.127.543.2.811.006.023.015.047.021.07.04.136.083.272.128.405L60.93,49.824l-.329-.188-.837-.478-.06.1a2.716,2.716,0,0,1-1.5,1.13,3.725,3.725,0,0,1-2.5-.333,7.3,7.3,0,0,1-1.951-1.313l-.07-.069.052.053c-.2-.181-.385-.37-.568-.568a12.843,12.843,0,0,1-2.119-3.151",
    transform: "translate(-4.264 -3.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80783",
    "data-name": "Path 80783",
    className: "cls-23",
    d: "M49.535,33.7q2.912-1.667,5.824-3.331a3.7,3.7,0,0,1,.436-.213l-5.827,3.333a3.57,3.57,0,0,0-.433.211",
    transform: "translate(-4.219 -2.568)"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73886",
    "data-name": "Group 73886",
    transform: "translate(44.662 31.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73885",
    "data-name": "Group 73885",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27205",
    "data-name": "Rectangle 27205",
    className: "cls-73",
    width: 2.675,
    height: 1.751,
    transform: "translate(0 0)"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73888",
    "data-name": "Group 73888",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73887",
    "data-name": "Group 73887",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80785",
    "data-name": "Path 80785",
    className: "cls-23",
    d: "M49.113,46.148q.214.451.458.89l-.422.241A18.013,18.013,0,0,1,47.5,43.243c.187.03.374.059.561.09.033.124.068.247.105.371.014.049.029.1.044.148.045.147.092.3.145.445.007.026.016.05.025.075s.017.048.027.073c.014.043.029.086.045.129s.041.114.063.17q.095.258.2.513c.016.04.033.081.049.12.026.061.052.122.079.183.017.041.036.082.054.124q.1.235.214.465",
    transform: "translate(-4.046 -3.683)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73890",
    "data-name": "Group 73890",
    transform: "translate(43.458 39.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73889",
    "data-name": "Group 73889",
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27207",
    "data-name": "Rectangle 27207",
    className: "cls-75",
    width: 0.561,
    height: 0.36,
    transform: "translate(0 0)"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73892",
    "data-name": "Group 73892",
    transform: "translate(43.249 33.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73891",
    "data-name": "Group 73891",
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27208",
    "data-name": "Rectangle 27208",
    className: "cls-77",
    width: 0.951,
    height: 1.041,
    transform: "translate(0 0)"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73894",
    "data-name": "Group 73894",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73893",
    "data-name": "Group 73893",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80788",
    "data-name": "Path 80788",
    className: "cls-23",
    d: "M47.252,37.229l.666.582a5.278,5.278,0,0,0-.091.652c0,.023.065.11.062.133a9.007,9.007,0,0,0-.119,2.441c-.2-.08-.5-.212-.7-.293a9.489,9.489,0,0,1,.178-3.515",
    transform: "translate(-4.002 -3.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80789",
    "data-name": "Path 80789",
    className: "cls-23",
    d: "M63.764,31.862c-.048-.115-.1-.23-.145-.344l.16-.026a4.556,4.556,0,0,1,.519-.045,5.232,5.232,0,0,1,.722.03,6.651,6.651,0,0,1,1.528.365c.037.244.121.709.156.953a6.542,6.542,0,0,0-1.46-.342c-.044,0-.37.341-.369.056-.36-.032-.477-.306-.83-.25l-.105.016c-.059-.138-.116-.277-.176-.414",
    transform: "translate(-5.419 -2.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80790",
    "data-name": "Path 80790",
    className: "cls-23",
    d: "M50.308,34.663c-.129.074-.193.215-.322.289l-.107.232A2.285,2.285,0,0,0,49,35.9c-.005.006.01.4-.2.07a2.323,2.323,0,0,0-.258.338c-.177-.2-.481-.559-.656-.759a4.059,4.059,0,0,1,1.5-1.539l0,0a3.557,3.557,0,0,1,.432-.211c.124.238.356.627.481.865",
    transform: "translate(-4.079 -2.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80791",
    "data-name": "Path 80791",
    className: "cls-23",
    d: "M60.366,51.431l.374.141,1.1-.489-.028-.12-.329-.188Z",
    transform: "translate(-5.142 -4.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80792",
    "data-name": "Path 80792",
    className: "cls-78",
    d: "M60.942,50.69l-.033.049-.069.1-.036.048a2.967,2.967,0,0,1-1.753,1.064,4.321,4.321,0,0,1-2.707-.519,8.967,8.967,0,0,1-2.27-1.645l.013.01a7.282,7.282,0,0,0,1.951,1.313,3.714,3.714,0,0,0,2.5.333,2.705,2.705,0,0,0,1.5-1.129l.06-.1c.279.158.559.319.838.478",
    transform: "translate(-4.606 -4.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80793",
    "data-name": "Path 80793",
    className: "cls-23",
    d: "M101.608,78.224c.12.25.274.566.394.816a5.146,5.146,0,0,1-2.858-.071c-.047-.245-.106-.535-.154-.779a4.131,4.131,0,0,0,.815.054c.008,0,.1-.089.1-.089l.177.106a3.525,3.525,0,0,0,1.522-.037",
    transform: "translate(-8.431 -6.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80794",
    "data-name": "Path 80794",
    className: "cls-79",
    d: "M51.142,36.545a3.086,3.086,0,0,0-1.017.821,4.4,4.4,0,0,0-.81,2.65,9.623,9.623,0,0,0,.571,3.435,13.366,13.366,0,0,0,1.98,3.7,10.539,10.539,0,0,0,3.109,2.839L92.851,71.65a5.3,5.3,0,0,0,2.083.738,3.455,3.455,0,0,0,1.708-.242,2.531,2.531,0,0,0,.439-.242A3.431,3.431,0,0,0,98.3,70.082a6.441,6.441,0,0,0,.118-2.919,12.23,12.23,0,0,0-1.133-3.51,12.915,12.915,0,0,0-2.6-3.582l-.566-.507-2.166-1.943h0l-1.052-.944L84.8,51.216l-4.342-3.893-7.07-6.339h0l-3.281-2.942L68.361,36.47a11.447,11.447,0,0,0-1.028-.857A6.588,6.588,0,0,0,64.9,34.5a3.64,3.64,0,0,0-.523-.084,3.316,3.316,0,0,0-.8.029l-6.622,1.048-3.464.548-1.431.226-.156.027a2.644,2.644,0,0,0-.763.252M49.6,46.132h0l-.016-.028c-.161-.293-.314-.59-.458-.889-.074-.155-.145-.31-.214-.465-.018-.041-.037-.082-.054-.124-.027-.061-.053-.122-.079-.183-.016-.04-.033-.08-.049-.12q-.106-.255-.2-.513c-.021-.056-.042-.113-.062-.17s-.031-.086-.045-.129-.035-.1-.051-.148c-.052-.148-.1-.3-.145-.445-.015-.049-.03-.1-.044-.148-.038-.124-.072-.247-.105-.37s-.061-.239-.09-.36a11.584,11.584,0,0,1-.329-3.045,8.887,8.887,0,0,1,.07-.908c0-.022.006-.044.009-.066a6.988,6.988,0,0,1,.147-.709l-.008-.007a5.014,5.014,0,0,1,.383-1.041c.042-.082.086-.163.134-.242l.007.009a4.117,4.117,0,0,1,.319-.479A3.851,3.851,0,0,1,51,34.18l.159-.027.231-.036,2.486-.394,1.243-.2,2.485-.392h0l1.241-.2,2.486-.392,1.242-.2a5.305,5.305,0,0,1,.636-.065,4.616,4.616,0,0,1,.537.014l.131.013c.165.021.33.049.5.088a8.541,8.541,0,0,1,2.383.937v.014a11.6,11.6,0,0,1,1.461,1.035c.06.05.121.1.18.152s.116.1.175.152l0,0c.078.07.248.225.256.233l.1.086.115.1c.2.177.4.354.593.532h0l1.418,1.272L73.9,39.461l1.418,1.273,2.837,2.543,1.418,1.272q1.419,1.271,2.836,2.543l1.419,1.273,2.837,2.543,1.418,1.272,4.255,3.816q1.419,1.271,2.836,2.543a16.224,16.224,0,0,1,2.32,2.781l0,0a17.951,17.951,0,0,1,1.041,1.786l.075.153c.03.059.059.121.088.18a15.751,15.751,0,0,1,1.349,4.275q.069.428.109.858l.005.07a9.232,9.232,0,0,1-.027,1.683l.01.006A6.486,6.486,0,0,1,99.9,71.5a4.911,4.911,0,0,1-1.03,1.893c-.056.06-.114.12-.174.177a3.62,3.62,0,0,1-.337.28l-.009.006-.017.012a4.181,4.181,0,0,1-2.751.64h0a5.823,5.823,0,0,1-.95-.191l0,.01a6.434,6.434,0,0,1-.781-.276c-.231-.1-.456-.207-.676-.324h0c-.108-.056-.215-.114-.321-.175-.139-.079-.278-.159-.416-.239l-2.212-1.265-.878-.5-.6-.34L85.8,69.517l-.877-.5-.6-.34h0l-2.948-1.685-.878-.5-.6-.341-2.948-1.686h0l-.878-.5-.6-.341h0l-2.949-1.686-.878-.5-.6-.342L68.108,59.4l-.878-.5-.6-.341L63.685,56.87l-.878-.5-.6-.341L59.262,54.34l-.878-.5-.6-.34v0q-1.107-.631-2.212-1.264c-.061-.035-.123-.07-.185-.1l-.369-.211-.048-.027-.135-.08a11.063,11.063,0,0,1-1.086-.733c-.127-.1-.253-.2-.377-.3v0A14.919,14.919,0,0,1,51.5,48.9c-.013-.016-.026-.031-.038-.046l-.124-.151-.014-.016c-.125-.155-.249-.312-.369-.471-.069-.091-.136-.183-.2-.274a17.824,17.824,0,0,1-1.153-1.81",
    transform: "translate(-4.059 -2.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80795",
    "data-name": "Path 80795",
    className: "cls-44",
    d: "M81.332,50.214a1.273,1.273,0,0,1,.435-.536c.022-.014.043-.028.066-.04a1.578,1.578,0,0,1,1.155-.07,3.276,3.276,0,0,1,1.675,1.347,4.9,4.9,0,0,1,1.1,2.83A1.974,1.974,0,0,1,85.5,54.83a1.336,1.336,0,0,1-.1.136,1.225,1.225,0,0,1-.616.375,1.322,1.322,0,0,1-.4.026h-.008a1.558,1.558,0,0,1-.262-.041c.032,0,.061-.011.091-.018a1.2,1.2,0,0,0,.708-.56,1.638,1.638,0,0,0,.189-.881c0-.1-.012-.209-.024-.312a4.358,4.358,0,0,0-.439-1.448,4.82,4.82,0,0,0-.894-1.239,3.066,3.066,0,0,0-1-.7c-.064-.027-.131-.051-.2-.073a1.294,1.294,0,0,0-.7-.045,1.211,1.211,0,0,0-.708.557l.192-.394Z",
    transform: "translate(-6.911 -4.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80796",
    "data-name": "Path 80796",
    className: "cls-4",
    d: "M112.027,72.089v3.333l-1.457.833V72.922Z",
    transform: "translate(-9.418 -6.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80797",
    "data-name": "Path 80797",
    className: "cls-9",
    d: "M111.241,71.4l-1.457.833L101.348,64.8l1.457-.832Z",
    transform: "translate(-8.632 -5.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80798",
    "data-name": "Path 80798",
    className: "cls-80",
    d: "M109.349,71.681v3.333l-13.111-7.5v-10l2.011,1.149,2.665,5.582Z",
    transform: "translate(-8.197 -4.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80799",
    "data-name": "Path 80799",
    className: "cls-4",
    d: "M99.893,57.863l2.665,5.583-1.457.832L98.435,58.7Z",
    transform: "translate(-8.384 -4.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80800",
    "data-name": "Path 80800",
    className: "cls-9",
    d: "M99.705,57.756l-1.457.833-2.01-1.15,1.456-.833Z",
    transform: "translate(-8.197 -4.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80801",
    "data-name": "Path 80801",
    className: "cls-18",
    d: "M95.84,57.552V58.8L92.02,56.613,92,56.6l-.326-.186a.323.323,0,0,1-.11-.31.723.723,0,0,1,.11-.314.735.735,0,0,1,.22-.252.329.329,0,0,1,.325-.06l3.623,2.072",
    transform: "translate(-7.799 -4.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80802",
    "data-name": "Path 80802",
    className: "cls-18",
    d: "M92.519,55.538a.481.481,0,0,0-.134-.366.436.436,0,0,0-.391-.04.774.774,0,0,0-.327.226,1.6,1.6,0,0,0-.238.323,1.374,1.374,0,0,0-.14.375.79.79,0,0,0-.009.334.405.405,0,0,0,.126.232.358.358,0,0,0,.255.072.482.482,0,0,0,.158-.045l-.02.014a.841.841,0,0,1-.218.105.5.5,0,0,1-.34,0,.225.225,0,0,1-.038-.021.463.463,0,0,1-.187-.228.8.8,0,0,1-.028-.425,1.656,1.656,0,0,1,.156-.484,2.016,2.016,0,0,1,.29-.423,1.029,1.029,0,0,1,.405-.3.617.617,0,0,1,.446-.006.3.3,0,0,1,.055.033.6.6,0,0,1,.177.462Z",
    transform: "translate(-7.749 -4.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80803",
    "data-name": "Path 80803",
    className: "cls-81",
    d: "M81.7,49.306a.654.654,0,0,1,.65-.122l9.1,5.2,0,0a.613.613,0,0,0-.446.007,1.012,1.012,0,0,0-.405.3,1.982,1.982,0,0,0-.29.423,1.672,1.672,0,0,0-.156.485.814.814,0,0,0,.028.424.47.47,0,0,0,.188.228v0l-9.1-5.206a.637.637,0,0,1-.218-.618,1.459,1.459,0,0,1,.218-.628,1.48,1.48,0,0,1,.44-.5",
    transform: "translate(-6.902 -4.185)"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73896",
    "data-name": "Group 73896",
    transform: "translate(69.982 42.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73895",
    "data-name": "Group 73895",
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27210",
    "data-name": "Rectangle 27210",
    className: "cls-83",
    width: 5.476,
    height: 4.291,
    transform: "translate(-0.015 0)"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73898",
    "data-name": "Group 73898",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73897",
    "data-name": "Group 73897",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80805",
    "data-name": "Path 80805",
    className: "cls-4",
    d: "M94.57,58.131l-5.844,3.343V72.448l6.661-3.81V57.665Zm1.856-2.251v17.9l-8.74,5v-17.9Z",
    transform: "translate(-7.469 -4.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80806",
    "data-name": "Path 80806",
    className: "cls-9",
    d: "M83.144,41.309,94.8,54.639l-8.741,5-17.48-10Z",
    transform: "translate(-5.841 -3.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80807",
    "data-name": "Path 80807",
    className: "cls-84",
    d: "M96.027,57.831V68.8l-.816-.7V58.3Z",
    transform: "translate(-8.11 -4.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80808",
    "data-name": "Path 80808",
    className: "cls-85",
    d: "M95.483,69.762l-6.66,3.81V72.406l5.844-3.344c.272.234.544.467.816.7",
    transform: "translate(-7.565 -5.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80809",
    "data-name": "Path 80809",
    className: "cls-23",
    d: "M94.667,58.342v9.807l-5.844,3.344V61.685Z",
    transform: "translate(-7.565 -4.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80810",
    "data-name": "Path 80810",
    className: "cls-10",
    d: "M86.057,60.414v17.9L68.576,71.652V50.416ZM85.2,72.585V60.773l-5.135-2.937L74.239,54.5,70,52.082l-.571-.327V66.573l4.969,1.9,5.827,2.221,4.97,1.9",
    transform: "translate(-5.841 -4.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80811",
    "data-name": "Path 80811",
    className: "cls-9",
    d: "M85.281,73.336v.708l-4.97-1.9-5.827-2.221-4.969-1.9c.19-.164.381-.327.571-.49l15.2,5.794",
    transform: "translate(-5.921 -5.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80812",
    "data-name": "Path 80812",
    className: "cls-12",
    d: "M85.334,69.129v2.9l-15.2-5.795v-14l4.234,2.422L80.2,57.991l5.135,2.937v8.2Z",
    transform: "translate(-5.974 -4.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80813",
    "data-name": "Path 80813",
    className: "cls-4",
    d: "M84.449,36.707l0,.983-.426.243-.129-.908.553-.317",
    transform: "translate(-7.146 -3.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80814",
    "data-name": "Path 80814",
    className: "cls-4",
    d: "M79.25,21.278,74.631,23.92l-5.459,3.122L64.177,29.9q.687,2.757,1.375,5.513.759,3.038,1.516,6.077l1.312,5.258.08.318L72.9,44.524l4.857-2.777L82.2,39.205q-.42-2.948-.838-5.894-.456-3.211-.912-6.421-.414-2.913-.828-5.827l-.376.215M82.3,36.521l.425,2.994L68.153,47.847,63.607,29.618l16.376-9.366,1.753,12.332.432,3.038Z",
    transform: "translate(-5.418 -1.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80815",
    "data-name": "Path 80815",
    className: "cls-12",
    d: "M84.409,36.454l-.553.317-.432-3.038c.416,1.147.57,1.573.985,2.721",
    transform: "translate(-7.106 -2.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80816",
    "data-name": "Path 80816",
    className: "cls-84",
    d: "M82.822,33.387q.42,2.946.838,5.894l-.424-.122q-1.265-8.9-2.529-17.805l.376-.215q.413,2.913.828,5.827.456,3.211.912,6.421",
    transform: "translate(-6.874 -1.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80817",
    "data-name": "Path 80817",
    className: "cls-85",
    d: "M82.648,40.959,78.2,43.5q-2.427,1.39-4.856,2.777Q71.126,47.55,68.9,48.819l-.08-.317,13.4-7.664.424.122",
    transform: "translate(-5.862 -3.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80818",
    "data-name": "Path 80818",
    className: "cls-16",
    d: "M81.832,39.177q-1.135.648-2.248,1.287c-3.745,2.141-7.331,4.194-11.154,6.379q-.653-2.631-1.31-5.26-.757-3.04-1.516-6.075-.685-2.76-1.377-5.515l.011-.007q2.493-1.418,4.986-2.847,2.729-1.564,5.461-3.124L79.3,21.373q1.264,8.906,2.529,17.8",
    transform: "translate(-5.471 -1.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80819",
    "data-name": "Path 80819",
    className: "cls-9",
    d: "M78.1,19.175,61.725,28.541l-10.1-3.479L41.505,19.276,61.9,7.611,72.016,13.4Z",
    transform: "translate(-3.535 -0.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80820",
    "data-name": "Path 80820",
    className: "cls-4",
    d: "M70.085,52.207v14l-.572.49V51.88l.572.327",
    transform: "translate(-5.921 -4.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80821",
    "data-name": "Path 80821",
    className: "cls-10",
    d: "M67.212,48.395v4.122l-9.092-3.131L52.564,37.719V26.687l10.1,3.479Z",
    transform: "translate(-4.477 -2.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80822",
    "data-name": "Path 80822",
    className: "cls-4",
    d: "M58.933,48.829l-.425.241L53.08,37.675V27.406l.427.146v9.883Z",
    transform: "translate(-4.521 -2.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80823",
    "data-name": "Path 80823",
    className: "cls-86",
    d: "M66.824,48.527v3.021l-7.851-2.705L53.547,37.448V27.567L62.353,30.6Z",
    transform: "translate(-4.561 -2.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80824",
    "data-name": "Path 80824",
    className: "cls-4",
    d: "M52.564,38.746l5.557,11.667-1.105.632Z",
    transform: "translate(-4.477 -3.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80825",
    "data-name": "Path 80825",
    className: "cls-80",
    d: "M52.645,55.979l4.37,2.5h5.827l4.37-2.5V72.121L52.564,67.075V55.926l.01-.011Z",
    transform: "translate(-4.477 -4.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80826",
    "data-name": "Path 80826",
    className: "cls-10",
    d: "M51.622,26.148V37.18l-4.452-2.547-5.665-3.239V20.363Z",
    transform: "translate(-3.535 -1.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80827",
    "data-name": "Path 80827",
    className: "cls-9",
    d: "M51.279,36.055v.537l-3.885-2.223-5.476-3.131V21.071l.459.263v9.63L47.853,34.1Z",
    transform: "translate(-3.57 -1.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80828",
    "data-name": "Path 80828",
    className: "cls-86",
    d: "M51.322,26.449v9.63L47.9,34.12,42.42,30.989v-9.63Z",
    transform: "translate(-3.613 -1.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80829",
    "data-name": "Path 80829",
    className: "cls-9",
    d: "M50.917,37.742l-3.2,1.832L36.139,32.956,33.225,31.29l1.538-.88.606-.347.546-.311.187-.107.278-.159L40.8,26.957v5L46.466,35.2Z",
    transform: "translate(-2.83 -2.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80830",
    "data-name": "Path 80830",
    className: "cls-10",
    d: "M43.718,48l7.913,7.1-.009.01V66.261l-7.2-4.119c-1.135-1.946-1.78-3.054-2.915-5V46.347c.164.093.328.194.491.3.141.091.283.188.423.288.093.068.188.137.28.207s.186.145.279.22.185.15.275.228.183.159.274.241l.163.149Z",
    transform: "translate(-3.535 -3.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80831",
    "data-name": "Path 80831",
    className: "cls-12",
    d: "M36.03,33.358l-2.915-1.666L31.951,33.26l2.914,1.666L46.849,41.78q.377-.9.754-1.8Z",
    transform: "translate(-2.721 -2.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80832",
    "data-name": "Path 80832",
    className: "cls-12",
    d: "M67.289,53.528v.387l-8.277-2.852.426-.241Z",
    transform: "translate(-5.026 -4.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80833",
    "data-name": "Path 80833",
    className: "cls-4",
    d: "M42.377,21.334v9.63l-.459.274V21.072Z",
    transform: "translate(-3.57 -1.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80834",
    "data-name": "Path 80834",
    className: "cls-87",
    d: "M81.833,39.177q-1.135.648-2.248,1.287L64.24,29.985q2.493-1.418,4.986-2.847,2.729-1.564,5.461-3.124L79.3,21.373q1.264,8.906,2.529,17.8",
    transform: "translate(-5.472 -1.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80835",
    "data-name": "Path 80835",
    className: "cls-44",
    d: "M81.995,19.452l1,2.075L63.562,32.641l-.279-2.487Z",
    transform: "translate(-5.39 -1.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80836",
    "data-name": "Path 80836",
    className: "cls-47",
    d: "M79.626,18.1,60.915,28.8,49.372,24.824,39.149,18.977l-3.67-2.1,23.3-13.327,3.671,2.1L72.676,11.5Z",
    transform: "translate(-3.022 -0.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80837",
    "data-name": "Path 80837",
    className: "cls-88",
    d: "M50.228,23.693,38.575,17.029,59.045,5.323l13.037,7.455,5.466,5.191L61.031,27.415Z",
    transform: "translate(-3.286 -0.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80838",
    "data-name": "Path 80838",
    className: "cls-89",
    d: "M62.174,30.78l.279,2.487-12.187-4.2.366-2.266Z",
    transform: "translate(-4.281 -2.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80839",
    "data-name": "Path 80839",
    className: "cls-48",
    d: "M49.669,26.261,49.3,28.527,38.957,22.61l.489-2.2Z",
    transform: "translate(-3.318 -1.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80840",
    "data-name": "Path 80840",
    className: "cls-48",
    d: "M39.1,20.219l-.489,2.2-3.67-2.1.489-2.2Z",
    transform: "translate(-2.976 -1.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80841",
    "data-name": "Path 80841",
    className: "cls-90",
    d: "M72.582,67.32s.736-.7.7-1.112-.172-.489-.172-.489l-.525.029-.5.424-.147.515-.038.439.056.109.193.133.121.018.161-.022Z",
    transform: "translate(-6.123 -5.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80842",
    "data-name": "Path 80842",
    className: "cls-4",
    d: "M92.772,82.74v3.333l-1.457.833V83.574Z",
    transform: "translate(-7.778 -7.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80843",
    "data-name": "Path 80843",
    className: "cls-9",
    d: "M91.987,82.048l-1.457.833L82.094,75.45l1.457-.832Z",
    transform: "translate(-6.992 -6.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80844",
    "data-name": "Path 80844",
    className: "cls-91",
    d: "M90.094,82.333v3.333l-13.111-7.5v-10l2.011,1.15L81.659,74.9Z",
    transform: "translate(-6.557 -5.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80845",
    "data-name": "Path 80845",
    className: "cls-4",
    d: "M80.638,68.515,83.3,74.1l-1.457.833-2.665-5.582Z",
    transform: "translate(-6.744 -5.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80846",
    "data-name": "Path 80846",
    className: "cls-9",
    d: "M80.451,68.408l-1.457.833-2.01-1.15,1.456-.833Z",
    transform: "translate(-6.557 -5.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80847",
    "data-name": "Path 80847",
    className: "cls-92",
    d: "M76.582,68.2v1.244c-1.272-.723-2.543-1.455-3.815-2.177-.009-.009-.018-.009-.027-.018-.1-.055-.21-.119-.32-.183a.313.313,0,0,1-.11-.311.7.7,0,0,1,.11-.311.764.764,0,0,1,.073-.11.556.556,0,0,1,.146-.146.137.137,0,0,1,.064-.027.262.262,0,0,1,.256-.027c1.272.723,2.36,1.345,3.623,2.068",
    transform: "translate(-6.159 -5.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80848",
    "data-name": "Path 80848",
    className: "cls-93",
    d: "M76.6,68.38v.3c-1.354-.787-2.726-1.564-4.089-2.342a.556.556,0,0,1,.146-.146.137.137,0,0,1,.064-.027c1.354.768,2.562,1.464,3.879,2.214",
    transform: "translate(-6.176 -5.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80849",
    "data-name": "Path 80849",
    className: "cls-18",
    d: "M73.265,66.189a.484.484,0,0,0-.133-.366.438.438,0,0,0-.392-.04.78.78,0,0,0-.327.226,1.6,1.6,0,0,0-.238.323,1.374,1.374,0,0,0-.14.375.786.786,0,0,0-.009.333.4.4,0,0,0,.126.233.363.363,0,0,0,.255.072.476.476,0,0,0,.158-.045l-.02.014a.841.841,0,0,1-.218.105.5.5,0,0,1-.34,0,.4.4,0,0,1-.038-.021.463.463,0,0,1-.187-.228.8.8,0,0,1-.028-.425,1.656,1.656,0,0,1,.156-.484,2.016,2.016,0,0,1,.29-.423,1.021,1.021,0,0,1,.405-.3.617.617,0,0,1,.446-.006.257.257,0,0,1,.055.033.6.6,0,0,1,.177.462Z",
    transform: "translate(-6.109 -5.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80850",
    "data-name": "Path 80850",
    className: "cls-11",
    d: "M72.19,65.037a.465.465,0,0,0-.2-.037.739.739,0,0,0-.247.046c-.009,0-.009.009-.018.009a1.058,1.058,0,0,0-.393.293l-.11.137a1.814,1.814,0,0,0-.174.284,1.141,1.141,0,0,0-.128.375.483.483,0,0,0-.027.11.763.763,0,0,0,.027.43.5.5,0,0,0,.183.229q-4.556-2.607-9.1-5.205a.645.645,0,0,1-.22-.622.465.465,0,0,1,.027-.156A1.619,1.619,0,0,1,62,60.463a1.256,1.256,0,0,1,.119-.183,1.184,1.184,0,0,1,.32-.32c.055-.037.119-.073.183-.11a.558.558,0,0,1,.467-.018q4.556,2.607,9.1,5.205",
    transform: "translate(-5.262 -5.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80851",
    "data-name": "Path 80851",
    className: "cls-25",
    d: "M71.1,67.019q-4.556-2.607-9.1-5.205a.645.645,0,0,1-.22-.622.465.465,0,0,1,.027-.156c3.037,1.738,6.074,3.485,9.112,5.214a.483.483,0,0,0-.027.11.763.763,0,0,0,.027.43.5.5,0,0,0,.183.229",
    transform: "translate(-5.262 -5.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80852",
    "data-name": "Path 80852",
    className: "cls-24",
    d: "M71.756,65.061a1.058,1.058,0,0,0-.393.293l-.11.137Q66.7,62.9,62.15,60.286a1.184,1.184,0,0,1,.32-.32c.055-.037.119-.073.183-.11q4.556,2.621,9.1,5.205",
    transform: "translate(-5.294 -5.098)"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73900",
    "data-name": "Group 73900",
    transform: "translate(52.367 52.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73899",
    "data-name": "Group 73899",
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27212",
    "data-name": "Rectangle 27212",
    className: "cls-95",
    width: 5.475,
    height: 4.29,
    transform: "translate(-0.015 0)"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73902",
    "data-name": "Group 73902",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73901",
    "data-name": "Group 73901",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80854",
    "data-name": "Path 80854",
    className: "cls-18",
    d: "M81.728,88.117l.178-.618-6.257,2.019-.639,2.194h1.073Z",
    transform: "translate(-6.389 -7.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80855",
    "data-name": "Path 80855",
    className: "cls-26",
    d: "M81.774,82.628a14.3,14.3,0,0,0-.466-1.638l-5.751,2.153-.975,1.219.693,1.949,1.114.546,1.567-.437,1.844-1.37a3.462,3.462,0,0,0,1.122-.687l.481-.465Z",
    transform: "translate(-6.353 -6.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80856",
    "data-name": "Path 80856",
    className: "cls-27",
    d: "M82.528,82.931a11.627,11.627,0,0,1,.259,3.758q-.369.21-.736.421l-5.093,2.912a11.68,11.68,0,0,0-.257-3.759l5.827-3.332",
    transform: "translate(-6.533 -7.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80857",
    "data-name": "Path 80857",
    className: "cls-28",
    d: "M81.9,82.78l.573.137L76.648,86.25l-.574-.137L81.9,82.78",
    transform: "translate(-6.48 -7.051)"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73904",
    "data-name": "Group 73904",
    transform: "translate(69.512 80.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73903",
    "data-name": "Group 73903",
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27214",
    "data-name": "Rectangle 27214",
    className: "cls-97",
    width: 6.394,
    height: 3.872,
    transform: "translate(0 0)"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73906",
    "data-name": "Group 73906",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73905",
    "data-name": "Group 73905",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80859",
    "data-name": "Path 80859",
    className: "cls-31",
    d: "M76.456,92.1q2.912-1.667,5.827-3.333A4.545,4.545,0,0,1,80.7,91l-5.827,3.332A4.551,4.551,0,0,0,76.456,92.1",
    transform: "translate(-6.378 -7.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80860",
    "data-name": "Path 80860",
    className: "cls-27",
    d: "M81.69,80.345l-.443.253-5.384,3.079a18.962,18.962,0,0,0-2-3.952l5.4-3.089.424-.242a18.885,18.885,0,0,1,2,3.951",
    transform: "translate(-6.291 -6.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80861",
    "data-name": "Path 80861",
    className: "cls-26",
    d: "M79.012,76.405l-5.4,3.089-.373.311a16.266,16.266,0,0,0-2.32-2.781l5.827-3.333c.214.2.421.414.623.63A16.472,16.472,0,0,1,78.5,75.684q.263.354.511.722",
    transform: "translate(-6.04 -6.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80862",
    "data-name": "Path 80862",
    className: "cls-32",
    d: "M76.906,73.076l-.164.564-5.827,3.333c.055-.188.109-.376.164-.564l5.827-3.333",
    transform: "translate(-6.04 -6.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80863",
    "data-name": "Path 80863",
    className: "cls-33",
    d: "M76.657,72.839,70.83,76.172l-2.837-2.543q2.672-1.529,5.344-3.057l.483-.275,2.837,2.543",
    transform: "translate(-5.791 -5.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80864",
    "data-name": "Path 80864",
    className: "cls-23",
    d: "M76.616,86.554a11.679,11.679,0,0,1,.257,3.759c-.195-.139-.539-.373-.734-.512a7.547,7.547,0,0,0-.05-1.585c0-.023-.274-.091-.276-.114a11.978,11.978,0,0,0-.106-1.751c.191.046.717.159.909.2",
    transform: "translate(-6.448 -7.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80865",
    "data-name": "Path 80865",
    className: "cls-23",
    d: "M75.793,91.756l.62.6a4.548,4.548,0,0,1-1.578,2.238l-.045-.071-.4-.635.009-.007c.119-.085-.029-.495.076-.6.059-.057.262-.01.317-.07a4.015,4.015,0,0,0,1-1.454",
    transform: "translate(-6.336 -7.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80866",
    "data-name": "Path 80866",
    className: "cls-23",
    d: "M75.815,83.988,75.169,84a14.9,14.9,0,0,0-.7-1.4c-.028-.06-.105-.2-.135-.256-.015-.03-.027-.068-.043-.1s-.229-.144-.24-.164a12.825,12.825,0,0,0-.759-1.616c.125-.1.392-.328.517-.431a18.939,18.939,0,0,1,2,3.952",
    transform: "translate(-6.243 -6.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80867",
    "data-name": "Path 80867",
    className: "cls-47",
    d: "M65.656,88.2c-.257-.269-.5-.553-.729-.846A12.364,12.364,0,0,1,63.072,84l-.093-.263c-.045-.134-.088-.27-.128-.405-.006-.025-.014-.048-.021-.071-.077-.266-.145-.536-.2-.81a7.3,7.3,0,0,1-.07-2.658,3.764,3.764,0,0,1,.423-1.251L63,78.506c.016-.027.03-.054.047-.079s.016-.027.024-.039a2.8,2.8,0,0,1,1.584-1.17,3.874,3.874,0,0,1,2.621.4,8.4,8.4,0,0,1,2.63,2.027,12.553,12.553,0,0,1,2.167,3.343,9.651,9.651,0,0,1,.9,3.876,4.294,4.294,0,0,1-1.023,3,2.985,2.985,0,0,1-2.36.681,5.231,5.231,0,0,1-2.35-.986A10.2,10.2,0,0,1,65.656,88.2m5.772.7a3.688,3.688,0,0,0,.782-2.476,8.221,8.221,0,0,0-.733-3.231,10.575,10.575,0,0,0-1.77-2.807,7.82,7.82,0,0,0-2.147-1.75,3.583,3.583,0,0,0-2.151-.509,2.453,2.453,0,0,0-.338.071h0a2.3,2.3,0,0,0-1.113.7.357.357,0,0,0-.029.036c-.02.023-.038.048-.058.072s-.018.025-.027.037a2.891,2.891,0,0,0-.509,1.225,6.3,6.3,0,0,0,.093,2.689,10.825,10.825,0,0,0,.415,1.283l.114.274A10.606,10.606,0,0,0,65.6,87.174,8.431,8.431,0,0,0,67.566,88.9a4.123,4.123,0,0,0,1.966.7,2.523,2.523,0,0,0,1.853-.652c.016-.013.028-.028.043-.042",
    transform: "translate(-5.321 -6.569)"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73908",
    "data-name": "Group 73908",
    transform: "translate(65.285 86.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73907",
    "data-name": "Group 73907",
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27216",
    "data-name": "Rectangle 27216",
    className: "cls-99",
    width: 3.17,
    height: 1.277,
    transform: "translate(0 0)"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73910",
    "data-name": "Group 73910",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73909",
    "data-name": "Group 73909",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80869",
    "data-name": "Path 80869",
    className: "cls-48",
    d: "M72.376,86.514a3.69,3.69,0,0,1-.782,2.476l-.042.042,0,0c-.066.018-.133.032-.2.044s-.137.02-.206.026-.142.009-.213.009-.145,0-.22-.006-.148-.013-.223-.023-.153-.025-.229-.041-.156-.035-.233-.057-.158-.047-.236-.073-.16-.058-.239-.09-.162-.068-.242-.105-.162-.079-.242-.121-.161-.088-.241-.135-.16-.1-.24-.15c-.123-.079-.239-.16-.359-.25s-.235-.181-.353-.281-.231-.2-.348-.308-.226-.219-.338-.336-.22-.236-.328-.36-.213-.252-.316-.382-.2-.266-.3-.4-.192-.277-.284-.419-.179-.288-.263-.435c-.038-.068-.078-.135-.114-.2s-.088-.162-.129-.243-.091-.181-.136-.274c-.029-.06-.058-.122-.085-.182-.07-.153-.135-.307-.2-.461s-.119-.311-.171-.465-.1-.311-.146-.465-.084-.309-.118-.461-.066-.306-.091-.456-.046-.3-.061-.446-.027-.294-.032-.435-.006-.279,0-.415.013-.264.027-.394a4.492,4.492,0,0,1,.092-.554,3.461,3.461,0,0,1,.156-.5,2.905,2.905,0,0,1,.217-.441,3.443,3.443,0,0,1,.329-.444h0a2.437,2.437,0,0,1,.339-.072,3.6,3.6,0,0,1,2.15.509,7.8,7.8,0,0,1,2.147,1.751,10.556,10.556,0,0,1,1.77,2.806,8.226,8.226,0,0,1,.733,3.232",
    transform: "translate(-5.486 -6.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80870",
    "data-name": "Path 80870",
    className: "cls-32",
    d: "M72.255,68.906c-.055.187-.109.375-.164.564L66.265,72.8c.054-.188.109-.375.163-.564l5.827-3.332",
    transform: "translate(-5.644 -5.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80871",
    "data-name": "Path 80871",
    className: "cls-33",
    d: "M72.006,68.669,66.179,72l-2.836-2.543L68.687,66.4l.482-.275,2.837,2.543",
    transform: "translate(-5.395 -5.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80872",
    "data-name": "Path 80872",
    className: "cls-49",
    d: "M71.452,89.036l0,0a2.523,2.523,0,0,1-1.853.652,4.119,4.119,0,0,1-1.966-.7,8.41,8.41,0,0,1-1.966-1.721,10.606,10.606,0,0,1-1.644-2.664l-.114-.274a10.83,10.83,0,0,1-.416-1.283,6.326,6.326,0,0,1-.093-2.689,2.9,2.9,0,0,1,.51-1.224c.009-.013.018-.025.027-.038s.038-.048.059-.072a.356.356,0,0,1,.029-.036,2.3,2.3,0,0,1,1.113-.7,3.428,3.428,0,0,0-.33.444,2.914,2.914,0,0,0-.217.442,3.389,3.389,0,0,0-.156.5,4.281,4.281,0,0,0-.093.553c-.014.13-.022.258-.027.4s0,.273,0,.415.016.289.032.434.037.3.061.446.056.3.091.456.074.307.118.461.093.31.146.464.111.312.172.465.127.309.2.461c.027.061.055.122.084.183.045.091.09.182.136.273s.085.163.129.243.076.135.114.2c.084.147.172.292.263.435s.186.281.284.419.2.271.3.4.207.258.316.383.215.243.328.36.223.228.338.336.23.209.348.309.233.19.353.281.236.171.358.25c.08.053.158.1.24.149s.161.093.241.135.163.084.243.121.161.073.241.106.16.063.239.089.158.052.236.074.156.04.233.056.153.03.229.041.151.018.223.024.147.007.22.006.144,0,.213-.009.139-.016.206-.027a1.794,1.794,0,0,0,.2-.043",
    transform: "translate(-5.392 -6.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80873",
    "data-name": "Path 80873",
    className: "cls-23",
    d: "M70.815,76.483c-.055.187-.109.375-.164.564L67.816,74.5c.053-.188.108-.376.162-.563l2.837,2.543",
    transform: "translate(-5.776 -6.298)"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73912",
    "data-name": "Group 73912",
    transform: "translate(62.874 85.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73911",
    "data-name": "Group 73911",
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27218",
    "data-name": "Rectangle 27218",
    className: "cls-101",
    width: 0.676,
    height: 0.696,
    transform: "translate(0 0)"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73914",
    "data-name": "Group 73914",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73913",
    "data-name": "Group 73913",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80875",
    "data-name": "Path 80875",
    className: "cls-26",
    d: "M68.54,66.336,63.2,69.393c-.054.188-.109.375-.163.563l-1.419-1.271,5.827-3.334Z",
    transform: "translate(-5.248 -5.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80876",
    "data-name": "Path 80876",
    className: "cls-23",
    d: "M68.453,93.662c.008.232.017.583.027.816l-.2-.107-.2-.11L65.5,92.785V92.1c.737.422,1.631.489,2.368.911.138.08.172.308.311.387.106.059.161.2.27.261",
    transform: "translate(-5.579 -7.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80877",
    "data-name": "Path 80877",
    className: "cls-32",
    d: "M67.6,64.736c-.054.188-.109.375-.162.564l-5.828,3.333c.055-.188.109-.376.164-.564L67.6,64.736",
    transform: "translate(-5.248 -5.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80878",
    "data-name": "Path 80878",
    className: "cls-33",
    d: "M67.355,64.5l-5.827,3.333-2.837-2.543q2.672-1.529,5.344-3.057l.483-.275q1.419,1.271,2.836,2.543",
    transform: "translate(-4.999 -5.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80879",
    "data-name": "Path 80879",
    className: "cls-23",
    d: "M66.164,72.312c-.054.188-.109.376-.163.564l-2.836-2.544c.053-.188.108-.375.163-.563l2.836,2.543",
    transform: "translate(-5.38 -5.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80880",
    "data-name": "Path 80880",
    className: "cls-26",
    d: "M67.42,74.126l-4.255-3.816L66,72.854q2.913-1.665,5.826-3.332l1.1.984-5.343,3.057c-.054.187-.109.375-.163.563",
    transform: "translate(-5.38 -5.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80881",
    "data-name": "Path 80881",
    className: "cls-41",
    d: "M65.469,74.793l-1.4.8-6.886-3.937,1.521-.87a1.037,1.037,0,0,0,.316-.278,1.622,1.622,0,0,0,.328-.774,2.991,2.991,0,0,0,.03-.4Z",
    transform: "translate(-4.871 -5.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80882",
    "data-name": "Path 80882",
    className: "cls-23",
    d: "M31.13,66.747,60.105,83.318a12.225,12.225,0,0,0,1.272,2q.344.44.729.846c.077.085.155.169.234.252l.008.009A10.652,10.652,0,0,0,64.387,88.1a5.325,5.325,0,0,0,2.652.922,3.58,3.58,0,0,0,1.073-.134l0,.006a3.448,3.448,0,0,1-1.709.242,5.3,5.3,0,0,1-2.083-.737L26.448,66.737a10.518,10.518,0,0,1-3.109-2.84,13.375,13.375,0,0,1-1.981-3.7,9.623,9.623,0,0,1-.57-3.435,4.393,4.393,0,0,1,.809-2.65,3.1,3.1,0,0,1,1.017-.821,3.194,3.194,0,0,0-.926,1.137,5.152,5.152,0,0,0-.469,2.306,9.22,9.22,0,0,0,.264,2.143,9.775,9.775,0,0,0,.825,2.438,12.826,12.826,0,0,0,2.119,3.151q.273.3.568.568l.005.005a8.968,8.968,0,0,0,2.269,1.645,4.329,4.329,0,0,0,2.708.519,2.964,2.964,0,0,0,1.752-1.065l.036-.048.069-.1.033-.049.328.188c-.323.186-.7.4-1.066.61",
    transform: "translate(-1.77 -4.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80883",
    "data-name": "Path 80883",
    className: "cls-23",
    d: "M65.689,75.994a3.1,3.1,0,0,0-1.494.377l.471-.269,1.4-.8,1.052.944a4.407,4.407,0,0,0-1.429-.251",
    transform: "translate(-5.468 -6.414)"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73916",
    "data-name": "Group 73916",
    transform: "translate(58.452 83.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73915",
    "data-name": "Group 73915",
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27220",
    "data-name": "Rectangle 27220",
    className: "cls-103",
    width: 0.595,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73918",
    "data-name": "Group 73918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73917",
    "data-name": "Group 73917",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80885",
    "data-name": "Path 80885",
    className: "cls-26",
    d: "M63.889,62.165l-5.345,3.057-.162.563-1.419-1.273,5.827-3.332Z",
    transform: "translate(-4.852 -5.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80886",
    "data-name": "Path 80886",
    className: "cls-23",
    d: "M63.619,91.024v.682l-2.95-1.686v-.682l2.95,1.687",
    transform: "translate(-5.167 -7.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80887",
    "data-name": "Path 80887",
    className: "cls-41",
    d: "M61.068,84.514,32.093,67.943l1.066-.61L60.391,82.908l.092.263a12.265,12.265,0,0,0,.585,1.343",
    transform: "translate(-2.734 -5.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80888",
    "data-name": "Path 80888",
    className: "cls-32",
    d: "M62.954,60.566c-.055.188-.109.375-.164.564l-5.827,3.332c.055-.188.109-.375.164-.564l5.827-3.332",
    transform: "translate(-4.852 -5.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80889",
    "data-name": "Path 80889",
    className: "cls-27",
    d: "M62.705,60.329l-5.827,3.332-2.837-2.543,5.345-3.056.482-.275,2.837,2.543",
    transform: "translate(-4.603 -4.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80890",
    "data-name": "Path 80890",
    className: "cls-44",
    d: "M63.119,78.3l-.024.039c-.016.026-.031.051-.046.079s-.016.026-.023.039c0-.223.006-.445.01-.668,0-.108,0-.216.006-.323.014-.023.028-.044.043-.067.029-.045.059-.088.09-.131.016-.021.032-.043.048-.063a2.9,2.9,0,0,1,.858-.76l.013-.007a3.1,3.1,0,0,1,1.494-.377,4.406,4.406,0,0,1,1.429.251h0l2.166,1.943.566.507a12.915,12.915,0,0,1,2.6,3.582,12.211,12.211,0,0,1,1.133,3.51,6.442,6.442,0,0,1-.118,2.919,3.431,3.431,0,0,1-1.218,1.821,2.409,2.409,0,0,1-.439.242l0-.005a3.6,3.6,0,0,1-1.072.133,5.332,5.332,0,0,1-2.653-.922,10.682,10.682,0,0,1-2.039-1.671l-.008-.01c-.079-.083-.156-.167-.234-.252a10.287,10.287,0,0,0,1.584,1.359,5.23,5.23,0,0,0,2.351.986A2.984,2.984,0,0,0,72,89.77a4.29,4.29,0,0,0,1.023-3,9.651,9.651,0,0,0-.9-3.876,12.531,12.531,0,0,0-2.167-3.343,8.4,8.4,0,0,0-2.63-2.027,3.874,3.874,0,0,0-2.621-.4,2.8,2.8,0,0,0-1.584,1.17",
    transform: "translate(-5.368 -6.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80891",
    "data-name": "Path 80891",
    className: "cls-44",
    d: "M60.4,76.127c0,.108,0,.215-.006.323,0,.223-.008.445-.011.668l-28.4-16.242c.278-.172.559-.347.837-.521Z",
    transform: "translate(-2.724 -5.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80892",
    "data-name": "Path 80892",
    className: "cls-23",
    d: "M61.514,68.142c-.055.187-.109.375-.164.564q-1.418-1.273-2.836-2.544c.054-.188.108-.376.163-.563l2.837,2.543",
    transform: "translate(-4.984 -5.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80893",
    "data-name": "Path 80893",
    className: "cls-23",
    d: "M59.09,80.778,50.982,76.14,41.463,70.7l-8.1-4.63,1.019-.584L58.968,79.542h0c0,.081.005.162.01.244s.013.177.02.267.018.183.028.275c.016.147.038.3.062.449",
    transform: "translate(-2.842 -5.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80894",
    "data-name": "Path 80894",
    className: "cls-41",
    d: "M59.063,79.391,34.483,65.332c.017-.091.035-.184.048-.278s.027-.192.039-.29.018-.2.026-.3.011-.2.013-.306c0-.061,0-.122,0-.184v-.265l6.947,3.974,9.519,5.444,8.108,4.637c-.025.124-.045.251-.062.378-.01.081-.02.161-.028.242s-.014.163-.02.245-.008.164-.011.246,0,.166,0,.249,0,.166,0,.252v.016Z",
    transform: "translate(-2.937 -5.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80895",
    "data-name": "Path 80895",
    className: "cls-26",
    d: "M59.238,58l-5.344,3.056c-.054.188-.109.376-.163.563l-1.418-1.272,5.826-3.333Z",
    transform: "translate(-4.456 -4.856)"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73920",
    "data-name": "Group 73920",
    transform: "translate(54.029 80.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73919",
    "data-name": "Group 73919",
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27222",
    "data-name": "Rectangle 27222",
    className: "cls-105",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73922",
    "data-name": "Group 73922",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73921",
    "data-name": "Group 73921",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80897",
    "data-name": "Path 80897",
    className: "cls-23",
    d: "M54.7,65.076l4.342,3.893a2.99,2.99,0,0,1-.03.4,1.618,1.618,0,0,1-.328.774,1.04,1.04,0,0,1-.316.279l-1.521.87-.069-.04a1.365,1.365,0,0,0,.1-.135,1.986,1.986,0,0,0,.263-1.086,4.891,4.891,0,0,0-1.1-2.83,3.278,3.278,0,0,0-1.675-1.347,1.576,1.576,0,0,0-1.154.07h0q.742-.423,1.483-.848",
    transform: "translate(-4.533 -5.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80898",
    "data-name": "Path 80898",
    className: "cls-23",
    d: "M58.783,88.259v.682l-2.948-1.686v-.682l2.948,1.686Z",
    transform: "translate(-4.756 -7.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80899",
    "data-name": "Path 80899",
    className: "cls-32",
    d: "M58.3,56.395l-.164.564-5.827,3.333c.054-.188.109-.376.163-.564L58.3,56.395",
    transform: "translate(-4.456 -4.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80900",
    "data-name": "Path 80900",
    className: "cls-27",
    d: "M58.053,56.158l-5.827,3.333q-1.418-1.272-2.836-2.543l5.344-3.057.482-.275,2.837,2.543",
    transform: "translate(-4.207 -4.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80901",
    "data-name": "Path 80901",
    className: "cls-23",
    d: "M56.863,63.971c-.055.188-.109.376-.164.564l-2.835-2.544c.053-.187.108-.375.162-.563l2.837,2.543",
    transform: "translate(-4.588 -5.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80902",
    "data-name": "Path 80902",
    className: "cls-23",
    d: "M39.349,62.219a4.7,4.7,0,0,0,2.09.749l9.334,5.339h0a4.466,4.466,0,0,0,.29.729,4.918,4.918,0,0,0,.892,1.239,3.109,3.109,0,0,0,1,.7,1.717,1.717,0,0,0,.663.147c.136.011.272.02.408.029h.009a1.341,1.341,0,0,0,.4-.026,1.224,1.224,0,0,0,.617-.375l.069.039L62,74.727l-.471.27L61.517,75a2.908,2.908,0,0,0-.858.759c-.016.021-.033.042-.048.064-.03.043-.06.086-.09.131-.015.023-.029.044-.043.067L32.9,60.253l1.019-.583.876-.5,2.617,1.5c.107.119.217.236.33.349a6.316,6.316,0,0,0,1.466,1.129c.046.027.091.049.138.073Z",
    transform: "translate(-2.802 -5.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80903",
    "data-name": "Path 80903",
    className: "cls-47",
    d: "M53.135,66.9l-.015.008a1.084,1.084,0,0,0-.41.4,1.632,1.632,0,0,0-.141,1.02,3.736,3.736,0,0,0,.375,1.239,4.2,4.2,0,0,0,.763,1.058,2.671,2.671,0,0,0,.851.6,1.254,1.254,0,0,0,.771.1,1.036,1.036,0,0,0,.607-.479.805.805,0,0,0,.045-.089A1.5,1.5,0,0,0,56.1,70.1a2.572,2.572,0,0,0-.021-.265,3.656,3.656,0,0,0-.376-1.239,4.134,4.134,0,0,0-.762-1.058,2.622,2.622,0,0,0-.851-.6,1.66,1.66,0,0,0-.4-.116.967.967,0,0,0-.367.016.823.823,0,0,0-.181.07m-.7.109,0,0a1.208,1.208,0,0,1,.707-.558,1.3,1.3,0,0,1,.7.046c.069.021.135.046.2.072a3.1,3.1,0,0,1,1,.7,4.851,4.851,0,0,1,.892,1.239,4.343,4.343,0,0,1,.44,1.449c.013.1.021.207.024.311a1.641,1.641,0,0,1-.188.882,1.2,1.2,0,0,1-.708.559c-.03.007-.06.014-.091.019a1.128,1.128,0,0,1-.148.012,1.714,1.714,0,0,1-.662-.148,3.107,3.107,0,0,1-1-.7,4.922,4.922,0,0,1-.893-1.239,4.424,4.424,0,0,1-.289-.73,4.3,4.3,0,0,1-.15-.719,1.918,1.918,0,0,1,.165-1.193",
    transform: "translate(-4.45 -5.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80904",
    "data-name": "Path 80904",
    className: "cls-48",
    d: "M56.221,70.132a1.5,1.5,0,0,1-.116.665l-.013-.005c-.029,0-.061-.01-.091-.016s-.062-.014-.092-.023-.062-.018-.093-.028-.063-.023-.094-.036-.063-.027-.1-.042-.063-.03-.1-.048-.063-.035-.1-.053l-.094-.059c-.048-.03-.093-.063-.142-.1s-.092-.071-.139-.111-.091-.078-.137-.122-.089-.087-.134-.133-.087-.093-.129-.142-.084-.1-.125-.152-.08-.1-.118-.159-.075-.109-.112-.166-.071-.113-.1-.171-.065-.117-.1-.177-.059-.12-.087-.179-.054-.122-.079-.183-.048-.123-.068-.183-.04-.123-.058-.184-.033-.123-.047-.182-.027-.121-.036-.179-.018-.119-.025-.177-.01-.115-.012-.172,0-.109,0-.164,0-.1.01-.156a1.789,1.789,0,0,1,.036-.219,1.515,1.515,0,0,1,.062-.2l0-.026a1.582,1.582,0,0,1,.4.116,2.62,2.62,0,0,1,.851.6,4.138,4.138,0,0,1,.762,1.059,3.656,3.656,0,0,1,.376,1.239,2.573,2.573,0,0,1,.021.265",
    transform: "translate(-4.573 -5.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80905",
    "data-name": "Path 80905",
    className: "cls-49",
    d: "M53.15,66.948l.014-.007a.789.789,0,0,1,.182-.07.945.945,0,0,1,.366-.015l0,.025a1.438,1.438,0,0,0-.062.2,1.639,1.639,0,0,0-.036.218c-.005.053-.01.1-.011.156s0,.109,0,.164.007.115.013.172.015.117.025.176.021.12.036.18.029.122.046.182.038.123.058.184.045.123.069.183.05.123.078.182.057.121.087.18.064.119.1.177.068.115.1.171.074.112.113.166.078.108.118.159.082.1.124.152.085.1.13.142.088.09.133.133.091.082.138.122.091.076.139.111.093.068.142.1c.032.021.062.04.094.059l.1.053c.032.016.064.034.1.048s.065.029.1.042l.094.036.093.028c.03.009.061.016.091.023l.091.016.014.005a.906.906,0,0,1-.046.089,1.029,1.029,0,0,1-.607.478,1.245,1.245,0,0,1-.77-.1,2.644,2.644,0,0,1-.851-.6,4.225,4.225,0,0,1-.763-1.059,3.725,3.725,0,0,1-.376-1.239,1.636,1.636,0,0,1,.142-1.019,1.073,1.073,0,0,1,.41-.4",
    transform: "translate(-4.478 -5.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80906",
    "data-name": "Path 80906",
    className: "cls-18",
    d: "M55.952,72.263l-.408-.029a1.1,1.1,0,0,0,.147-.012,1.646,1.646,0,0,0,.261.041",
    transform: "translate(-4.731 -6.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80907",
    "data-name": "Path 80907",
    className: "cls-26",
    d: "M54.587,53.824q-2.673,1.53-5.343,3.057c-.055.187-.109.375-.164.563l-1.418-1.272,5.827-3.333Z",
    transform: "translate(-4.06 -4.501)"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73924",
    "data-name": "Group 73924",
    transform: "translate(49.605 78.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73923",
    "data-name": "Group 73923",
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27224",
    "data-name": "Rectangle 27224",
    className: "cls-107",
    width: 0.597,
    height: 0.682
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73926",
    "data-name": "Group 73926",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73925",
    "data-name": "Group 73925",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80909",
    "data-name": "Path 80909",
    className: "cls-41",
    d: "M51.777,65.91l-.192.4,0,0A1.908,1.908,0,0,0,51.42,67.5a4.426,4.426,0,0,0,.149.72h0l-9.334-5.339a2.277,2.277,0,0,0,.668-.052,2.039,2.039,0,0,0,.609-.26l0,.005q.947-.543,1.9-1.085a2.041,2.041,0,0,0,.609-.538,3.129,3.129,0,0,0,.636-1.5,5.885,5.885,0,0,0,.058-.819c0-.041,0-.081,0-.123,0-.081,0-.163-.009-.244,0-.041-.005-.081-.009-.122l7.07,6.339-1.483.848h0l-.067.04a1.28,1.28,0,0,0-.435.536Z",
    transform: "translate(-3.597 -4.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80910",
    "data-name": "Path 80910",
    className: "cls-23",
    d: "M53.948,85.494v.682L51,84.49v-.682Z",
    transform: "translate(-4.344 -7.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80911",
    "data-name": "Path 80911",
    className: "cls-32",
    d: "M53.651,52.225c-.054.188-.109.375-.163.564L47.661,56.12l.164-.564,5.827-3.332",
    transform: "translate(-4.059 -4.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80912",
    "data-name": "Path 80912",
    className: "cls-27",
    d: "M50.083,49.72l.484-.276L53.4,51.988,47.576,55.32,44.74,52.777l5.343-3.056",
    transform: "translate(-3.811 -4.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80913",
    "data-name": "Path 80913",
    className: "cls-23",
    d: "M52.211,59.8c-.054.187-.109.375-.163.563l-2.836-2.543c.054-.188.108-.376.163-.563q1.419,1.271,2.836,2.543",
    transform: "translate(-4.192 -4.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80914",
    "data-name": "Path 80914",
    className: "cls-26",
    d: "M49.936,49.654l-5.343,3.056c-.055.188-.109.376-.164.563L43.012,52l5.826-3.334Z",
    transform: "translate(-3.664 -4.145)"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73928",
    "data-name": "Group 73928",
    transform: "translate(45.182 75.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73927",
    "data-name": "Group 73927",
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27226",
    "data-name": "Rectangle 27226",
    className: "cls-109",
    width: 0.596,
    height: 0.681,
    transform: "translate(0 0)"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73930",
    "data-name": "Group 73930",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73929",
    "data-name": "Group 73929",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80916",
    "data-name": "Path 80916",
    className: "cls-32",
    d: "M49,48.054l-.164.564L43.011,51.95h0c.055-.188.11-.375.164-.563L49,48.054",
    transform: "translate(-3.663 -4.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80917",
    "data-name": "Path 80917",
    className: "cls-27",
    d: "M48.734,47.829l-5.827,3.333-.79-.709-.038-.035q-.309-.287-.626-.548a12.46,12.46,0,0,0-1.581-1.12l5.218-2.984.609-.349a12.389,12.389,0,0,1,1.58,1.12c.212.175.42.356.627.548l.025.024.006.005.8.714",
    transform: "translate(-3.396 -3.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80918",
    "data-name": "Path 80918",
    className: "cls-23",
    d: "M49.114,82.73v.681q-1.475-.843-2.949-1.685v-.682l2.949,1.686Z",
    transform: "translate(-3.932 -6.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80919",
    "data-name": "Path 80919",
    className: "cls-23",
    d: "M47.561,55.63l-.164.564L44.561,53.65c.054-.187.108-.375.163-.563l2.837,2.543",
    transform: "translate(-3.795 -4.522)"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73932",
    "data-name": "Group 73932",
    transform: "translate(40.76 73.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73931",
    "data-name": "Group 73931",
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27228",
    "data-name": "Rectangle 27228",
    className: "cls-111",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73934",
    "data-name": "Group 73934",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73933",
    "data-name": "Group 73933",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80921",
    "data-name": "Path 80921",
    className: "cls-44",
    d: "M41.646,62.27a4.7,4.7,0,0,1-2.09-.749c.1.052.21.1.32.148a2.829,2.829,0,0,0,1.744.228,2.33,2.33,0,0,0,1.371-1.083,3.187,3.187,0,0,0,.364-1.705c-.005-.2-.022-.4-.046-.6a8.393,8.393,0,0,0-.85-2.8,9.437,9.437,0,0,0-1.726-2.4,5.979,5.979,0,0,0-1.926-1.349,2.817,2.817,0,0,0-1.744-.229,2.325,2.325,0,0,0-1.371,1.083,2.934,2.934,0,0,0-.362,1.371c0-.055,0-.11,0-.167a4.507,4.507,0,0,1,.2-1.4,2.721,2.721,0,0,1,.689-1.144,2.17,2.17,0,0,1,.873-.5v0a3.6,3.6,0,0,1,.523.084,6.574,6.574,0,0,1,2.43,1.114,11.33,11.33,0,0,1,1.029.857l1.751,1.571c.12.2.234.4.342.6a9.766,9.766,0,0,1,.921,2.562,6.571,6.571,0,0,1,.141,1.352,4.068,4.068,0,0,1-.3,1.66,2.713,2.713,0,0,1-1.009,1.188,2.041,2.041,0,0,1-.609.261,2.277,2.277,0,0,1-.668.052",
    transform: "translate(-3.009 -4.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80922",
    "data-name": "Path 80922",
    className: "cls-32",
    d: "M44.074,45.323l-5.827,3.333c-.036-.244-.071-.488-.109-.733l5.827-3.333q.055.366.109.733",
    transform: "translate(-3.248 -3.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80923",
    "data-name": "Path 80923",
    className: "cls-23",
    d: "M44.279,79.964v.682L41.33,78.959v-.682Z",
    transform: "translate(-3.52 -6.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80924",
    "data-name": "Path 80924",
    className: "cls-47",
    d: "M42.192,60.661a2.1,2.1,0,0,0,.269-.363,2.723,2.723,0,0,0,.311-1.457c0-.172-.019-.344-.038-.514a7.17,7.17,0,0,0-.728-2.4,8.031,8.031,0,0,0-1.476-2.048,5.109,5.109,0,0,0-1.646-1.155,2.487,2.487,0,0,0-1.407-.213c-.028.005-.057.011-.084.018a1.99,1.99,0,0,0-1.172.926,3.157,3.157,0,0,0-.272,1.972,7.126,7.126,0,0,0,.726,2.4,8.037,8.037,0,0,0,1.476,2.048A5.121,5.121,0,0,0,39.8,61.03a2.41,2.41,0,0,0,1.49.195,1.883,1.883,0,0,0,.9-.564m-4.572-.628a9.4,9.4,0,0,1-1.4-2.046,8.366,8.366,0,0,1-.851-2.8c-.023-.2-.039-.4-.045-.6v-.267c0-.022,0-.045,0-.066a2.93,2.93,0,0,1,.361-1.371,2.326,2.326,0,0,1,1.371-1.084,2.823,2.823,0,0,1,1.745.229,6.006,6.006,0,0,1,1.925,1.349,9.456,9.456,0,0,1,1.725,2.4,8.356,8.356,0,0,1,.85,2.8c.024.2.042.4.047.6a3.186,3.186,0,0,1-.365,1.705,2.324,2.324,0,0,1-1.371,1.083,2.813,2.813,0,0,1-1.743-.228c-.111-.046-.216-.1-.321-.148h0c-.047-.023-.091-.047-.138-.072a6.365,6.365,0,0,1-1.466-1.13c-.113-.113-.222-.23-.329-.349",
    transform: "translate(-3.009 -4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80925",
    "data-name": "Path 80925",
    className: "cls-23",
    d: "M45.519,61.216l-1.9,1.085,0-.005a2.723,2.723,0,0,0,1.01-1.189,4.078,4.078,0,0,0,.3-1.66,6.625,6.625,0,0,0-.141-1.351,9.774,9.774,0,0,0-.922-2.562c-.107-.2-.221-.405-.341-.6L46.8,57.872h0l.008.122c0,.081.007.163.009.244,0,.041,0,.081,0,.123a5.762,5.762,0,0,1-.058.82,3.128,3.128,0,0,1-.635,1.5,2.042,2.042,0,0,1-.61.538",
    transform: "translate(-3.707 -4.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80926",
    "data-name": "Path 80926",
    className: "cls-48",
    d: "M42.921,58.91a2.725,2.725,0,0,1-.312,1.457,2.044,2.044,0,0,1-.268.363c-.04.006-.081.011-.122.015s-.109.006-.163.007-.111,0-.167-.005-.113-.01-.171-.018-.116-.018-.175-.031-.119-.026-.177-.043-.121-.036-.181-.056-.122-.043-.183-.069-.123-.051-.184-.081-.123-.059-.185-.092-.123-.067-.184-.1-.122-.073-.184-.113c-.092-.061-.181-.123-.273-.191s-.179-.138-.27-.214-.177-.154-.265-.237-.173-.166-.258-.256-.168-.179-.252-.275-.161-.191-.24-.293-.155-.2-.23-.306-.146-.211-.216-.321-.137-.22-.2-.332-.126-.226-.186-.34-.115-.231-.169-.348-.1-.235-.15-.353-.091-.237-.132-.354-.078-.238-.111-.355-.065-.237-.091-.352-.049-.234-.069-.349-.036-.23-.047-.34-.02-.224-.025-.332,0-.212,0-.317.009-.2.019-.3a3.477,3.477,0,0,1,.071-.423,2.678,2.678,0,0,1,.119-.383,2.275,2.275,0,0,1,.165-.338,1.9,1.9,0,0,1,.172-.242v0a2.479,2.479,0,0,1,1.407.213,5.109,5.109,0,0,1,1.646,1.155A8.031,8.031,0,0,1,42.154,56a7.168,7.168,0,0,1,.727,2.4c.02.17.035.342.039.514",
    transform: "translate(-3.158 -4.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80927",
    "data-name": "Path 80927",
    className: "cls-23",
    d: "M42.115,50.763l.79.709c-.054.188-.109.374-.164.563l-.589.29c-.039-.035-2.04-2.192-2.292-2.337,0-.221.006-.706.01-.927a12.46,12.46,0,0,1,1.581,1.12c.21.174.42.357.626.548l.038.035",
    transform: "translate(-3.395 -4.179)"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73936",
    "data-name": "Group 73936",
    transform: "translate(36.337 70.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73935",
    "data-name": "Group 73935",
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27230",
    "data-name": "Rectangle 27230",
    className: "cls-113",
    width: 0.595,
    height: 0.682
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73938",
    "data-name": "Group 73938",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73937",
    "data-name": "Group 73937",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80929",
    "data-name": "Path 80929",
    className: "cls-32",
    d: "M39.406,44.449c.107.253.068.162.175.414l-4.76,2.722c.049.115.1.23.145.345l-1.067.611c-.107-.252-.213-.507-.321-.759l5.827-3.333",
    transform: "translate(-2.86 -3.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80930",
    "data-name": "Path 80930",
    className: "cls-18",
    d: "M39.175,44.449l-5.827,3.333-2.486.393,4.76-2.722,1.068-.611,2.486-.393",
    transform: "translate(-2.629 -3.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80931",
    "data-name": "Path 80931",
    className: "cls-23",
    d: "M39.444,77.2v.682L36.5,76.194v-.682Z",
    transform: "translate(-3.109 -6.432)"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73940",
    "data-name": "Group 73940",
    transform: "translate(33.586 41.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73939",
    "data-name": "Group 73939",
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27232",
    "data-name": "Rectangle 27232",
    className: "cls-115",
    width: 8.107,
    height: 4.02,
    transform: "translate(0 0)"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73942",
    "data-name": "Group 73942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73941",
    "data-name": "Group 73941",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80933",
    "data-name": "Path 80933",
    className: "cls-49",
    d: "M37.533,52.59a1.983,1.983,0,0,0-.172.242,2.222,2.222,0,0,0-.165.338,2.68,2.68,0,0,0-.12.383,3.338,3.338,0,0,0-.07.423c-.01.1-.017.2-.02.3s0,.209,0,.316.013.222.025.332.027.228.048.34.042.233.069.349.057.236.091.352.071.237.112.355.084.238.132.355.1.236.15.352.11.233.168.348.123.229.187.34.132.223.2.333.142.215.216.32.15.207.23.307.157.2.24.293.166.186.252.274.169.174.257.257.176.16.265.236.179.146.271.214.18.131.273.191c.062.04.122.078.183.114s.123.07.185.1.124.065.185.092.124.057.184.081.123.048.182.069.123.039.182.056.119.031.177.043a1.711,1.711,0,0,0,.175.031c.058.008.115.016.17.019s.113.005.167.005.11,0,.164-.007.081-.009.122-.016a1.891,1.891,0,0,1-.9.564,2.408,2.408,0,0,1-1.49-.195,5.1,5.1,0,0,1-1.646-1.155A8.015,8.015,0,0,1,36.73,57.9,7.149,7.149,0,0,1,36,55.5a3.158,3.158,0,0,1,.273-1.972,1.99,1.99,0,0,1,1.172-.926c.027-.007.056-.013.084-.018Z",
    transform: "translate(-3.063 -4.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80934",
    "data-name": "Path 80934",
    className: "cls-41",
    d: "M35.763,51a3.355,3.355,0,0,1,.8-.03v0a2.176,2.176,0,0,0-.873.5A2.712,2.712,0,0,0,35,52.614a4.5,4.5,0,0,0-.2,1.4v.232c0,.085,0,.167,0,.252v.015c.005.2.022.4.046.6a8.366,8.366,0,0,0,.851,2.8,9.4,9.4,0,0,0,1.4,2.046l-2.616-1.5a13.364,13.364,0,0,0-.9-1.925A12.9,12.9,0,0,0,30.9,53.238a8.149,8.149,0,0,0-1.759-1.2Z",
    transform: "translate(-2.482 -4.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80935",
    "data-name": "Path 80935",
    className: "cls-32",
    d: "M35.33,45.1c.107.252.068.161.175.414l-4.76,2.722c.049.114.1.23.146.345l-1.067.611h0c-.107-.254-.213-.507-.321-.759L35.33,45.1",
    transform: "translate(-2.513 -3.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80936",
    "data-name": "Path 80936",
    className: "cls-18",
    d: "M35.1,45.1l-5.827,3.333-2.486.393,4.76-2.723,1.068-.61L35.1,45.1",
    transform: "translate(-2.281 -3.841)"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73944",
    "data-name": "Group 73944",
    transform: "translate(31.913 68.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73943",
    "data-name": "Group 73943",
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27234",
    "data-name": "Rectangle 27234",
    className: "cls-117",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73946",
    "data-name": "Group 73946",
    transform: "translate(31.04 44.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73945",
    "data-name": "Group 73945",
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27235",
    "data-name": "Rectangle 27235",
    className: "cls-119",
    width: 1.242,
    height: 0.61,
    transform: "translate(0 0)"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73948",
    "data-name": "Group 73948",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73947",
    "data-name": "Group 73947",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80939",
    "data-name": "Path 80939",
    className: "cls-18",
    d: "M34.937,47.561,39.7,44.839l1.069-.611.159-.026a4.575,4.575,0,0,1,.519-.044,5.1,5.1,0,0,1,.723.03,6.6,6.6,0,0,1,1.528.365l-5.827,3.332a6.651,6.651,0,0,0-1.528-.365,5.232,5.232,0,0,0-.722-.03,5.057,5.057,0,0,0-.52.045l-.159.026",
    transform: "translate(-2.976 -3.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80940",
    "data-name": "Path 80940",
    className: "cls-23",
    d: "M34.153,58.571l-.877.5q-.508.292-1.019.583l-.136-.349a14.358,14.358,0,0,0-1.176-2.274,11.561,11.561,0,0,0-3.672-3.614,4.462,4.462,0,0,0-1.917-.72v-.005l3.464-.548a8.116,8.116,0,0,1,1.759,1.2,12.9,12.9,0,0,1,2.675,3.306,13.364,13.364,0,0,1,.9,1.925",
    transform: "translate(-2.16 -4.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80941",
    "data-name": "Path 80941",
    className: "cls-23",
    d: "M34.609,74.434v.682l-2.948-1.686v-.682l2.948,1.687",
    transform: "translate(-2.697 -6.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80942",
    "data-name": "Path 80942",
    className: "cls-23",
    d: "M34.516,63.647v.265c0,.062,0,.123,0,.184,0,.1-.006.206-.014.306s-.015.2-.025.3-.024.195-.039.29-.031.188-.048.279l-1.02.583c.025-.122.045-.246.063-.371A7.181,7.181,0,0,0,33.5,64.5c0-.166,0-.338-.015-.515s-.027-.36-.05-.546c-.018-.145-.038-.293-.063-.445l1.148.657",
    transform: "translate(-2.842 -5.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80943",
    "data-name": "Path 80943",
    className: "cls-23",
    d: "M33.348,48.093c.108.252.214.506.321.758l-2.486.393-.175-.413c-.048-.115-.1-.231-.146-.346l2.486-.392",
    transform: "translate(-2.629 -4.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80944",
    "data-name": "Path 80944",
    className: "cls-44",
    d: "M31.771,59.356l.137.349c-.279.176-.559.35-.838.521l-.06-.169a12.014,12.014,0,0,0-1.854-3.319,10.086,10.086,0,0,0-2.323-2.161,4.769,4.769,0,0,0-2.368-.9,2.96,2.96,0,0,0-2.284.865,4.381,4.381,0,0,0-.8,3.109,8.47,8.47,0,0,0,.14,1.187,9.22,9.22,0,0,1-.264-2.143,5.15,5.15,0,0,1,.469-2.306,3.186,3.186,0,0,1,.927-1.137A2.644,2.644,0,0,1,23.419,53l.156-.027,1.431-.226v.005a4.444,4.444,0,0,1,1.917.719A11.555,11.555,0,0,1,30.6,57.082a14.393,14.393,0,0,1,1.175,2.274",
    transform: "translate(-1.811 -4.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80945",
    "data-name": "Path 80945",
    className: "cls-32",
    d: "M31.255,45.74c.059.137.117.276.175.414q-2.379,1.361-4.76,2.723c.049.114.1.23.146.345l-1.068.61c-.107-.253-.213-.506-.321-.759l5.827-3.332",
    transform: "translate(-2.166 -3.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80946",
    "data-name": "Path 80946",
    className: "cls-18",
    d: "M31.024,45.74,25.2,49.072l-2.486.394q2.364-1.353,4.728-2.7l1.1-.63,2.486-.392",
    transform: "translate(-1.934 -3.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80947",
    "data-name": "Path 80947",
    className: "cls-48",
    d: "M31.035,62.879a5.525,5.525,0,0,1-.031.589,3.728,3.728,0,0,1-.3,1.138,2.538,2.538,0,0,1-.3.507c-.005.008-.012.016-.017.023l-.038.048-.018.022a1.543,1.543,0,0,1-.106.113c-.06.016-.092.021-.156.032s-.134.02-.2.026-.137.009-.207.009-.142,0-.212-.006-.145-.013-.219-.023-.148-.024-.222-.039-.152-.035-.227-.056-.154-.045-.231-.07-.155-.057-.232-.087-.156-.067-.234-.1-.157-.077-.236-.118-.156-.085-.235-.132-.155-.093-.233-.145c-.118-.077-.231-.156-.348-.243s-.23-.176-.344-.274-.225-.194-.338-.3-.22-.213-.329-.328-.215-.229-.319-.35-.206-.244-.306-.372-.2-.258-.292-.392-.186-.27-.275-.409-.174-.279-.257-.423-.161-.288-.236-.435-.147-.295-.215-.443-.133-.3-.192-.449-.117-.3-.168-.452-.1-.3-.141-.452-.082-.3-.115-.448-.065-.3-.088-.444-.046-.293-.06-.435-.026-.285-.031-.423-.007-.271,0-.4.013-.259.026-.386a4.269,4.269,0,0,1,.091-.539,3.409,3.409,0,0,1,.152-.488,2.813,2.813,0,0,1,.211-.431,3.25,3.25,0,0,1,.306-.406,2.473,2.473,0,0,1,.561-.1,3.7,3.7,0,0,1,2.005.6,7.851,7.851,0,0,1,2,1.689,10.369,10.369,0,0,1,1.662,2.663l.073.178q.145.351.261.716a8.085,8.085,0,0,1,.328,1.486,6.22,6.22,0,0,1,.048.759",
    transform: "translate(-1.986 -4.666)"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73950",
    "data-name": "Group 73950",
    transform: "translate(27.313 44.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73949",
    "data-name": "Group 73949",
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27237",
    "data-name": "Rectangle 27237",
    className: "cls-121",
    width: 1.241,
    height: 0.61,
    transform: "translate(0 0)"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73952",
    "data-name": "Group 73952",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73951",
    "data-name": "Group 73951",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80949",
    "data-name": "Path 80949",
    className: "cls-49",
    d: "M29.966,65.361a1.391,1.391,0,0,0,.156-.033,2.307,2.307,0,0,1-1.261.628,3.412,3.412,0,0,1-2.041-.435,7.229,7.229,0,0,1-2.062-1.615,10.581,10.581,0,0,1-1.734-2.614,8.34,8.34,0,0,1-.815-3,3.817,3.817,0,0,1,.542-2.582A2.422,2.422,0,0,1,24,54.894a3.184,3.184,0,0,0-.306.406,2.8,2.8,0,0,0-.211.43,3.582,3.582,0,0,0-.152.489,4.242,4.242,0,0,0-.091.539c-.013.127-.021.252-.025.385s0,.266,0,.4.016.282.031.423.036.289.06.434.054.3.088.444.072.3.115.449.091.3.142.452.107.3.167.452.124.3.192.449.14.3.215.442.154.292.236.435.168.284.257.423.18.274.275.409.192.263.292.391.2.252.306.372.21.238.319.351.217.221.329.327.223.2.338.3.226.186.343.273.23.166.348.243c.079.051.155.1.233.145s.156.091.235.132.159.081.236.118.157.07.234.1.156.061.232.087.155.05.231.071.152.039.227.055.149.029.222.039.146.018.219.024.143.006.212.006.14,0,.207-.009.136-.015.2-.026",
    transform: "translate(-1.89 -4.676)"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73954",
    "data-name": "Group 73954",
    transform: "translate(27.491 65.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73953",
    "data-name": "Group 73953",
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27239",
    "data-name": "Rectangle 27239",
    className: "cls-123",
    width: 0.596,
    height: 0.682,
    transform: "translate(0 0)"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73956",
    "data-name": "Group 73956",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73955",
    "data-name": "Group 73955",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80951",
    "data-name": "Path 80951",
    className: "cls-23",
    d: "M29.774,71.59v.682L27.01,70.691c-.062-.035-.129-.074-.2-.113l.011-.676c.046.027.282-.869.327-.843.016.009.214.2.23.211.123.071.2.138.32.208.062.035.238.194.3.228Z",
    transform: "translate(-2.284 -5.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80952",
    "data-name": "Path 80952",
    className: "cls-23",
    d: "M29.272,48.738c.108.252.214.5.321.758l-2.486.393c-.059-.138-.116-.276-.175-.414-.048-.115-.1-.231-.146-.345l2.486-.393",
    transform: "translate(-2.281 -4.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80953",
    "data-name": "Path 80953",
    className: "cls-32",
    d: "M27.153,46.508l.167.32-4.728,2.7c.063.145.125.293.187.439l-1.065.61-.014-.027c-.124-.238-.251-.475-.375-.714l5.827-3.333",
    transform: "translate(-1.816 -3.961)"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73958",
    "data-name": "Group 73958",
    transform: "translate(23.583 45.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73957",
    "data-name": "Group 73957",
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27241",
    "data-name": "Rectangle 27241",
    className: "cls-125",
    width: 1.243,
    height: 0.61,
    transform: "translate(0 0)"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73960",
    "data-name": "Group 73960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73959",
    "data-name": "Group 73959",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80955",
    "data-name": "Path 80955",
    className: "cls-23",
    d: "M22.9,50.215q-.092-.221-.186-.44l2.486-.393.321.758-2.486.394-.135-.319",
    transform: "translate(-1.934 -4.206)"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73962",
    "data-name": "Group 73962",
    transform: "translate(22.95 62.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73961",
    "data-name": "Group 73961",
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27243",
    "data-name": "Rectangle 27243",
    className: "cls-127",
    width: 0.505,
    height: 0.588,
    transform: "translate(0 0)"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73964",
    "data-name": "Group 73964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73963",
    "data-name": "Group 73963",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80957",
    "data-name": "Path 80957",
    className: "cls-23",
    d: "M24.97,68.466l-.151.687a16.776,16.776,0,0,1-2.891-3.132l.347-.356c.016.022.3-.195.32-.173.066.092.07.139.14.231.12.16.238.056.363.21,0,.005.033.215.038.22.041.051.156.027.2.077.014.016.091.171.1.188a13.625,13.625,0,0,0,1.532,2.048",
    transform: "translate(-1.868 -5.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80958",
    "data-name": "Path 80958",
    className: "cls-10",
    d: "M21.7,50.931c0,.008.009.018.015.027a3.365,3.365,0,0,0-.4.195l.385-.221",
    transform: "translate(-1.815 -4.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80959",
    "data-name": "Path 80959",
    className: "cls-47",
    d: "M33.5,62.861,32.347,62.2c.025.152.046.3.063.445.023.187.039.37.05.546s.015.349.015.516a7.017,7.017,0,0,1-.065.985c-.017.125-.038.25-.063.371l8.1,4.631,9.519,5.443q4.055,2.319,8.108,4.638c-.025-.153-.045-.3-.062-.449-.01-.092-.019-.185-.028-.275s-.014-.179-.02-.267-.008-.164-.01-.244v-.016c0-.085,0-.17,0-.252s0-.167,0-.25.006-.164.011-.245.013-.164.02-.245.018-.162.028-.242c.017-.127.038-.253.062-.378l-8.108-4.637-9.519-5.444L33.5,62.861M23.935,54.8a2.421,2.421,0,0,0-1.251.821,3.812,3.812,0,0,0-.542,2.582,8.321,8.321,0,0,0,.814,3,10.584,10.584,0,0,0,1.735,2.614,7.238,7.238,0,0,0,2.061,1.615,3.416,3.416,0,0,0,2.042.435,2.31,2.31,0,0,0,1.261-.628,1.527,1.527,0,0,0,.105-.113l.019-.022.037-.047c.005-.007.013-.016.018-.024a2.508,2.508,0,0,0,.3-.507,3.731,3.731,0,0,0,.306-1.137,5.794,5.794,0,0,0,.031-.59,6.221,6.221,0,0,0-.048-.759,8.161,8.161,0,0,0-.328-1.486c-.078-.243-.165-.481-.261-.716l-.074-.177A10.366,10.366,0,0,0,28.5,56.989a7.877,7.877,0,0,0-2-1.69,3.7,3.7,0,0,0-2-.6,2.464,2.464,0,0,0-.561.1M22.36,61.359a9.788,9.788,0,0,1-.825-2.438,8.336,8.336,0,0,1-.14-1.187,4.381,4.381,0,0,1,.8-3.109,2.963,2.963,0,0,1,2.284-.865,4.772,4.772,0,0,1,2.368.9,10.063,10.063,0,0,1,2.322,2.161,12.017,12.017,0,0,1,1.855,3.319l.06.169,28.4,16.242a3.764,3.764,0,0,0-.423,1.251,7.3,7.3,0,0,0,.07,2.659c.059.274.127.543.2.811.007.023.015.047.021.07.04.136.083.272.128.405L32.248,66.177l-.329-.188-.837-.478-.06.1a2.717,2.717,0,0,1-1.5,1.13,3.727,3.727,0,0,1-2.5-.333,7.3,7.3,0,0,1-1.951-1.313l-.07-.069.052.053c-.2-.181-.385-.371-.568-.568a12.869,12.869,0,0,1-2.119-3.151",
    transform: "translate(-1.822 -4.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80960",
    "data-name": "Path 80960",
    className: "cls-23",
    d: "M20.853,50.052q2.912-1.667,5.824-3.331a3.7,3.7,0,0,1,.436-.213l-5.827,3.333a3.569,3.569,0,0,0-.433.211",
    transform: "translate(-1.776 -3.961)"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73966",
    "data-name": "Group 73966",
    transform: "translate(18.422 46.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73965",
    "data-name": "Group 73965",
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27245",
    "data-name": "Rectangle 27245",
    className: "cls-129",
    width: 2.676,
    height: 1.751,
    transform: "translate(0 0)"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73968",
    "data-name": "Group 73968",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73967",
    "data-name": "Group 73967",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80962",
    "data-name": "Path 80962",
    className: "cls-23",
    d: "M20.432,62.5q.214.451.458.89l-.422.241A18.014,18.014,0,0,1,18.822,59.6c.187.03.374.059.561.09.033.124.069.247.105.371.014.049.029.1.044.148.045.147.093.3.145.445l.025.075c.008.025.017.048.027.073.014.043.029.086.046.129s.04.114.062.17q.095.258.2.513c.016.04.032.081.048.12.026.061.052.122.079.183l.054.124c.068.156.14.311.214.465",
    transform: "translate(-1.603 -5.076)"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73970",
    "data-name": "Group 73970",
    transform: "translate(17.219 54.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73969",
    "data-name": "Group 73969",
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27247",
    "data-name": "Rectangle 27247",
    className: "cls-131",
    width: 0.561,
    height: 0.359,
    transform: "translate(0 0)"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73972",
    "data-name": "Group 73972",
    transform: "translate(17.011 48.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73971",
    "data-name": "Group 73971",
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27248",
    "data-name": "Rectangle 27248",
    className: "cls-133",
    width: 0.951,
    height: 1.04,
    transform: "translate(0 0)"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73974",
    "data-name": "Group 73974",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73973",
    "data-name": "Group 73973",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80965",
    "data-name": "Path 80965",
    className: "cls-23",
    d: "M18.571,53.582l.666.582a5.279,5.279,0,0,0-.091.652c0,.023.065.11.062.133a9.044,9.044,0,0,0-.119,2.441c-.2-.08-.5-.212-.7-.293a9.49,9.49,0,0,1,.178-3.515",
    transform: "translate(-1.56 -4.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80966",
    "data-name": "Path 80966",
    className: "cls-23",
    d: "M35.082,48.215c-.048-.115-.1-.229-.145-.344l.16-.026a4.775,4.775,0,0,1,.519-.045,5.232,5.232,0,0,1,.722.03,6.651,6.651,0,0,1,1.528.365c.037.245.121.709.156.953a6.542,6.542,0,0,0-1.46-.342c-.044,0-.371.341-.369.056-.36-.032-.477-.306-.83-.25l-.105.016c-.059-.138-.116-.277-.176-.414",
    transform: "translate(-2.976 -4.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80967",
    "data-name": "Path 80967",
    className: "cls-23",
    d: "M21.626,51.016c-.128.074-.192.215-.321.289l-.107.232a2.3,2.3,0,0,0-.88.717c0,.006.011.4-.2.07a2.4,2.4,0,0,0-.259.338c-.176-.2-.48-.559-.656-.759a4.061,4.061,0,0,1,1.5-1.539l0,0a3.569,3.569,0,0,1,.433-.211c.124.238.356.627.48.865",
    transform: "translate(-1.636 -4.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80968",
    "data-name": "Path 80968",
    className: "cls-23",
    d: "M31.684,67.784l.374.141,1.1-.489-.028-.12-.329-.188Z",
    transform: "translate(-2.699 -5.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80969",
    "data-name": "Path 80969",
    className: "cls-78",
    d: "M32.26,67.043l-.033.049c-.023.033-.046.065-.07.1l-.035.048A2.967,2.967,0,0,1,30.37,68.3a4.322,4.322,0,0,1-2.707-.519,8.966,8.966,0,0,1-2.27-1.645l.013.01a7.282,7.282,0,0,0,1.951,1.313,3.714,3.714,0,0,0,2.5.333,2.705,2.705,0,0,0,1.5-1.129l.06-.1c.279.158.559.319.838.478",
    transform: "translate(-2.163 -5.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80970",
    "data-name": "Path 80970",
    className: "cls-23",
    d: "M72.927,94.578c.12.25.274.566.394.816a5.146,5.146,0,0,1-2.858-.071c-.047-.245-.106-.535-.154-.779a4.131,4.131,0,0,0,.815.054c.008,0,.1-.089.1-.089l.177.106a3.525,3.525,0,0,0,1.522-.037",
    transform: "translate(-5.989 -8.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80971",
    "data-name": "Path 80971",
    className: "cls-79",
    d: "M22.461,52.9a3.086,3.086,0,0,0-1.017.821,4.4,4.4,0,0,0-.81,2.65,9.624,9.624,0,0,0,.571,3.435,13.366,13.366,0,0,0,1.98,3.7,10.542,10.542,0,0,0,3.109,2.839L64.17,88a5.3,5.3,0,0,0,2.083.738,3.455,3.455,0,0,0,1.708-.242,2.465,2.465,0,0,0,.439-.242,3.431,3.431,0,0,0,1.218-1.821,6.441,6.441,0,0,0,.118-2.919,12.23,12.23,0,0,0-1.133-3.51A12.915,12.915,0,0,0,66,76.424l-.566-.507-2.166-1.943h0l-1.052-.944-6.09-5.461-4.342-3.894-7.07-6.339h0l-3.281-2.942L39.68,52.823a11.319,11.319,0,0,0-1.028-.857,6.587,6.587,0,0,0-2.43-1.114,3.619,3.619,0,0,0-.523-.084,3.315,3.315,0,0,0-.8.029l-6.622,1.048-3.464.548-1.431.226-.156.027a2.645,2.645,0,0,0-.763.252m-1.543,9.587h0c0-.009-.01-.018-.015-.028-.162-.293-.315-.59-.459-.889-.074-.155-.145-.31-.214-.465-.018-.041-.037-.082-.054-.124-.027-.061-.053-.122-.079-.183-.016-.04-.033-.08-.049-.12q-.106-.255-.2-.513c-.022-.056-.043-.113-.063-.17s-.031-.086-.045-.129-.035-.1-.051-.148c-.052-.148-.1-.3-.145-.445-.015-.049-.03-.1-.044-.148-.038-.124-.072-.247-.105-.371s-.061-.239-.09-.36a11.584,11.584,0,0,1-.329-3.045,8.889,8.889,0,0,1,.07-.908c0-.022.006-.044.009-.066a6.746,6.746,0,0,1,.148-.709l-.009-.007a5.013,5.013,0,0,1,.383-1.041c.042-.082.086-.163.134-.242l.007.009a4.116,4.116,0,0,1,.319-.479,3.851,3.851,0,0,1,2.285-1.369l.159-.027.231-.036,2.486-.394,1.243-.2,2.486-.392h0l1.241-.2,2.486-.392,1.242-.2a5.323,5.323,0,0,1,.636-.065,4.617,4.617,0,0,1,.537.014l.131.013c.165.021.33.049.5.088a8.54,8.54,0,0,1,2.383.937V49.7a11.534,11.534,0,0,1,1.461,1.035c.06.05.121.1.18.152s.116.1.175.152l0,0c.078.07.248.225.256.233l.1.086.115.1c.2.177.4.354.593.532h0l1.418,1.272,2.837,2.543,1.418,1.273,2.837,2.543L50.891,60.9q1.419,1.271,2.836,2.543l1.419,1.273,2.837,2.543L59.4,68.531l4.255,3.816q1.419,1.271,2.836,2.543a16.225,16.225,0,0,1,2.32,2.781l0,0a17.948,17.948,0,0,1,1.041,1.786c.026.05.05.1.075.153s.059.121.088.18a15.751,15.751,0,0,1,1.349,4.275q.069.428.109.858l.005.07a9.232,9.232,0,0,1-.027,1.683l.01.006a6.567,6.567,0,0,1-.241,1.167,4.924,4.924,0,0,1-1.03,1.893c-.056.06-.114.12-.174.177a3.617,3.617,0,0,1-.337.28l-.009.006-.017.012a4.181,4.181,0,0,1-2.751.64h0a5.843,5.843,0,0,1-.95-.191l0,.01a6.448,6.448,0,0,1-.782-.276q-.346-.148-.677-.324h0c-.107-.056-.214-.114-.32-.175-.139-.079-.278-.159-.416-.239L61.542,88.4l-.878-.5-.6-.34L57.118,85.87l-.877-.5-.6-.34h0L52.7,83.342l-.878-.5-.6-.341-2.948-1.686h0l-.878-.5-.6-.341h0L43.85,78.282l-.878-.5-.6-.342-2.949-1.686-.878-.5-.6-.341L35,73.223l-.878-.5-.6-.341-2.948-1.686-.878-.5-.6-.34v0Q28,69.218,26.9,68.584c-.061-.035-.123-.07-.185-.1l-.369-.211-.048-.027-.136-.08a11.064,11.064,0,0,1-1.086-.733c-.127-.1-.253-.2-.377-.3v0a14.92,14.92,0,0,1-1.876-1.873c-.012-.016-.026-.031-.038-.046l-.124-.151-.014-.016c-.125-.155-.249-.312-.369-.471-.069-.091-.136-.183-.2-.274a17.825,17.825,0,0,1-1.153-1.81",
    transform: "translate(-1.616 -4.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80972",
    "data-name": "Path 80972",
    className: "cls-44",
    d: "M52.65,66.567a1.28,1.28,0,0,1,.435-.536c.022-.014.044-.028.067-.04a1.574,1.574,0,0,1,1.153-.07,3.272,3.272,0,0,1,1.676,1.347,4.9,4.9,0,0,1,1.1,2.83,1.982,1.982,0,0,1-.264,1.085,1.338,1.338,0,0,1-.1.136,1.224,1.224,0,0,1-.617.375,1.313,1.313,0,0,1-.4.026h-.009a1.548,1.548,0,0,1-.261-.041c.031,0,.061-.011.091-.018a1.2,1.2,0,0,0,.708-.56,1.647,1.647,0,0,0,.189-.881c0-.1-.012-.209-.024-.312a4.359,4.359,0,0,0-.44-1.448,4.838,4.838,0,0,0-.893-1.239,3.086,3.086,0,0,0-1-.7c-.065-.027-.132-.051-.2-.073a1.3,1.3,0,0,0-.7-.045,1.211,1.211,0,0,0-.708.557c.063-.131.128-.263.192-.394Z",
    transform: "translate(-4.468 -5.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80973",
    "data-name": "Path 80973",
    className: "cls-4",
    d: "M68.169,54.922v.972l-4.37,2.5v-.972Z",
    transform: "translate(-5.434 -4.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80974",
    "data-name": "Path 80974",
    className: "cls-12",
    d: "M58.128,51.5l-1.105.632-4.37,2.5,4.37,2.5h5.827l4.37-2.5Z",
    transform: "translate(-4.485 -4.386)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27249",
    "data-name": "Rectangle 27249",
    className: "cls-9",
    width: 5.827,
    height: 0.972,
    transform: "translate(52.538 52.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80975",
    "data-name": "Path 80975",
    className: "cls-10",
    d: "M50.89,53.089v.972L50.818,54,42.9,46.9l-.027-.025c-.053-.05-.108-.1-.163-.149-.091-.081-.182-.162-.274-.241s-.184-.155-.276-.229-.185-.147-.278-.219l-.281-.207c-.14-.1-.282-.2-.422-.288-.164-.105-.328-.206-.491-.3l-.146-.082q-.213-.117-.424-.219c-.094-.045-.188-.089-.282-.13s-.188-.08-.282-.116-.186-.071-.278-.1-.186-.061-.278-.09-.183-.053-.274-.076-.181-.044-.272-.062c-.061-.012-.121-.024-.18-.034L38.1,44.3c-.059-.008-.117-.016-.176-.021s-.117-.011-.175-.015-.115-.008-.172-.01l-.17,0c-.057,0-.112,0-.168,0s-.111,0-.166.01-.109.009-.163.016-.108.013-.161.022l-4.8.759V33.406l2.915,1.666L46.85,41.926l4.04,11.164",
    transform: "translate(-2.721 -2.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80976",
    "data-name": "Path 80976",
    className: "cls-10",
    d: "M57.023,57.422v.972l-4.37-2.5v-.972Z",
    transform: "translate(-4.485 -4.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80977",
    "data-name": "Path 80977",
    className: "cls-23",
    d: "M139.475,80.808l0,0-2.959-20.911,8.47,27.064-2.213-3.614Z",
    transform: "translate(-11.627 -5.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80978",
    "data-name": "Path 80978",
    className: "cls-134",
    d: "M141.717,84.678l-5.671,3.242-11.892-9.153,2.673-1.529,3-1.706,8.6,6.609Z",
    transform: "translate(-10.575 -6.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80979",
    "data-name": "Path 80979",
    className: "cls-135",
    d: "M135.86,88.077l1.283,2.094L121.962,78.485V77.379l.725.559.325.25.956.736Z",
    transform: "translate(-10.388 -6.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80980",
    "data-name": "Path 80980",
    className: "cls-136",
    d: "M137.054,90.273l-2.769,1.584L133,89.763,121.11,80.61l-.2-1.469h0l.966-.553Z",
    transform: "translate(-10.298 -6.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80981",
    "data-name": "Path 80981",
    className: "cls-134",
    d: "M132.493,89.952l-5.67,3.242L114.93,84.041,120.6,80.8Z",
    transform: "translate(-9.789 -6.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80982",
    "data-name": "Path 80982",
    className: "cls-31",
    d: "M124.326,58.927l.094.775-5.669,3.235-2.769,1.584-5.67,3.242-2.834,1.621-5.67,3.243-2.836,1.621L93.3,77.492l-2.835,1.62L84.8,82.355l-.085.048-.446-.526c14.922-8.534,40.059-22.95,40.059-22.95",
    transform: "translate(-7.177 -5.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80983",
    "data-name": "Path 80983",
    className: "cls-135",
    d: "M126.637,93.352q.641,1.047,1.283,2.093L112.737,83.761V82.654l2.007,1.545Z",
    transform: "translate(-9.602 -7.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80984",
    "data-name": "Path 80984",
    className: "cls-136",
    d: "M127.823,95.549l-2.835,1.621q-.641-1.047-1.284-2.093l-11.892-9.154-.2-1.468h0l1.033-.591Z",
    transform: "translate(-9.506 -7.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80985",
    "data-name": "Path 80985",
    className: "cls-18",
    d: "M124.975,61.486l2.54,14.11-.875.445-2.672,1.529-2.006-14.415Z",
    transform: "translate(-10.388 -5.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80986",
    "data-name": "Path 80986",
    className: "cls-23",
    d: "M144.3,86.551,120.975,99.892l-.024-.039q2.834-1.623,5.669-3.244l16.943-9.69-8.376-27.064.754-.431Z",
    transform: "translate(-10.302 -5.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80987",
    "data-name": "Path 80987",
    className: "cls-23",
    d: "M126.338,99.442l.179.293-5.67,3.242-.931-1.52-1.283-2.093L124.3,96.12l1.284,2.093q.376.615.752,1.229",
    transform: "translate(-10.104 -8.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80988",
    "data-name": "Path 80988",
    className: "cls-134",
    d: "M123.2,95.268l-5.67,3.243-11.891-9.153,5.669-3.243h0Z",
    transform: "translate(-8.997 -7.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80989",
    "data-name": "Path 80989",
    className: "cls-135",
    d: "M121.961,63.31l2.006,14.415-.955-.736-.325-.25-.726-.559Z",
    transform: "translate(-10.388 -5.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80990",
    "data-name": "Path 80990",
    className: "cls-23",
    d: "M121.7,76.181v1.106l-.966.553h0l-1.8-12.946L121.7,63.31Z",
    transform: "translate(-10.13 -5.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80991",
    "data-name": "Path 80991",
    className: "cls-137",
    d: "M120.208,77.987l.2,1.47-5.67,3.242-2.006-14.416,5.67-3.242Z",
    transform: "translate(-9.602 -5.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80992",
    "data-name": "Path 80992",
    className: "cls-23",
    d: "M120.7,103.473l-2.835,1.622-.714-1.165-.219-.357,2.835-1.621Z",
    transform: "translate(-9.96 -8.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80993",
    "data-name": "Path 80993",
    className: "cls-135",
    d: "M117.339,98.669l1.283,2.093L103.44,89.077V87.971l2.007,1.545h0Z",
    transform: "translate(-8.81 -7.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80994",
    "data-name": "Path 80994",
    className: "cls-136",
    d: "M118.525,100.866l-2.835,1.621q-.639-1.047-1.283-2.093L102.516,91.24l-.2-1.469,1.034-.59Z",
    transform: "translate(-8.714 -7.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80995",
    "data-name": "Path 80995",
    className: "cls-23",
    d: "M117.221,105.051l-1.723.985-3.947,2.257-.931-1.52-1.283-2.093,5.669-3.243q.642,1.047,1.283,2.093l.219.357.714,1.165",
    transform: "translate(-9.313 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80996",
    "data-name": "Path 80996",
    className: "cls-134",
    d: "M113.9,100.585l-5.67,3.243L96.338,94.675l5.67-3.244Z",
    transform: "translate(-8.206 -7.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80997",
    "data-name": "Path 80997",
    className: "cls-135",
    d: "M112.737,68.585,114.744,83l-2.007-1.544Z",
    transform: "translate(-9.602 -5.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80998",
    "data-name": "Path 80998",
    className: "cls-23",
    d: "M112.473,81.456v1.107q-.517.294-1.032.59h0l-1.8-12.947,2.835-1.621Z",
    transform: "translate(-9.338 -5.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80999",
    "data-name": "Path 80999",
    className: "cls-137",
    d: "M111.117,84.774l-5.669,3.242h0L103.441,73.6l5.669-3.243,1.8,12.946.2,1.469Z",
    transform: "translate(-8.811 -5.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81000",
    "data-name": "Path 81000",
    className: "cls-137",
    d: "M129.637,74.191l-5.669,3.242h0l-2.006-14.423c1.889-1.081,3.78-2.153,5.669-3.234l1.8,12.947.2,1.468Z",
    transform: "translate(-10.388 -5.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81001",
    "data-name": "Path 81001",
    className: "cls-23",
    d: "M110.475,107.271q.467.759.932,1.52l-2.835,1.621-.218-.355-.714-1.165Z",
    transform: "translate(-9.168 -9.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81002",
    "data-name": "Path 81002",
    className: "cls-135",
    d: "M108.043,103.987l1.283,2.093L94.144,94.395V93.288l2.007,1.545Z",
    transform: "translate(-8.019 -7.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81003",
    "data-name": "Path 81003",
    className: "cls-136",
    d: "M109.229,106.183l-2.835,1.621q-.639-1.047-1.283-2.093L93.22,96.557l-.2-1.469,1.033-.59Z",
    transform: "translate(-7.922 -8.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81004",
    "data-name": "Path 81004",
    className: "cls-23",
    d: "M107.925,110.369l-3.528,2.018-.081.046-2.063,1.179-.93-1.52h0q-.641-1.047-1.282-2.093l5.669-3.242q.642,1.047,1.283,2.093l.714,1.166Z",
    transform: "translate(-8.521 -9.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81005",
    "data-name": "Path 81005",
    className: "cls-134",
    d: "M104.825,105.9l-5.669,3.242L90.389,102.4h0l-.737-3.771,3.282-1.878Z",
    transform: "translate(-7.636 -8.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81006",
    "data-name": "Path 81006",
    className: "cls-135",
    d: "M103.441,73.9l2.007,14.414-2.007-1.478Z",
    transform: "translate(-8.811 -6.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81007",
    "data-name": "Path 81007",
    className: "cls-23",
    d: "M103.177,86.774V87.88l-1.033.59-1.8-12.946,2.836-1.621v12.87Z",
    transform: "translate(-8.546 -6.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81008",
    "data-name": "Path 81008",
    className: "cls-137",
    d: "M101.616,88.62l.2,1.469-5.67,3.244L94.144,78.917l5.669-3.243Z",
    transform: "translate(-8.019 -6.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81009",
    "data-name": "Path 81009",
    className: "cls-23",
    d: "M100.7,112.519q.467.76.931,1.521L99.247,115.4l-5.669,3.243-.858-4.389,4.314-2.468q.639,1.047,1.283,2.094Z",
    transform: "translate(-7.897 -9.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81010",
    "data-name": "Path 81010",
    className: "cls-136",
    d: "M100.53,111.885l-2.382,1.363q-.642-1.047-1.283-2.094l-5.648-4.346-.481-2.461,9.793,7.537h0",
    transform: "translate(-7.728 -8.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81011",
    "data-name": "Path 81011",
    className: "cls-135",
    d: "M99.225,109.671q.639,1.047,1.282,2.092l-9.794-7.536-.254-1.3h0Z",
    transform: "translate(-7.705 -8.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81012",
    "data-name": "Path 81012",
    className: "cls-134",
    d: "M96.91,111.384,92.6,113.852l-1.334-6.815Z",
    transform: "translate(-7.773 -9.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81013",
    "data-name": "Path 81013",
    className: "cls-135",
    d: "M94.144,79.22l2.008,14.415-2.008-1.545Z",
    transform: "translate(-8.019 -6.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81014",
    "data-name": "Path 81014",
    className: "cls-23",
    d: "M93.88,92.09V93.2c-.345.2-.688.393-1.033.59l-1.8-12.946L93.88,79.22Z",
    transform: "translate(-7.755 -6.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81015",
    "data-name": "Path 81015",
    className: "cls-23",
    d: "M93.069,116.615l-.732.412-.851-4.364-.009-.027L86.73,88.365l.778-.439.073.65,1.821,9.3.741,3.769.256,1.3.476,2.461,1.336,6.815.009.037Z",
    transform: "translate(-7.387 -7.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81016",
    "data-name": "Path 81016",
    className: "cls-137",
    d: "M92.311,93.938l.2,1.469-3.282,1.878-1.819-9.3-.081-.654-2.581-3.05.085-.048,5.669-3.242Z",
    transform: "translate(-7.219 -6.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81017",
    "data-name": "Path 81017",
    className: "cls-138",
    d: "M86.733,88.405l5.607,28.664L86.733,112.8Z",
    transform: "translate(-7.387 -7.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81018",
    "data-name": "Path 81018",
    className: "cls-138",
    d: "M86.051,88v24.391l-7.329-10.881v-15l3.664-2.843Z",
    transform: "translate(-6.705 -7.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81019",
    "data-name": "Path 81019",
    className: "cls-139",
    d: "M132.686,59.314l-.754.431-7.733-.9S99.058,73.265,84.136,81.8l.446.526,2.581,3.05-.771.441-3.665-4.33,40.989-23.479Z",
    transform: "translate(-7.046 -4.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81020",
    "data-name": "Path 81020",
    className: "cls-23",
    d: "M135.6,94.072l.179.293-5.67,3.242-.931-1.52L127.9,93.993l5.669-3.243,1.284,2.093q.376.615.752,1.229",
    transform: "translate(-10.893 -7.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81021",
    "data-name": "Path 81021",
    className: "cls-23",
    d: "M144.859,88.848l.179.293-5.67,3.242-.931-1.52-1.283-2.094,5.669-3.243,1.284,2.093q.376.615.752,1.229",
    transform: "translate(-11.682 -7.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81022",
    "data-name": "Path 81022",
    className: "cls-23",
    d: "M130,98.156l-2.835,1.622-.714-1.165-.219-.357,2.835-1.621Z",
    transform: "translate(-10.752 -8.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81023",
    "data-name": "Path 81023",
    className: "cls-23",
    d: "M139.265,92.824l-2.835,1.622-.714-1.165-.219-.357,2.835-1.621Z",
    transform: "translate(-11.541 -7.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81024",
    "data-name": "Path 81024",
    className: "cls-4",
    d: "M52.2,38.746l4.452,12.3-4.37,2.5-4.04-11.163q.376-.9.754-1.8Z",
    transform: "translate(-4.109 -3.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81025",
    "data-name": "Path 81025",
    className: "cls-16",
    d: "M57.19,71.779l-.036.085-.312.171.242-.211.1-.059Z",
    transform: "translate(-4.841 -6.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81026",
    "data-name": "Path 81026",
    className: "cls-16",
    d: "M4.355,40.891a1.135,1.135,0,0,1-.2.714s-.416.262-.845.51l-.086.049-.011-.013a.817.817,0,0,0,.173-.208,1.1,1.1,0,0,0,.124-.58,1.952,1.952,0,0,0-.016-.2c-.005-.046-.012-.091-.019-.135l.853-.491a1.976,1.976,0,0,1,.033.36",
    transform: "translate(-0.273 -3.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81027",
    "data-name": "Path 81027",
    className: "cls-16",
    d: "M10.36,37.413a1.2,1.2,0,0,1-.144.622.712.712,0,0,1-.154.177h0l-1.312.749a5.224,5.224,0,0,0-.271-.862l1.847-1.063a1.986,1.986,0,0,1,.036.374",
    transform: "translate(-0.722 -3.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81028",
    "data-name": "Path 81028",
    className: "cls-16",
    d: "M16.29,34.671,14.172,35.88l-.348-.2.145-.723,1.407-.811Z",
    transform: "translate(-1.177 -2.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81029",
    "data-name": "Path 81029",
    className: "cls-16",
    d: "M26.043,28.337a1.173,1.173,0,0,1-.154.638s-.554.341-1.249.761c-.489.3-1.049.633-1.532.918h0L22.5,31a5.345,5.345,0,0,0-.287-.907L26,27.918a1.967,1.967,0,0,1,.047.419",
    transform: "translate(-1.892 -2.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81030",
    "data-name": "Path 81030",
    className: "cls-16",
    d: "M32.162,25.6l-.207.119-.123.07-.066.038-.137.079-.22.125-.286.164-.191.11-.886.506-.359-.2.156-.78,1.352-.777Z",
    transform: "translate(-2.528 -2.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81031",
    "data-name": "Path 81031",
    className: "cls-92",
    d: "M18.025,36.416c-.034.016-.066.034-.1.053l-.029.018a1.524,1.524,0,0,0-.129.083c-.039.027-.079.056-.119.086-.07.052-.138.108-.2.163-.019.016-.038.034-.055.05-.036.033-.066.064-.1.1h0c-.981-1.162-2.876-3.449-2.876-3.449l.474.271,1.068.609.338.193.414.236s.87,1.061,1.313,1.586",
    transform: "translate(-1.228 -2.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81032",
    "data-name": "Path 81032",
    className: "cls-24",
    d: "M3.651,39.056l-.838.478a2.861,2.861,0,0,0-.264-.3c-.033-.033-.066-.065-.1-.1l.847-.485a2.808,2.808,0,0,1,.356.405",
    transform: "translate(-0.209 -3.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81033",
    "data-name": "Path 81033",
    className: "cls-24",
    d: "M9.631,35.58l-1.91,1.092c-.1-.149-.2-.3-.3-.436l1.853-1.06a2.794,2.794,0,0,1,.356.4",
    transform: "translate(-0.632 -2.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81034",
    "data-name": "Path 81034",
    className: "cls-6",
    d: "M8.526,39.739l-2.68,1.537a4.942,4.942,0,0,0-.128-.97,5.28,5.28,0,0,0-.457-1.217c-.037-.082-.082-.165-.128-.247a6.106,6.106,0,0,0-.412-.659l2.671-1.528a1.165,1.165,0,0,1,.119.174c.146.229.293.476.421.723a5.334,5.334,0,0,1,.467,1.2,3.334,3.334,0,0,1,.128.988",
    transform: "translate(-0.402 -3.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81035",
    "data-name": "Path 81035",
    className: "cls-8",
    d: "M14.235,28.851l-2.279,1.318a4.265,4.265,0,0,0-.284-.446,3.639,3.639,0,0,0-.264-.324l2.269-1.312c.059.063.117.13.173.2a3.875,3.875,0,0,1,.385.565",
    transform: "translate(-0.972 -2.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81036",
    "data-name": "Path 81036",
    className: "cls-140",
    d: "M30.092,19.771l-2.279,1.318a4.139,4.139,0,0,0-.283-.444,3.534,3.534,0,0,0-.265-.325l2.268-1.312c.06.063.119.13.175.2a3.852,3.852,0,0,1,.384.564",
    transform: "translate(-2.322 -1.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81037",
    "data-name": "Path 81037",
    className: "cls-24",
    d: "M25.319,26.505l-3.842,2.2q-.143-.226-.3-.437L24.963,26.1a2.473,2.473,0,0,1,.356.405",
    transform: "translate(-1.804 -2.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81038",
    "data-name": "Path 81038",
    className: "cls-141",
    d: "M17.45,36.82c-.02.016-.038.034-.056.05-.035.033-.065.064-.1.1h0c-.982-1.162-2.876-3.449-2.876-3.449l.474.27L17.45,36.82",
    transform: "translate(-1.228 -2.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81039",
    "data-name": "Path 81039",
    className: "cls-93",
    d: "M18.041,36.57c-.041.025-.085.052-.128.083-.586-.7-1.5-1.8-1.809-2.17l.338.193,1.6,1.894",
    transform: "translate(-1.372 -2.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81040",
    "data-name": "Path 81040",
    className: "cls-23",
    d: "M33.2,28.552s.134-.275.2-.4.267-.457.272-.457l.458-.1a2.391,2.391,0,0,1,.476-.1c.11.009-.258.475-.258.475l-.373.346-.727.311Z",
    transform: "translate(-2.828 -2.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81041",
    "data-name": "Path 81041",
    className: "cls-11",
    d: "M36.377,29.531l-.277.159-.188.106-.546.312-.6.347-1.545-1.829c-.05-.059.023-.147.083-.218a2.68,2.68,0,0,1,.21-.227c.04-.037.084-.076.132-.116s.122-.1.185-.147a3.086,3.086,0,0,1,.317-.215l.024-.015c.053-.032.105-.059.166-.089l.113-.052c.083-.038.184-.084.235-.024l1.7,2.007",
    transform: "translate(-2.828 -2.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81042",
    "data-name": "Path 81042",
    className: "cls-24",
    d: "M36.188,29.7,36,29.807l-1.769-2.094.024-.015c.054-.032.106-.059.167-.088L36.188,29.7",
    transform: "translate(-2.916 -2.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81043",
    "data-name": "Path 81043",
    className: "cls-25",
    d: "M35.367,30.162l-.606.347L33.217,28.68c-.05-.059.022-.147.082-.218a2.4,2.4,0,0,1,.211-.226c.04-.038.083-.077.131-.117q.863,1.021,1.725,2.043",
    transform: "translate(-2.828 -2.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81044",
    "data-name": "Path 81044",
    className: "cls-92",
    d: "M33.882,27.339c-.034.017-.066.034-.1.053l-.029.018a1.524,1.524,0,0,0-.129.083c-.039.027-.079.056-.119.086-.07.052-.138.108-.2.163-.019.016-.038.034-.055.05-.036.033-.066.064-.1.1h0c-.981-1.162-2.876-3.449-2.876-3.449l.474.271,1.068.609.338.193.414.236s.87,1.061,1.313,1.586",
    transform: "translate(-2.579 -2.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81045",
    "data-name": "Path 81045",
    className: "cls-141",
    d: "M33.308,27.742c-.02.016-.038.034-.056.05-.035.033-.065.064-.1.1h0c-.982-1.162-2.876-3.449-2.876-3.449l.474.27,2.557,3.028",
    transform: "translate(-2.579 -2.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81046",
    "data-name": "Path 81046",
    className: "cls-93",
    d: "M33.9,27.492c-.041.025-.085.052-.128.083-.586-.7-1.5-1.8-1.809-2.17l.338.193q.8.948,1.6,1.894",
    transform: "translate(-2.722 -2.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81047",
    "data-name": "Path 81047",
    className: "cls-4",
    d: "M89.1,43.086v.97l-1.4.805-.494-.567-.073-.082Z",
    transform: "translate(-7.421 -3.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81048",
    "data-name": "Path 81048",
    className: "cls-12",
    d: "M88.821,39.2v3.339l-1.967,1.125-.082-.091-2.324-2.662L83.9,37.026l.549-.32,2.177,1.244Z",
    transform: "translate(-7.146 -3.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81049",
    "data-name": "Path 81049",
    className: "cls-4",
    d: "M83.424,33.732q.493,1.361.985,2.723l-.553.317Z",
    transform: "translate(-7.106 -2.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81050",
    "data-name": "Path 81050",
    className: "cls-8",
    d: "M8.471,38.879l-2.69,1.546a5.372,5.372,0,0,0-.457-1.208l2.662-1.537a5.876,5.876,0,0,1,.485,1.2",
    transform: "translate(-0.453 -3.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81051",
    "data-name": "Path 81051",
    className: "cls-23",
    d: "M128.032,58.927l2.1,15.19,8.838,6.774s-3.2-21.068-3.2-21.068Z",
    transform: "translate(-10.905 -5.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81052",
    "data-name": "Path 81052",
    className: "cls-47",
    d: "M83.931,16.441l-3.913,2.238-1.246-.709,3.913-2.238Z",
    transform: "translate(-6.709 -1.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81053",
    "data-name": "Path 81053",
    className: "cls-142",
    d: "M80.319,18.914l3.1-1.775c-.127.667-.2,1.071-.328,1.733-1.14.651-1.961,1.119-3.1,1.77Z",
    transform: "translate(-6.814 -1.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81054",
    "data-name": "Path 81054",
    className: "cls-143",
    d: "M84.021,16.943,83.634,19c-.085-.048-.17-.1-.254-.147.127-.662.2-1.067.328-1.734Z",
    transform: "translate(-7.102 -1.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81055",
    "data-name": "Path 81055",
    className: "cls-144",
    d: "M83.34,19.18l-3.414,1.954.063-.331c1.134-.651,1.957-1.119,3.1-1.77.084.048.169.1.254.147",
    transform: "translate(-6.808 -1.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81056",
    "data-name": "Path 81056",
    className: "cls-44",
    d: "M79.6,21.318l.493-2.573L84,16.508l-.489,2.573Zm.3-.4,3.414-1.954.387-2.058-.313.178-3.1,1.776-.323,1.727Z",
    transform: "translate(-6.779 -1.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81057",
    "data-name": "Path 81057",
    className: "cls-48",
    d: "M80.018,18.887l-.493,2.573-.753-.441V18.178Z",
    transform: "translate(-6.709 -1.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81058",
    "data-name": "Path 81058",
    className: "cls-47",
    d: "M67.772,25.762,63.859,28l-1.246-.709,3.913-2.238Z",
    transform: "translate(-5.333 -2.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81059",
    "data-name": "Path 81059",
    className: "cls-142",
    d: "M64.16,28.235l3.1-1.775c-.127.667-.2,1.071-.328,1.733-1.14.651-1.961,1.119-3.1,1.77Z",
    transform: "translate(-5.437 -2.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81060",
    "data-name": "Path 81060",
    className: "cls-143",
    d: "M67.862,26.265l-.387,2.058c-.085-.047-.169-.1-.254-.146.127-.662.2-1.067.328-1.734Z",
    transform: "translate(-5.726 -2.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81061",
    "data-name": "Path 81061",
    className: "cls-144",
    d: "M67.181,28.5l-3.414,1.954.063-.331c1.134-.651,1.957-1.119,3.1-1.77.084.048.169.1.254.147",
    transform: "translate(-5.431 -2.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81062",
    "data-name": "Path 81062",
    className: "cls-44",
    d: "M63.437,30.639l.493-2.573,3.913-2.237L67.355,28.4Zm.3-.4,3.414-1.954.387-2.058-.313.178-3.1,1.775L63.8,29.909Z",
    transform: "translate(-5.403 -2.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81063",
    "data-name": "Path 81063",
    className: "cls-48",
    d: "M63.859,28.208l-.493,2.573-.753-.441V27.5Z",
    transform: "translate(-5.333 -2.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81064",
    "data-name": "Path 81064",
    className: "cls-145",
    d: "M45.3,15.988a.071.071,0,0,0,0,.027.378.378,0,0,0,.073.21.673.673,0,0,0,.209.177,1.142,1.142,0,0,0,.31.121,1.647,1.647,0,0,0,.732,0,1.119,1.119,0,0,0,.31-.121.621.621,0,0,0,.209-.177.352.352,0,0,0,.073-.21.091.091,0,0,0,0-.031v-.01a.365.365,0,0,0-.07-.169.652.652,0,0,0-.209-.176,1.089,1.089,0,0,0-.31-.118,1.647,1.647,0,0,0-.732,0,1.111,1.111,0,0,0-.31.118.71.71,0,0,0-.209.176.375.375,0,0,0-.07.169Z",
    transform: "translate(-3.858 -1.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81065",
    "data-name": "Path 81065",
    className: "cls-146",
    d: "M47.531,18.661a.487.487,0,0,1-.1.286.9.9,0,0,1-.283.242,1.66,1.66,0,0,1-.425.163,2.187,2.187,0,0,1-.5.059,2.225,2.225,0,0,1-.5-.059,1.589,1.589,0,0,1-.421-.163.905.905,0,0,1-.286-.242.482.482,0,0,1-.1-.286l0-.059c.032-.221.059-.446.091-.666.084-.621.167-1.25.254-1.871a.38.38,0,0,0,.073.21.684.684,0,0,0,.209.176,1.113,1.113,0,0,0,.31.121,1.612,1.612,0,0,0,.732,0,1.081,1.081,0,0,0,.31-.121.63.63,0,0,0,.209-.176.348.348,0,0,0,.073-.21c.088.625.171,1.246.258,1.871.028.22.059.445.091.666Z",
    transform: "translate(-3.826 -1.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81066",
    "data-name": "Path 81066",
    className: "cls-24",
    d: "M45.676,19.526a1.607,1.607,0,0,1-.422-.162.913.913,0,0,1-.285-.242.48.48,0,0,1-.1-.287l0-.059c.031-.22.059-.445.091-.666a1.051,1.051,0,0,0-.522.566.458.458,0,0,0-.017.158.711.711,0,0,0,.156.414,1.166,1.166,0,0,0,.355.294,2.432,2.432,0,0,0,1.067.29,3.043,3.043,0,0,0,.92-.09,1.8,1.8,0,0,0,.665-.311.83.83,0,0,0,.32-.438.6.6,0,0,0,.017-.142.74.74,0,0,0-.118-.39,1.128,1.128,0,0,0-.414-.352c.027.221.059.446.091.666l0,.059a.491.491,0,0,1-.1.287.9.9,0,0,1-.282.242,1.686,1.686,0,0,1-.425.162,2.179,2.179,0,0,1-1,0",
    transform: "translate(-3.784 -1.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81067",
    "data-name": "Path 81067",
    className: "cls-25",
    d: "M47.936,18.92v.6a.917.917,0,0,1-.485.691,2.062,2.062,0,0,1-1.1.3,2.675,2.675,0,0,1-1.415-.283,1.316,1.316,0,0,1-.191-.128.892.892,0,0,1-.275-.359.552.552,0,0,1-.046-.221V18.9a.718.718,0,0,0,.157.414,1.166,1.166,0,0,0,.355.294,2.429,2.429,0,0,0,1.067.29,3.064,3.064,0,0,0,.919-.091,1.789,1.789,0,0,0,.666-.31.833.833,0,0,0,.32-.438.6.6,0,0,0,.017-.142Z",
    transform: "translate(-3.784 -1.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81068",
    "data-name": "Path 81068",
    className: "cls-11",
    d: "M44.939,19.61v.621a1.387,1.387,0,0,1-.191-.127.873.873,0,0,1-.275-.36.533.533,0,0,1-.046-.22V18.9a.718.718,0,0,0,.157.414,1.145,1.145,0,0,0,.355.294",
    transform: "translate(-3.784 -1.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81069",
    "data-name": "Path 81069",
    className: "cls-147",
    d: "M45.545,16.452,45.3,19.189a.911.911,0,0,1-.285-.242.484.484,0,0,1-.1-.286l0-.059c.032-.221.059-.446.091-.666.084-.622.167-1.25.254-1.871a.38.38,0,0,0,.073.21.684.684,0,0,0,.209.176",
    transform: "translate(-3.826 -1.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81070",
    "data-name": "Path 81070",
    className: "cls-44",
    d: "M40.363,12.9v2.841L36.45,17.975V15.133Z",
    transform: "translate(-3.105 -1.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81071",
    "data-name": "Path 81071",
    className: "cls-47",
    d: "M40.247,12.83l-3.913,2.238-1.246-.709,3.918-2.238Z",
    transform: "translate(-2.989 -1.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81072",
    "data-name": "Path 81072",
    className: "cls-48",
    d: "M36.334,15.275v2.841l-.758-.42-.488-3.131Z",
    transform: "translate(-2.989 -1.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81073",
    "data-name": "Path 81073",
    className: "cls-44",
    d: "M61.555.775V3.617L57.642,5.853V3.013Z",
    transform: "translate(-4.91 -0.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81074",
    "data-name": "Path 81074",
    className: "cls-47",
    d: "M61.439.709,57.526,2.947,56.28,2.238,60.2,0Z",
    transform: "translate(-4.794 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81075",
    "data-name": "Path 81075",
    className: "cls-48",
    d: "M57.526,3.155V6l-.758-.42L56.28,2.446Z",
    transform: "translate(-4.794 -0.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81076",
    "data-name": "Path 81076",
    className: "cls-23",
    d: "M44.567,41.538v.782l-9.632-5.509.682-.389Z",
    transform: "translate(-2.976 -3.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81077",
    "data-name": "Path 81077",
    className: "cls-31",
    d: "M35.618,36.386l-.682.389v-.782Z",
    transform: "translate(-2.976 -3.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81078",
    "data-name": "Path 81078",
    className: "cls-23",
    d: "M44.567,42.8v.782l-9.632-5.509.682-.389Z",
    transform: "translate(-2.976 -3.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81079",
    "data-name": "Path 81079",
    className: "cls-31",
    d: "M35.618,37.651l-.682.389v-.782Z",
    transform: "translate(-2.976 -3.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81080",
    "data-name": "Path 81080",
    className: "cls-23",
    d: "M44.567,44.068v.782l-9.632-5.509.682-.389Z",
    transform: "translate(-2.976 -3.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81081",
    "data-name": "Path 81081",
    className: "cls-31",
    d: "M35.618,38.916l-.682.389v-.782Z",
    transform: "translate(-2.976 -3.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81082",
    "data-name": "Path 81082",
    className: "cls-23",
    d: "M44.567,45.333v.782l-9.632-5.509.682-.389Z",
    transform: "translate(-2.976 -3.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81083",
    "data-name": "Path 81083",
    className: "cls-31",
    d: "M35.618,40.181l-.682.389v-.782Z",
    transform: "translate(-2.976 -3.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81084",
    "data-name": "Path 81084",
    className: "cls-4",
    d: "M89.232,42.95c-.613.439-1.253.823-1.894,1.208l-.073-.082-.082-.091a22.592,22.592,0,0,1,2.049-1.034",
    transform: "translate(-7.426 -3.658)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmuNew);
export default __webpack_public_path__ + "static/media/DMUNew.0868c7b208d7094f17845ba75c0f7d3d.svg";
export { ForwardRef as ReactComponent };